import React, {useCallback, useEffect, useMemo, useState} from "react";
import {
    Box,
    Typography,
    Button,
    TextField,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Alert,
    Chip,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    ListItemButton,
    CardContent,
    Popper, CardHeader, DialogContentText
} from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListAltIcon from '@mui/icons-material/ListAlt'; // or try ArticleIcon / HistoryIcon / ReceiptLongIcon
import { PDFDocument, rgb } from 'pdf-lib';
import SignatureCanvas from 'react-signature-canvas';
import { getCurrentUser } from 'aws-amplify/auth';

import Collapse from "@mui/material/Collapse";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Grid from "@mui/material/Grid";
import CheckCircleIcon            from '@mui/icons-material/CheckCircle';
import RadioButtonCheckedIcon     from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon   from '@mui/icons-material/RadioButtonUnchecked';
import ArrowForwardIosIcon        from '@mui/icons-material/ArrowForwardIos';
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from "@mui/icons-material/Close";
import TableSortLabel from "@mui/material/TableSortLabel";
import IconButton from "@mui/material/IconButton";
import { alpha } from '@mui/material/styles';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';

import {
  Document,
  Packer,
  Paragraph,
  Table as DocxTable,
  TableRow as DocxTableRow,
  TableCell as DocxTableCell,
  HeadingLevel,
  TextRun,
  WidthType,
  Media,
  ImageRun,
  ExternalHyperlink, SectionType,
  AlignmentType,

} from "docx";
// Import your MUI controller hook
import { useMaterialUIController } from "../../context";
import AsyncSearch from "../../components/AsyncSearch";
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';
import Snackbar from "@mui/material/Snackbar";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useTheme } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { MaterialReactTable } from "material-react-table";
import {Tooltip} from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import FormControlLabel from "@mui/material/FormControlLabel";
import useMediaQuery from "@mui/material/useMediaQuery";
import Autocomplete from "@mui/material/Autocomplete";
import Card from "@mui/material/Card";
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import CallSplitIcon  from '@mui/icons-material/CallSplit';
import CallMergeIcon  from '@mui/icons-material/CallMerge';
import Divider from "@mui/material/Divider";
import {Stack} from "@mui/system";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import goHunt from '../../assets/images/goHunt.png';
import {ClickAwayListener} from "@mui/base";
const rowBg = (theme, row) => {
  const isParent   = row.depth === 0;
  const isExpanded = row.getIsExpanded();
  const base       = isParent ? theme.palette.primary.main : theme.palette.primary.main;

  // stronger in dark mode so it’s obvious
  const aBase = theme.palette.mode === 'dark'
      ? (0.22)
      :( 0.10);
  const aExp  = theme.palette.mode === 'dark' ? 0.30 : 0.12;

  return isParent && isExpanded ? alpha(base, aBase) : alpha(base, aExp);
};



const STATUS_OPTIONS = [
    { value: "ראשוני", label: "ראשוני" },
    { value: "איסוף נתונים", label: "איסוף נתונים" },
    { value: "טיפול תפעול", label: "טיפול תפעול" },
    { value: "ממתין לטיפול משפטי", label: "ממתין לטיפול משפטי" },
    { value: "נגבה", label: "נגבה" },
    { value: 'הנה"ח', label: 'הנה"ח' },
];

const SUB_STATUS = {
  'ראשוני': [
    'לטיפול מיידי',
    'לטיפול בהמשך',
    'מוקפא',
    'לא רלוונטי',
  ],
  'איסוף נתונים': [
    'בוצע GO HUNT',
    'ממתין לסרטון',
    'ממתין למכתב עו"ד ודו"ח עסקה',
  ],
    'טיפול תפעול': [
        'ממתין לאיתור',
        'אותר',
        'נשלח מכתב בוואטספ',
        'שיחת גביה',
        'ממתין לפולואו אפ',
        'נגבה'
    ],
  'ממתין לטיפול משפטי': [
      'התקבל חומר',
      'טיפול עו"ד טרם הגשת תביעה',
      'הגשת כתב תביעה',
      'בתהליך בבית משפט',
      'תיק נסגר בביהמ"ש',
      ]
  ,
    'נגבה': [
        'נגבה ע"י מערך גביה',
        'נגבה ע"י טיפול משפטי',
    ],
    'הנה"ח': [
        'ממתין להנה"ח',
        'נסגר ע\'י הנה"ח'
]
};

async function suggestUsers(q) {
    const resp = await fetch(`https://blue-parking-invite.bluept.dev/api/users/suggest?q=${encodeURIComponent(q)}`);
    if (!resp.ok) return [];
    return await resp.json(); // expected: [{email, username, name, ...}]
}


const DEPARTMENTS = ['תפעול','משפטי','חוקר','הנה"ח'];
const SUB_DEPTS_BY_DEPT = {
    'תפעול': ['מנהל','אדמינסטרציה','מערך גביה'],
    'משפטי': ['בארי רז','בקר את מנסור'],
    'חוקר':  ['עמית לוגסי','אחר'],
    'הנה"ח': ["מירי", "סנדרה"],  // none for now
};
const ALL_SUB_DEPTS = Array.from(new Set(Object.values(SUB_DEPTS_BY_DEPT).flat()));
function NoteItem({ note }) {
  // prefer the ms from server; fallback to created_at
  const ms = note.created_at_ms ?? Date.parse(note.created_at_utc ?? note.created_at);

  const ts = new Date(ms).toLocaleString('he-IL', {
    timeZone: 'Asia/Jerusalem',
    hour12: false,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });

  return (
      <Paper variant="outlined" sx={{ p: 1, borderRadius: 1.5 }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5, flexWrap: 'wrap' }}>
          <Typography variant="caption" sx={{ fontWeight: 600 }}>{note.author_name || note.author_email}</Typography>
          <Typography variant="caption" sx={{ opacity: 0.7 }}>· {ts}</Typography>
        </Stack>

        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
          {note.body}
        </Typography>
      </Paper>
  );
}


// 1️⃣ Define your columns
function patchAfterSplit(setRows, { movedEvent, newCase, oldCase }) {
  setRows(prev => {
    // make a shallow copy; if you're not using immer, avoid mutating prev directly
    const next = prev.map(p => ({ ...p, subRows: Array.isArray(p.subRows) ? [...p.subRows] : p.subRows }));

    // 1) find the old case (the one that currently contains the moved event)
    const oldParentIdx = next.findIndex(
        r => Array.isArray(r.subRows) && r.subRows.some(ev => ev.id === movedEvent.id)
    );

    if (oldParentIdx !== -1) {
      // remove the moved event from old parent's subRows
      const childIdx = next[oldParentIdx].subRows.findIndex(ev => ev.id === movedEvent.id);
      if (childIdx !== -1) next[oldParentIdx].subRows.splice(childIdx, 1);

      // update old parent metadata from response (status/updated_at, counts if you keep them)
      if (oldCase) {
        next[oldParentIdx] = {
          ...next[oldParentIdx],
          main_status: oldCase.main_status ?? next[oldParentIdx].main_status,
          updated_at: oldCase.updated_at ?? next[oldParentIdx].updated_at,
          // if you track counters:
          events: Array.isArray(next[oldParentIdx].subRows) ? next[oldParentIdx].subRows.length : next[oldParentIdx].events,
        };
      }
    }

    // 2) insert the new parent row for the new case with the moved event inside
    const newParentRow = {
      ...newCase,
      // whatever flags your grid uses for parent rows:
      isParent: true,
      // the moved event now belongs to the new case
      subRows: [{ ...movedEvent }],
    };

    // add to the top (or use your current sort)
    return [newParentRow, ...next];
  });
}



const formatCurrency = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString('he-IL', {
    style: 'currency',
    currency: 'ILS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};
const getEventTypeColor = (type,darkMode, defaultColor) => {
  switch (type) {
    case 'ברחן':  return 'blue';
    case 'נזק':   return 'orange';
    case 'תאונה': return 'red';
    default:      return defaultColor;
  }
};

const HANDLING_LAWYERS = [
  "בארי",
  "בקר",
  "שירות"
];
const ALL_STATUS_STEPS = [
  'ראשוני',
  'איסוף נתונים',
  'טיפול תפעול',
  'ממתין לטיפול משפטי',
  'נגבה',
'הנה"ח'
];

const ALL_SUB_STATUSES = Array.from(new Set(Object.values(SUB_STATUS).flat()));


const num = (v) => (v == null || v === '' || isNaN(v)) ? 0 : Number(v);
const ils = (v) => `₪${(num(v)).toLocaleString('he-IL', { maximumFractionDigits: 2 })}`;
const fmtDT = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2,"0");
  const mm = String(d.getMonth()+1).padStart(2,"0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2,"0");
  const mi = String(d.getMinutes()).padStart(2,"0");
  const ss = String(d.getSeconds()).padStart(2,"0");
  return `${dd}/${mm}/${yyyy} ${hh}:${mi}:${ss}`;
};

function SubStatusTracker({ mainStatus, currentSubStatus, textColor }) {
  const theme = useTheme();
  const steps = SUB_STATUS[mainStatus] || [];
  const activeIdx = steps.indexOf(currentSubStatus);

  return (
      <Box sx={{ p: 1 }}>
        <Typography variant="subtitle2" sx={{ mb: 0.5, color: textColor }}>
          התקדמות בתת-סטטוס
        </Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', rowGap: 0.5, columnGap: 1 }}>
          {steps.map((label, idx) => (
              <React.Fragment key={label}>
                <Box
                    sx={{
                      width: 8, height: 8, borderRadius: '50%',
                      bgcolor:
                          idx < activeIdx
                              ? theme.palette.success.main
                              : idx === activeIdx
                                  ? theme.palette.primary.main
                                  : theme.palette.grey[500],
                      mt: 0.5
                    }}
                />
                <Typography variant="caption" sx={{ color: textColor }}>{label}</Typography>
              </React.Fragment>
          ))}
        </Box>
      </Box>
  );
}

// // StatusTracker.jsx
// import * as React from 'react';
// import { Box, Tooltip, Typography, useTheme } from '@mui/material';

// Assumes these exist in your file/scope:
// - const ALL_STATUS_STEPS = [...];
// - const SUB_STATUS = { [mainStatus]: [sub1, sub2, ...] };
// - SubStatusTracker({ mainStatus, currentSubStatus, textColor })

export function StatusTracker({
                                          currentStatus,
                                          currentSubStatus,
                                          textColor,
                                          layout = 'grid', // 'inline' | 'grid'
                                      }) {
    const theme = useTheme();
    const steps = ALL_STATUS_STEPS;
    const activeIdx = Math.max(0, steps.indexOf(currentStatus));
    const isGrid = layout === 'grid';

    // derive which main statuses have sub-statuses from your SUB_STATUS map
    const MAIN_WITH_SUB = React.useMemo(() => new Set(Object.keys(SUB_STATUS || {})), []);

    const colors = {
        done: theme.palette.success.main,
        active: theme.palette.primary.main,
        todo: theme.palette.divider,
        text: textColor || theme.palette.text.primary,
    };

    const StepDot = ({ state }) => (
        <Box
            sx={{
                width: 14,
                height: 14,
                borderRadius: '50%',
                border: `2px solid ${theme.palette.divider}`,
                bgcolor: state === 'done' ? colors.done : state === 'active' ? colors.active : 'transparent',
            }}
        />
    );

    const StepLine = ({ state }) => (
        <Box
            sx={{
                flex: 1,
                height: 2,
                bgcolor: state === 'done' ? colors.done : state === 'active' ? colors.active : colors.todo,
            }}
        />
    );

    const StepCell = ({ label, idx }) => {
        const state = idx < activeIdx ? 'done' : idx === activeIdx ? 'active' : 'todo';
        const isActive = idx === activeIdx;
        const hasSubs = MAIN_WITH_SUB.has(label);
        // show hover ONLY for the current main status and only if it has sub-statuses
        const showSubHover = isActive && hasSubs;

        const content = (
            <Box
                sx={{
                    display: isGrid ? 'grid' : 'flex',
                    gridTemplateColumns: isGrid ? 'auto 1fr' : undefined,
                    alignItems: 'center',
                    gap: 1,
                    cursor: showSubHover ? 'pointer' : 'default',
                    minWidth: 0,
                }}
            >
                <StepDot state={state} />
                {!isGrid && idx > 0 && (
                    <Box sx={{ mx: 1, minWidth: 24 }}>
                        <StepLine state={idx <= activeIdx ? 'done' : 'todo'} />
                    </Box>
                )}
                <Typography
                    variant="body2"
                    sx={{
                        color: colors.text,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontWeight: state === 'active' ? 600 : 400,
                    }}
                    title={label}
                >
                    {label}
                </Typography>
            </Box>
        );

        return showSubHover ? (
            <Tooltip
                key={label}
                arrow
                enterDelay={200}
                title={
                    <SubStatusTracker
                        mainStatus={label}
                        currentSubStatus={currentStatus === label ? currentSubStatus : null}
                        textColor={textColor}
                    />
                }
            >
                <Box>{content}</Box>
            </Tooltip>
        ) : (
            <Box key={label}>{content}</Box>
        );
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: isGrid ? 'column' : 'row',
                alignItems: isGrid ? 'stretch' : 'center',
                gap: isGrid ? 1 : 2,
                width: '100%',
            }}
        >
            {steps.map((label, idx) => (
                <StepCell key={label} label={label} idx={idx} />
            ))}
        </Box>
    );
}




export const makeVideoThumb = (file, max = 200) =>
    new Promise((resolve) => {
      const video = document.createElement("video");
      video.src = URL.createObjectURL(file);
      video.preload = "metadata";
      video.muted = true;                 // iOS/Safari needs this
      video.playsInline = true;

      // Grab something ≈1 s in – avoids black first frame
      video.onloadeddata = () => {
        video.currentTime = Math.min(1, video.duration / 2);
      };

      video.onseeked = () => {
        const cvs = document.createElement("canvas");
        const scale = Math.min(max / video.videoWidth, max / video.videoHeight);
        cvs.width  = Math.round(video.videoWidth  * scale);
        cvs.height = Math.round(video.videoHeight * scale);
        cvs.getContext("2d").drawImage(video, 0, 0, cvs.width, cvs.height);

        cvs.toBlob((blob) => {
          resolve(
              new File(
                  [blob],
                  `thumb-${file.name.replace(/\.[^.]+$/, ".jpg")}`,
                  { type: "image/jpeg" }
              )
          );
        }, "image/jpeg", 0.8);
      };
    });

const guessIcon = (mime) => {
  if (mime.includes("spreadsheet"))           return "xlsx";
  if (mime === "application/pdf")             return "pdf";
  if (mime.includes("zip"))                   return "zip";
  return "generic"; // fallback
};



function convertToMySQLDatetime(datetimeStr) {
  if (!datetimeStr) return null;
  // Split the string at the "T" character
  const parts = datetimeStr.split("T");
  if (parts.length !== 2) return datetimeStr; // Return original if unexpected format

  let datePart = parts[0];
  let timePart = parts[1];

  // If timePart does not include seconds (i.e. only one colon is present), add ":00"
  if ((timePart.match(/:/g) || []).length === 1) {
    timePart = `${timePart}:00`;
  }
  // console.log(`${datePart} ${timePart}`);
  return `${datePart} ${timePart}`;
}

const formatDuration = (seconds) => {
  const secNum = parseInt(seconds, 10);
  const hours = Math.floor(secNum / 3600);
  const minutes = Math.floor((secNum % 3600) / 60);
  const secs = secNum % 60;
  // Pad with zeros if needed.
  const pad = (num) => (num < 10 ? "0" + num : num);
  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
};

const formatTimestamp = (isoString) => {
  if (!isoString) return "";
  const dateObj = new Date(isoString);
  // Using the timeZone "Europe/Athens" for GMT+2.
  // Adjust locale or timeZone if needed.
  const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Athens" };
  const optionsTime = { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false, timeZone: "Europe/Athens" };
  const formattedDate = dateObj.toLocaleDateString("en-GB", optionsDate);
  const formattedTime = dateObj.toLocaleTimeString("en-GB", optionsTime);
  return (
      <>
        {formattedDate}
        <br />
        {formattedTime}
      </>
  );
};

const fmtIL = (ms) => new Date(ms).toLocaleString('he-IL', {
  timeZone: 'Asia/Jerusalem',
  hour12: false,
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit',
});

const makeImageThumb = (file, max = 200) => new Promise((resolve) => {
  const img = new Image();
  img.src = URL.createObjectURL(file);
  img.onload = () => {
    const scale = Math.min(max / img.width, max / img.height);
    const cvs   = document.createElement("canvas");
    cvs.width   = Math.round(img.width  * scale);
    cvs.height  = Math.round(img.height * scale);
    cvs.getContext("2d").drawImage(img, 0, 0, cvs.width, cvs.height);
    cvs.toBlob((blob) => {
      resolve(new File([blob], `thumb-${file.name.replace(/\.[^.]+$/, '.jpg')}`, {
        type: "image/jpeg"
      }));
    }, "image/jpeg", 0.8);
  };
});


async function processAttachment(file) {
  const isTS = file.type === "video/vnd.dlna.mpeg-tts"
      || /\.ts$/i.test(file.name)

  if (file.type.startsWith("image/")) {
    const thumb = await makeImageThumb(file, 200);
    return { original: file, thumbnail: thumb };
  }

  // only thumbnail “real” videos browsers support
  if (!isTS && file.type.startsWith("video/")) {
    const thumb = await makeVideoThumb(file, 200);
    return { original: file, thumbnail: thumb };
  }

  // fallback for TS or any other unknown type
  return { original: file, icon: guessIcon(file.type) };
}

const getImageSrc = (att) => {
  if (att.thumbUrl) return att.thumbUrl;
  if (att.type.startsWith("image/")) {
    // fallback: add a resize query param (if CDN/S3 signed URLs support it)
    return `${att.url}?w=50&h=50&fit=crop`;
  }
  return att.url;
};
const eventTypeOptions = ['ברחן','תאונה','נזק','אחר'];

const uploadFilesWithThumbs = async (files) => {
    if (!files.length) return [];

    // Flat list of every File we need to send up (orig + thumb if exists)
    const allFiles = files.flatMap(att => att.thumbFile ? [att.file, att.thumbFile] : [att.file]);
    const fileRequests = allFiles.map(f => ({ fileName: f.name, fileType: f.type }));

    const presResp = await fetch("https://blue-parking-invite.bluept.dev/api/get-presigned-urls", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ files: fileRequests })
    });
    const { presignedUrls } = await presResp.json();

    const uploadedMeta = [];

    for (let i = 0; i < allFiles.length; i++) {
        const file   = allFiles[i];
        const target = presignedUrls[i];
        const data   = new FormData();
        Object.entries(target.fields).forEach(([k,v]) => data.append(k,v));
        data.append("file", file);

        await fetch(target.url, { method: "POST", body: data });
        uploadedMeta.push({
            name: file.name,
            type: file.type,
            url:  `${target.url}${target.fields.key}`
        });
    }

    // Re‑group by original attachment so we can provide {url, thumbUrl}
    const result = files.map(att => {
        const origIdx  = uploadedMeta.findIndex(m => m.name === att.file.name);
        const thumbIdx = att.thumbFile ? uploadedMeta.findIndex(m => m.name === att.thumbFile.name) : -1;
        return {
            fileName: att.file.name,
            type:     att.file.type,
            url:      uploadedMeta[origIdx].url,
            thumbUrl: thumbIdx >= 0 ? uploadedMeta[thumbIdx].url : null,
            iconName: att.iconName ?? null
        };
    });
    return result;
};


export function BulkEditCasesDialog({
                                        open,
                                        onClose,
                                        selectedCases,
                                        onSave,
                                        darkMode,
                                        STATUS_OPTIONS,
                                        SUB_STATUS_BY_MAIN,
                                        DEPARTMENTS,
                                        SUB_DEPARTMENTS,
                                        userEmail
                                    }) {
    const [form, setForm] = React.useState({
        legal_fees: "",
        locating_fees: "",
        handling_fees: "",
        principal_amount: "",
        override_total_amount: "",
        main_status: "",
        sub_status: "",
        department: "",
        sub_department: "",
        internal_handler: "",
        paid: "",
        number_of_payments: "",
        number_of_payments_paid: "",
        call_number: "",
        invoice_number: "",
        pay_condition: "",
        end_date: "", // simple string (dd/mm/yyyy or yyyy-mm-dd)
    });
    const [ihOptions, setIhOptions] = React.useState([]);
    const [ihLoading, setIhLoading] = React.useState(false);
    const [noteBody, setNoteBody] = React.useState("");
    const [files, setFiles] = React.useState([]);
    const [mentions, setMentions] = React.useState([]);   // emails that were tagged
    const [suggest, setSuggest] = React.useState([]);     // users from suggest API
    const [anchorEl, setAnchorEl] = React.useState(null); // textarea element
    const [triggerRange, setTriggerRange] = React.useState(null); // {start,end} of @word
    const [saving, setSaving] = React.useState(false);
    const [discountError, setDiscountError] = React.useState("");
    const textColor = darkMode ? "#ffffff" : "#000000";
    const bgColor = darkMode ? "#121212" : "#ffffff";

    useEffect(() => {
        if (!form.with_discount) {
            setDiscountError("");
            return;
        }

        if (!selectedCases.length) return;

        let minBaseAcrossCases = Infinity;

        for (const c of selectedCases) {
            let handling = form.handling_fees !== "" ? Number(form.handling_fees) : Number(c.handling_fees || 0);
            let locating = form.locating_fees !== "" ? Number(form.locating_fees) : Number(c.locating_fees || 0);
            let legal    = form.legal_fees    !== "" ? Number(form.legal_fees)    : Number(c.legal_fees || 0);

            const base = Number(c.principal_amount || 0) + handling + locating + legal;

            if (!isNaN(base) && base < minBaseAcrossCases) {
                minBaseAcrossCases = base;
            }
        }

        if (!isFinite(minBaseAcrossCases)) {
            setDiscountError("");
            return;
        }

        const maxDiscount = minBaseAcrossCases * 0.35;
        const minDiscount = 1;
        const d = Number(form.payment_discount || 0);

        if (d > maxDiscount) {
            setDiscountError(` הנחה מקסימלית לפי התיקים היא ${formatCurrency(maxDiscount)}`);
        } else if (d < minDiscount) {
            setDiscountError(` הנחה חייבת להיות לפחות ${formatCurrency(minDiscount)}`);
        } else {
            setDiscountError("");
        }

    }, [
        form.with_discount,
        form.payment_discount,
        form.handling_fees,
        form.locating_fees,
        form.legal_fees,
        selectedCases,
    ]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };
    const applyMention = (user) => {
        if (!triggerRange) return;
        const email = user.email || user.username;
        const before = noteBody.slice(0, triggerRange.start);
        const after  = noteBody.slice(triggerRange.end);
        const next   = `${before}${email} ${after}`;
        setNoteBody(next);
        setMentions((prev) => Array.from(new Set([...prev, email])));
        setSuggest([]);
        setTriggerRange(null);
    };
    const onBulkNoteChange = async (e) => {
        const val = e.target.value;
        setNoteBody(val);
        const sel = e.target.selectionStart;

        // find "@word" ending at cursor
        const upto = val.slice(0, sel);
        const match = upto.match(/@([^\s@]{1,40})$/);
        if (match) {
            const q = match[1];
            const resp = await fetch(
                `https://blue-parking-invite.bluept.dev/api/users/suggest?q=${encodeURIComponent(q)}`
            );
            const users = await resp.json();
            setSuggest(users);
            setAnchorEl(e.target);
            setTriggerRange({ start: sel - q.length - 1, end: sel }); // include @
        } else {
            setSuggest([]);
            setTriggerRange(null);
        }
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setForm((prev) => ({ ...prev, [name]: checked }));
    };

    const handleFilesChange = async (e) => {
        const list = Array.from(e.target.files || []);
        if (!list.length) {
            setFiles([]);
            return;
        }

        // use your existing helper
        const packed = await Promise.all(list.map(processAttachment));

        // normalize to what uploadFilesWithThumbs expects
        const normalized = packed.map(att => ({
            file: att.original,               // from processAttachment
            thumbFile: att.thumbnail || null, // may be undefined
            iconName: att.icon || null,
        }));

        setFiles(normalized);
    };
    const handleInternalHandlerInput = async (_, q) => {
        if (!q || !q.trim()) {
            setIhOptions([]);
            return;
        }
        setIhLoading(true);
        try {
            const users = await suggestUsers(q);
            setIhOptions(users || []);
        } finally {
            setIhLoading(false);
        }
    };
    const handleClose = () => {
        if (saving) return;
        setForm({
            legal_fees: "",
            locating_fees: "",
            handling_fees: "",
            principal_amount: "",
            // with_discount: false,
            // override_total_enabled: false,
            override_total_amount: "",
            main_status: "",
            sub_status: "",
            department: "",
            sub_department: "",
            internal_handler: "",
            paid: "",
            number_of_payments: "",
            number_of_payments_paid: "",
            call_number: "",
            invoice_number: "",
            pay_condition: "",
            end_date: "",
        });
        setNoteBody("");
        setFiles([]);
        onClose();
    };

    const handleSave = async () => {
        if (!selectedCases?.length) return;

        // build "patch" with ONLY fields that have a value (empty string = ignore)
        const patch = {};
        const addIfNotEmptyNumber = (key) => {
            const v = form[key];
            if (v !== "" && v !== null && v !== undefined) {
                patch[key] = Number(v);
            }
        };
        const addIfNotEmpty = (key) => {
            const v = form[key];
            if (v !== "" && v !== null && v !== undefined) {
                patch[key] = v;
            }
        };

        addIfNotEmptyNumber("legal_fees");
        addIfNotEmptyNumber("locating_fees");
        addIfNotEmptyNumber("handling_fees");
        addIfNotEmptyNumber("principal_amount");
        addIfNotEmptyNumber("override_total_amount");
        addIfNotEmptyNumber("payment_discount");
        addIfNotEmptyNumber("paid");
        addIfNotEmptyNumber("number_of_payments");
        addIfNotEmptyNumber("number_of_payments_paid");

        if (form.with_discount === true || form.with_discount === false) {
            patch.with_discount = form.with_discount ? 1 : 0;
        }

        // booleans
        if (form.override_total_enabled === true || form.override_total_enabled === false) {
            // only send if user actually toggled it (you can add a separate tri-state if you want)
            patch.override_total_enabled = form.override_total_enabled ? 1 : 0;
        }

        // strings
        addIfNotEmpty("main_status");
        addIfNotEmpty("sub_status");
        addIfNotEmpty("department");
        addIfNotEmpty("sub_department");
        addIfNotEmpty("internal_handler");
        addIfNotEmpty("call_number");
        addIfNotEmpty("invoice_number");
        addIfNotEmpty("pay_condition");

        // date: you can normalize to YYYY-MM-DD on backend too
        if (form.end_date) {
            patch.end_date = form.end_date; // e.g. "2025-12-31"
        }

        const caseIds = selectedCases.map((c) => c.case_id);

        try {
            setSaving(true);
            await onSave({
                caseIds,
                patch,
                userEmail,
                noteBody: noteBody.trim() || "",
                mentions,          // ← new
                files,
            });
            setSaving(false);
            handleClose();
        } catch (err) {
            console.error(err);
            setSaving(false);
            // optional: show toast
        }
    };

    const selectedCount = selectedCases?.length || 0;

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
            <DialogTitle sx={{ bgcolor: bgColor, color: textColor }}>
                עריכה מרובה ({selectedCount} תיקים)
            </DialogTitle>

            <DialogContent sx={{ bgcolor: bgColor }}>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    {/* LEFT SIDE – case fields */}
                    <Grid item xs={12} md={7}>
                        <Grid container spacing={2}>
                            {/* column 1 */}
                            <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <TextField
                                    label="דמי טיפול"
                                    name="handling_fees"
                                    type="number"
                                    value={form.handling_fees}
                                    onChange={handleChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor } }}
                                />
                                <TextField
                                    label="דמי איתור"
                                    name="locating_fees"
                                    type="number"
                                    value={form.locating_fees}
                                    onChange={handleChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor } }}
                                />
                                <TextField
                                    label="דמי משפטי"
                                    name="legal_fees"
                                    type="number"
                                    value={form.legal_fees}
                                    onChange={handleChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor } }}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="with_discount"
                                            checked={Boolean(form.with_discount)}
                                            onChange={handleCheckboxChange }
                                            sx={{ color: textColor }}
                                        />
                                    }
                                    label="הנחה"
                                />

                                {Boolean(form.with_discount) && (
                                    <TextField
                                        label="סכום הנחה"
                                        name="payment_discount"
                                        type="number"
                                        value={form.payment_discount ?? ""}
                                        onChange={handleChange}
                                        fullWidth
                                        error={Boolean(discountError)}
                                        helperText={discountError}
                                        // InputLabelProps={{ style: { color: textColor } }}
                                        // InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                    />
                                )}
                                {/*<TextField*/}
                                {/*    label="סכום קרן"*/}
                                {/*    name="principal_amount"*/}
                                {/*    type="number"*/}
                                {/*    value={form.principal_amount}*/}
                                {/*    onChange={handleChange}*/}
                                {/*    fullWidth*/}
                                {/*    InputLabelProps={{ style: { color: textColor } }}*/}
                                {/*    InputProps={{ sx: { color: textColor } }}*/}
                                {/*/>*/}
                            </Grid>

                            {/* column 2 */}
                            <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={form.override_total_enabled}
                                            onChange={handleCheckboxChange}
                                            name="override_total_enabled"
                                        />
                                    }
                                    label="שינוי מחיר כולל"
                                    sx={{ color: textColor, mt: 1 }}
                                />

                                <TextField
                                    label="סכום כולל (חדש)"
                                    name="override_total_amount"
                                    type="number"
                                    value={form.override_total_amount}
                                    onChange={handleChange}
                                    fullWidth
                                    disabled={!form.override_total_enabled}
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor } }}
                                />

                                <TextField
                                    label="שולם עד כה"
                                    name="paid"
                                    type="number"
                                    value={form.paid}
                                    onChange={handleChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor } }}
                                />

                                <TextField
                                    label="כמות תשלומים"
                                    name="number_of_payments"
                                    type="number"
                                    value={form.number_of_payments}
                                    onChange={handleChange}
                                    fullWidth
                                    helperText="1–18"
                                    FormHelperTextProps={{ sx: { color: textColor } }}
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor } }}
                                />

                            </Grid>

                            {/* column 3 */}
                            <Grid item xs={12} sm={12} md={4} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>סטטוס</InputLabel>
                                    <Select
                                        label="סטטוס"
                                        name="main_status"
                                        value={form.main_status}
                                        onChange={(e) =>
                                            setForm((prev) => ({
                                                ...prev,
                                                main_status: e.target.value,
                                                sub_status: "",
                                            }))
                                        }
                                        sx={{height:44, color: textColor }}
                                    >
                                        {(STATUS_OPTIONS || []).map((s) => (
                                            <MenuItem key={s} value={s}>
                                                {s}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl fullWidth size="small" disabled={!form.main_status}>
                                    <InputLabel>תת סטטוס</InputLabel>
                                    <Select
                                        label="תת סטטוס"
                                        name="sub_status"
                                        value={form.sub_status}
                                        onChange={handleChange}
                                        sx={{height:44, color: textColor }}
                                    >
                                        {(SUB_STATUS_BY_MAIN?.[form.main_status] || []).map((s) => (
                                            <MenuItem key={s} value={s}>
                                                {s}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl fullWidth size="small">
                                    <InputLabel>מחלקה</InputLabel>
                                    <Select
                                        label="מחלקה"
                                        name="department"
                                        value={form.department}
                                        onChange={(e) =>
                                            setForm((prev) => ({
                                                ...prev,
                                                department: e.target.value,
                                                sub_department: "",
                                                internal_handler: "",
                                            }))
                                        }
                                        sx={{ height:44,color: textColor }}
                                    >
                                        {(DEPARTMENTS || []).map((d) => (
                                            <MenuItem key={d} value={d}>
                                                {d}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl fullWidth size="small" disabled={!form.department}>
                                    <InputLabel>תת מחלקה</InputLabel>
                                    <Select
                                        label="תת מחלקה"
                                        name="sub_department"
                                        value={form.sub_department}
                                        onChange={handleChange}
                                        sx={{height:44, color: textColor }}
                                    >
                                        {(SUB_DEPARTMENTS?.[form.department] || []).map((d) => (
                                            <MenuItem key={d} value={d}>
                                                {d}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    options={ihOptions}
                                    loading={ihLoading}
                                    value={form.internal_handler || ""}
                                    onInputChange={handleInternalHandlerInput}
                                    onChange={(_, userOrString) => {
                                        const val =
                                            typeof userOrString === "string"
                                                ? userOrString
                                                : (userOrString?.email || userOrString?.username || userOrString?.name || "");
                                        setForm(prev => ({ ...prev, internal_handler: val }));
                                    }}
                                    getOptionLabel={(u) =>
                                        typeof u === "string"
                                            ? u
                                            : (u?.name || u?.email || u?.username || "")
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="בטיפול של"
                                            placeholder="חפש משתמש לפי מייל/שם"
                                            sx={{height:44, color: textColor }}
                                            InputLabelProps={{ style: { color: textColor } }}
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: { color: textColor },
                                                endAdornment: (
                                                    <>
                                                        {ihLoading ? <CircularProgress size={16} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />

                                {/*<TextField*/}
                                {/*    label="תנאי תשלום"*/}
                                {/*    name="pay_condition"*/}
                                {/*    value={form.pay_condition}*/}
                                {/*    onChange={handleChange}*/}
                                {/*    fullWidth*/}
                                {/*    InputLabelProps={{ style: { color: textColor } }}*/}
                                {/*    InputProps={{ sx: { color: textColor } }}*/}
                                {/*/>*/}

                                <TextField
                                    label="תאריך סגירה"
                                    name="end_date"
                                    type={"date"}
                                    placeholder="yyyy-mm-dd"
                                    value={form.end_date}
                                    onChange={handleChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor } }}
                                />

                                <TextField
                                    label="מספר קריאה"
                                    name="call_number"
                                    value={form.call_number}
                                    onChange={handleChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor } }}
                                />

                                <TextField
                                    label="מספר חשבונית"
                                    name="invoice_number"
                                    value={form.invoice_number}
                                    onChange={handleChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor } }}
                                />
                            </Grid>
                        </Grid>

                        {/* attachments */}
                        <Box sx={{ mt: 3 }}>
                            <Typography variant="subtitle1" sx={{ color: textColor, mb: 1 }}>
                                קבצים להוספה לכל התיקים
                            </Typography>
                            <input
                                type="file"
                                multiple
                                onChange={handleFilesChange}
                                style={{ color: textColor }}
                            />
                            {files.length > 0 && (
                                <Typography variant="caption" sx={{ color: textColor }}>
                                    {files?.length} קבצים נבחרו
                                </Typography>
                            )}
                        </Box>
                    </Grid>

                    {/* RIGHT SIDE – notes */}
                    <Grid item xs={12} md={5}>
                        <Typography variant="subtitle1" sx={{ color: textColor, mb: 1 }}>
                            הערה שתתווסף לכל התיקים הנבחרים
                        </Typography>
                        <TextField
                            label="כתוב הערה, ניתן לתייג מישהו בעזרת @"
                            value={noteBody}
                            onChange={onBulkNoteChange}
                            fullWidth
                            multiline
                            minRows={8}
                            sx={{ '& .MuiInputBase-root': { alignItems: 'flex-start' } }}
                            inputProps={{
                                dir: "rtl",
                                style: { direction: "rtl", textAlign: "right" },
                            }}
                        />

                        <Popper
                            open={Boolean(suggest.length && anchorEl)}
                            anchorEl={anchorEl}
                            placement="top-start"
                            disablePortal={false}
                            container={document.body}
                            modifiers={[
                                { name: 'offset', options: { offset: [0, 8] } },
                                { name: 'preventOverflow', options: { boundary: 'viewport' } },
                            ]}
                            sx={(theme) => ({
                                zIndex: theme.zIndex.modal + 2,
                                width: anchorEl ? anchorEl.clientWidth : undefined,
                            })}
                        >
                            <Paper elevation={3}>
                                <List dense sx={{ maxHeight: 240, overflowY: 'auto' }}>
                                    {suggest.map((u) => (
                                        <ListItem
                                            key={u.email || u.username}
                                            onMouseDown={(e) => e.preventDefault()} // keep focus in textarea
                                            onClick={() => applyMention(u)}
                                            sx={{ px: 1.5, py: 0.75, cursor: 'pointer' }}
                                        >
                                            <ListItemText
                                                primary={u.email || u.username}
                                                secondary={[u.given_name, u.family_name]
                                                    .filter(Boolean)
                                                    .join(' ')}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Paper>
                        </Popper>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ bgcolor: bgColor }}>
                <Button onClick={handleClose} disabled={saving}>
                    בטל
                </Button>
                <Button  variant="contained" onClick={handleSave} disabled={(Boolean(discountError) && form?.with_discount) || (saving || !selectedCount)}>
                    שמור לכל התיקים
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const GodsBlueEye = () => {
  const [filteredEvents, setFilteredEvents] = useState([]);
    const [rowSelection, setRowSelection] = useState({});
    const [bulkOpen, setBulkOpen] = useState(false);
    const [bulkTargets, setBulkTargets] = useState([]);
    const [allCasesSelected, setAllCasesSelected] = useState(false);

    const resetSelection = useCallback(() => {
        setRowSelection({});
        setBulkTargets([]);
        setAllCasesSelected(false);
    }, []);

    const [filters, setFilters] = useState({
        from: '', to: '', carId: '', place: '',  main_status: [],
        sub_status: [],
        department: [],
        sub_department: [],
        eventType: [], lawyer: '', includeUnassigned: '0'
    });
    const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [internalHandlerFilter, setInternalHandlerFilter] = useState("");
  const [totalCases, setTotalCases] = useState(0);
  const [payOpen, setPayOpen] = useState(false);
  const [paySubmitting, setPaySubmitting] = useState(false);
  const [showFilesModal, setShowFilesModal] = useState(false);
  const [filesModalItems, setFilesModalItems] = useState([]);
  const [activeAttachment, setActiveAttachment] = useState(null);
  const [showSignDialog, setShowSignDialog] = useState(false);
    const [drill, setDrill] = React.useState({ id: null, anchorEl: null });
    const [freezePrompt, setFreezePrompt] = React.useState({
        open: false,
        target: null,     // 'case' | 'event'
        id: null,
        freeze: true,     // true = freeze, false = unfreeze
        row: null,        // the row object (for labels if you want)
    });

    const openDrill = useCallback((e, label, data) => {
        setDrill((d) =>
            d.open && d.anchorEl === e.currentTarget
                ? { open: false, anchorEl: null, label: null, data: null }
                : { open: true, anchorEl: e.currentTarget, label, data }
        );
    }, []);
    const closeDrill = useCallback((ev) => {
        if (!drill.open) return;
        // ignore clicks that originate from the anchor itself
        if (drill.anchorEl && drill.anchorEl.contains(ev?.target)) return;
        setDrill({ open:false, anchorEl:null, label:null, data:null });
    }, [drill]);
  const [pdfToSign, setPdfToSign] = useState(null); // { url, fileName }
  const sigPadRef = React.useRef(null);
  const [signing, setSigning] = useState(false);
  const [preivewCaseId, setPreivewCaseId] = useState(null);
// This will store the signed PDF blob URL (preview) after we generate it
  const [signedPreviewUrl, setSignedPreviewUrl] = useState("");
  const [signedBlob, setSignedBlob] = useState(null);
  const [loadingReport,setLoadingReport] = useState({});
    const [openHuntDialog, setOpenHuntDialog] = useState(false);
    const [huntTarget, setHuntTarget] = useState(null); // will store row.origina
// open dialog for a specific PDF
  function openSignDialog(att) {
    setPdfToSign(att); // att is the attachment object: {url, fileName,...}
    setSignedPreviewUrl("");
    setSignedBlob(null);
    setShowSignDialog(true);
  }

  function closeSignDialog() {
    setShowSignDialog(false);
  }
  const openFilesModal = (attachments, cid) => {
    setFilesModalItems(attachments);
    setPreivewCaseId(cid);
    setActiveAttachment(attachments[0] ?? null);
    setShowFilesModal(true);
  };

    const handleOpenBulk = (table) => {
        const selectedCases = table
            .getSelectedRowModel()
            .flatRows
            .filter(r => r.depth === 0)     // ✅ רק תיקים
            .map(r => r.original);

        setBulkTargets(selectedCases);
        setBulkOpen(true);
    };

    const applyBulkPatch = (list, caseIds, patch, newAttachments = []) => {
        const idSet = new Set(caseIds);

        return list.map(c => {
            if (!idSet.has(c.case_id)) return c;

            // למקרה שאתה מראה קבצים בטבלה – למזג גם אותם
            const mergedAttPreview = [
                ...(c.attachments ?? []),
                ...newAttachments,
            ];



            return {
                ...c,
                ...patch,                      // 👈 כל השדות שעידכנת בבאלק
                attachments_preview: mergedAttPreview,
                attachments: mergedAttPreview,
            };
        });
    };


    const handleBulkSave = async ({          caseIds, patch, userEmail, noteBody, mentions, files, }) => {
        // 1. call your bulk-update API (you can adapt the route we wrote earlier)
        // 2. send `caseIds`, `patch`, and maybe upload files / note
        // 3. merge results back into casesMaster / filteredEvents
        let uploadedAttachments = [];

        // 1) אם יש קבצים – מעלים אותם ל-S3 כמו בעריכת תיק רגילה
        if (files && files.length) {
            // אם אתה כבר משתמש ב-processAttachment במקום אחר, אפשר לעטוף אותם שם.
            // כאן נניח ש-files הם כבר אובייקטים בפורמט של uploadFilesWithThumbs,
            // או ש-uploadFilesWithThumbs יודע לטפל ב-File[].
            uploadedAttachments = await uploadFilesWithThumbs(files);
            // uploadedAttachments = [{ url, thumbUrl, fileName, type, size }, ...]
        }

        const res = await fetch("https://blue-parking-invite.bluept.dev/api/cases/bulk-update", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({  caseIds, patch, userEmail, noteBody, mentions,  attachments: uploadedAttachments, }), // handle files with FormData in a separate call if needed
        });
        const data = await res.json();
        if (!res.ok || data.error) {
            alert('שגיאה בעדדכון תיקים');
            return;
        }

        setCasesMaster(prev =>
            applyBulkPatch(prev, caseIds, patch, uploadedAttachments),
        );

        setFilteredEvents(prev =>
            applyBulkPatch(prev, caseIds, patch, uploadedAttachments),
        );

        resetSelection();
        // reload or optimistically update state here...
    };

  function officeViewerSrc(url) {
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
  }
  function googleViewerSrc(url) {
    return `https://docs.google.com/gview?embedded=1&url=${encodeURIComponent(url)}`;
  }
  function formatBytes(n) {
    if (!Number.isFinite(n)) return '';
    const units = ['B','KB','MB','GB','TB'];
    const i = Math.floor(Math.log(n)/Math.log(1024));
    return `${(n/Math.pow(1024,i)).toFixed(1)} ${units[i]}`;
  }

  async function generateReport(caseId) {
    setLoadingReport((prev => ({ ...prev, [caseId]: true })));
    const resp = await fetch(
        `https://blue-parking-invite.bluept.dev/api/cases/${caseId}/generate-legal-report`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            handledByEmail: userEmail, // you already have this in state
          }),
        }
    );

    if (!resp.ok) {
      const t = await resp.text();
      console.error("Report failed", t);
      alert("שגיאה בהפקת הדוח");
      return;
    }

    const res = await resp.json();

    const { currentAttachments } = res;

    // Update state immutably
    setCasesMaster((prevCases) =>
        prevCases.map((c) =>
            c.case_id === caseId
                ? {
                  ...c,
                  attachments: currentAttachments, // new array from server
                }
                : c
        )
    );

    // Also update filteredEvents if you're showing the table from filteredEvents,
    // not directly from casesMaster:
    setFilteredEvents((prevCases) =>
        prevCases.map((c) =>
            c.case_id === caseId
                ? {
                  ...c,
                  attachments: currentAttachments,
                }
                : c
        )
    );
    setLoadingReport((prev => ({ ...prev, [caseId]: false })));

    // optional toast
    alert("הדוח נוצר ונשמר בתיק ✅");
    // optional: refresh case data so new attachment appears in the attachments modal
    // await refetchCase(caseForm.id)
  }

  function RenderAttachmentInline({ att }) {
    if (!att) return null;
    const { url, type = '', fileName = 'file', size } = att;
    const mime = type.toLowerCase();

    // images
    if (mime.startsWith('image/')) {
      return <img src={url} alt={fileName} style={{ maxWidth: '100%', maxHeight: 520, objectFit: 'contain' }} />;
    }

    // video
    if (mime.startsWith('video/')) {
      return <video src={url} controls style={{ width: '100%', maxHeight: 520 }} />;
    }

    // pdf
    if (mime === 'application/pdf' || /\.pdf$/i.test(fileName)) {
      return    (  <Box>
            <iframe
                title={fileName}
                src={url}
                style={{ width: '100%', height: 520, border: 0 }}
            />
            <Box sx={{ textAlign: 'center', mt: 1 }}>
              <Button
                  variant="contained"
                  onClick={() => openSignDialog(att)}
              >
                חתום על המסמך הזה
              </Button>
            </Box>
          </Box>
      );
    }

    // office docs (xlsx/docx/pptx)
    const isOffice =
        mime.includes('officedocument') || mime.includes('ms-excel') || mime.includes('msword') ||
        /\.xlsx?$|\.docx?$|\.pptx?$/i.test(fileName);

    if (isOffice) {
      const LIMIT = 25 * 1024 * 1024; // 25MB office viewer limit
      if (Number.isFinite(size) && size > LIMIT) {
        return (
            <Box sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                This workbook is {formatBytes(size)}, which exceeds the 25MB limit for the online viewer.
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Button variant="contained" onClick={() => window.open(url, '_blank')}>Download / Open</Button>
                <Button variant="outlined" onClick={() => window.open(googleViewerSrc(url), '_blank')}>
                  Try Google Viewer
                </Button>
              </Box>
            </Box>
        );
      }
      // under limit → try Office viewer
      return <iframe title={fileName} src={officeViewerSrc(url)} style={{ width: '100%', height: 520, border: 0 }} />;
    }

    // default fallback
    return (
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            No inline preview for this file type.
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
            <Button variant="contained" onClick={() => window.open(url, '_blank')}>Download / Open</Button>
            <Button variant="outlined" onClick={() => window.open(googleViewerSrc(url), '_blank')}>Try Online Viewer</Button>
          </Box>
        </Box>
    );
  }


  const [payForm, setPayForm] = useState({
    clientName: '',
    clientPhone: '',
    paymentsNumber: 1, // default 1, max 36
    amount: '',        // required (₪, gross)
    clientEmail: '',
    clientId: '',
      caseId: ''
  });

  const [payAttachmentOptions, setPayAttachmentOptions] = useState([]);   // all selectable files
  const [paySelectedAttachment, setPaySelectedAttachment] = useState(null); // {url, fileName, type}
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
    const [attachFile, setAttachFile] = useState(false);

    const hasSignedAttachment = !!(
        paySelectedAttachment &&
        /legal-report-\d+-signed/i.test(paySelectedAttachment.fileName || '')
    );
  const [summary, setSummary] = useState({
    byEventType: {}, byStatus: {},bySubStatus:{}, totalEvents: 0, grandTotal: 0,
  });
  const bySub = summary?.bySubStatus || {};
    const mainStatusesForDrill = ['ממתין לטיפול משפטי', 'טיפול תפעול', 'הנה"ח'];
  const [expanded, setExpanded] = useState({});
  const openPaymentDialog = () => setPayOpen(true);
  const closePaymentDialog = () => {
    setPayOpen(false);
    setPaySubmitting(false);
  };
  const onPayChange = (e) => {
    const { name, value } = e.target;
    setPayForm(prev => ({ ...prev, [name]: value }));
  };
  // after initial fetch:
  const [casesMaster, setCasesMaster] = useState([]);   // full dataset from server
  // const [filteredEvents, setFilteredEvents] = useState([]); // what the table shows (cases)
  const [alertMsg, setAlertMsg] = useState("");
  const [showEditCaseModal, setShowEditCaseModal] = useState(false);
  const [caseForm, setCaseForm] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState({
    open: false,
    event: null,
  });
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  // Use your controller to detect dark mode
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  // const rowsPerPage = 10;
  // const [page, setPage] = useState(0);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  // FILTER STATE
  // const [order, setOrder] = useState("asc");
  // const [orderBy, setOrderBy] = useState("created_at");
  const [feeRows, setFeeRows] = useState([]);

    const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [carIdFilter, setCarIdFilter] = useState("");
  const [placeFilter, setPlaceFilter] = useState("");
  const [subStatusFilter, setSubStatusFilter] = useState("");
  const [eventTypeFilter, setEventTypeFilter] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [subDepartmentFilter, setSubDepartmentFilter] = useState("");
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [mediaPreview, setMediaPreview] = useState({ url: "", type: "" });
  // logs modal states
  const [showLogsModal, setShowLogsModal] = useState(false);
  const [selectedLogs, setSelectedLogs] = useState([]);
  const [logsPage, setLogsPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingFiles, setLoadingFiles] = useState(false);
  const logsPerPage = 6;
  const [statusFilter, setStatusFilter] = useState("");
  const [notes, setNotes] = useState([]);
  const [noteBody, setNoteBody] = useState('');
  const [mentions, setMentions] = useState([]); // array of emails
  const [anchorEl, setAnchorEl] = useState(null);
  const [suggest, setSuggest] = useState([]);
  const [triggerRange, setTriggerRange] = useState(null); // {start, end}
  const [payErrors, setPayErrors] = useState({ paid:'', nop:'', nopp:'' });
  const [notesLoading, setNotesLoading] = useState(false);

  const clamp = (n, lo, hi) => Math.min(hi, Math.max(lo, n));

  const onPaidChange = (e) => {
    const val = Math.max(0, Math.trunc(Number(e.target.value || 0)));
    setCaseForm(prev => ({ ...prev, paid: val }));
  };

  const onNopChange = (e) => {
    let val = Math.trunc(Number(e.target.value || 1));
    val = clamp(val, 1, 18);                 // 1–18
    setCaseForm(prev => {
      let nopp = prev.number_of_payments_paid ?? 0;
      nopp = clamp(nopp, 0, val);            // 0..nop
      return { ...prev, number_of_payments: val, number_of_payments_paid: nopp };
    });
  };



  useEffect(() => {
    if (!caseForm?.case_id) return;
    setNotes([]);
    setNotesLoading(true);
    fetch(`https://blue-parking-invite.bluept.dev/api/cases/${caseForm.case_id}/notes`)
        .then(r => r.json())
        .then(setNotes)
        .catch(err => {
          console.error("Failed to fetch notes:", err);
          setNotes([]); // optional fallback
        })
        .finally(() => {
          setNotesLoading(false);

        });
  }, [caseForm?.case_id]);

  const onNoteChange = async (e) => {
    const val = e.target.value;
    setNoteBody(val);
    const sel = e.target.selectionStart;

    // find "@word" ending at cursor
    const upto = val.slice(0, sel);
    const match = upto.match(/@([^\s@]{1,40})$/);
    if (match) {
      const q = match[1];
      const resp = await fetch(`https://blue-parking-invite.bluept.dev/api/users/suggest?q=${encodeURIComponent(q)}`);
      const users = await resp.json();
      setSuggest(users);
      setAnchorEl(e.target);
      setTriggerRange({ start: sel - q.length - 1, end: sel }); // include @
    } else {
      setSuggest([]);
    }
  };

  const applyMention = (user) => {
    if (!triggerRange) return;
    const email = user.email || user.username;
    const before = noteBody.slice(0, triggerRange.start);
    const after  = noteBody.slice(triggerRange.end);
    const next   = `${before}${email} ${after}`; // replace with full email
    setNoteBody(next);
    setMentions(prev => Array.from(new Set([...prev, email])));
    setSuggest([]);
    setTriggerRange(null);
  };

  const saveNote = async () => {
    if (!noteBody.trim()) return;
    const res = await fetch(`https://blue-parking-invite.bluept.dev/api/cases/${caseForm.case_id}/notes`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        author_email: userEmail,
        author_name: userName,
        body: noteBody.trim(),
        mentions
      })
    });
    const json = await res.json();
    setNotes(prev => [json, ...prev]);
    setNoteBody(''); setMentions([]);
  };

  // track which car-groups are open
  const [expandedGroups, setExpandedGroups] = useState({});
  const toggleGroup = (carId) =>
      setExpandedGroups(prev => ({ ...prev, [carId]: !prev[carId] }));

//case
  function onEditCase(caseRow) {
    setCaseForm(normalizeCase(caseRow));
    setShowEditCaseModal(true);
  }

  function MoveToExistingCaseDialog({
                                      open,
                                      onClose,
                                      eventRow,
                                      allCases,
                                      onPatched,
                                      allowCrossCar = false,
                                      currentCaseId,
                                      filteredEvents,  // Add this prop
                                      casesMaster      // Add this prop
                                    }) {
    const norm = v => v == null ? "" : String(v).trim();

    const [loading, setLoading] = React.useState(false);
    const [selected, setSelected] = React.useState(null);

    // Reset selected when dialog opens or data changes
    React.useEffect(() => {
      if (open) {
        setSelected(null);
      }
    }, [open, filteredEvents, casesMaster]);

    const casesList = React.useMemo(
        () => (allCases || []),
        [allCases, filteredEvents, casesMaster]  // Include both dependencies
    );

    const options = React.useMemo(() => {
      const eventCar = norm(eventRow?.car_id);
      const curCase = norm(currentCaseId);
      const list = Array.isArray(allCases) ? allCases : [];

      return list
          .filter(c =>
              (allowCrossCar || norm(c.car_id) === eventCar) &&
              norm(c.case_id) !== curCase
          )
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    }, [allCases, eventRow?.car_id, currentCaseId, allowCrossCar, filteredEvents, casesMaster]);

    const fmt = (iso) => iso ? new Date(iso).toLocaleString("he-IL", { dateStyle: "short", timeStyle: "short" }) : "";

    const handleAttach = async () => {
      if (!selected) return;
      try {
        setLoading(true);
        const res = await fetch("https://blue-parking-invite.bluept.dev/api/cases/attach-event", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ eventId: eventRow.id, targetCaseId: selected.case_id, userEmail }),
        });
        if (!res.ok) throw new Error(await res.text());
        const payload = await res.json();
        onPatched?.(payload);  // Call onPatched with the result
        onClose();
      } catch (e) {
        alert(`Failed to attach: ${e.message}`);
      } finally {
        setLoading(false);
      }
    };

    // console.log("Dialog data:", { filteredEvents: filteredEvents?.length, casesMaster: casesMaster?.length, options: options?.length });

    return (
        <Dialog
            sx={{
              color: textColor,
            }}
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
          <DialogTitle sx={{
            bgcolor: paperBg,
          }}>
            צרף אירוע #{eventRow?.id} לתיק קיים
          </DialogTitle>
          <DialogContent sx={{
            bgcolor: paperBg,
            color: textColor,
            p: 2,
            overflowY: isXs ? "auto" : "visible",
            borderRadius: 2,
          }}>
            <Box sx={{ mt: 2 }}>
              <Autocomplete
                  options={options}
                  getOptionKey={(o) => o.case_id}
                  getOptionLabel={(o) => `#${o.case_id} — ${fmt(o.created_at)} — ${o.main_status ?? "—"} — `}
                  groupBy={(o) => o.created_at ? new Date(o.created_at).toLocaleDateString("he-IL") : "ללא תאריך"}
                  value={selected}
                  onChange={(_, v) => setSelected(v)}
                  loading={loading}
                  renderInput={(params) => (
                      <TextField
                          {...params}
                          label="בחר תיק לפי תאריך יצירה"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                  {loading && <CircularProgress size={18} />}
                                  {params.InputProps.endAdornment}
                                </>
                            )
                          }}
                      />
                  )}
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{
            bgcolor: paperBg,
          }}>
            <Button onClick={onClose}>ביטול</Button>
            <Button disabled={!selected || loading} variant="contained" onClick={handleAttach}>
              צרף
            </Button>
          </DialogActions>
        </Dialog>
    );
  }


  function InternalHandlerField({ caseForm, setCaseForm }) {
    const [open, setOpen] = React.useState(false);
    const [opts, setOpts] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const disabled = caseForm.department !== "תפעול"; // disable if handling_lawyer is set

    const onInputChange = async (_, q) => {
      if (!q || q.length < 1) { setOpts([]); return; }
      setLoading(true);
      try {
        const users = await suggestUsers(q);
        setOpts(users);
      } finally {
        setLoading(false);
      }
    };

    return (
        <Autocomplete
            disabled={disabled}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            options={opts}
            loading={loading}
            value={caseForm.internal_handler || ""}
            onInputChange={onInputChange}
            onChange={(_, user) => {
              setCaseForm(prev => ({
                ...prev,
                internal_handler: user ? (user.email || user.username || user.name) : "",
              }));
            }}
            getOptionLabel={(u) => (typeof u === "string" ? u : (u?.name || u?.email || u?.username || ""))}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="בטיפול של"
                    placeholder={disabled ? "לא זמין כשנבחר עו\"ד" : "חפש מייל משתמש"}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                          <>
                            {loading ? <CircularProgress size={16} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                      ),
                    }}
                />
            )}
        />
    );
  }

  async function uploadSignedPdfDirect(caseId) {
    if (!signedBlob) {
      alert("אין קובץ חתום");
      return;
    }

    // 1. ask server for presigned URL for this 1 file
    const fileName = (pdfToSign?.fileName || "signed.pdf").replace(/\.pdf$/i, "-signed.pdf");
    const fileType = "application/pdf";

    // same shape you use in handleEditEventSubmit
    const presignResp = await fetch("https://blue-parking-invite.bluept.dev/api/get-presigned-urls", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        files: [{ fileName, fileType }]
      }),
    });

    if (!presignResp.ok) {
      alert("שגיאה בקבלת קישור העלאה");
      return;
    }

    const presignedData = await presignResp.json();
    const { url, fields } = presignedData.presignedUrls[0];

    // 2. upload the blob to S3 using that presigned POST
    const formDataPayload = new FormData();
    Object.entries(fields).forEach(([field, value]) => {
      formDataPayload.append(field, value);
    });
    formDataPayload.append("file", signedBlob, fileName);

    const s3Resp = await fetch(url, {
      method: "POST",
      body: formDataPayload,
    });

    if (!s3Resp.ok) {
      alert("העלאת המסמך החתום נכשלה");
      return;
    }

    // 3. Build the attachment object we want to save in DB
    //    (you already do this pattern elsewhere)
    const newAttachment = {
      fileName,
      type: fileType,
      url: `${url}${fields.key}`, // how you already compute final URL in editEvent flow
    };

    // 4. Fetch the current case from server (to get existing attachments array)
    const getCaseResp = await fetch(`https://blue-parking-invite.bluept.dev/api/cases/${caseId}`);
    const caseJson = await getCaseResp.json();

    const existingAttachments = Array.isArray(caseJson.attachments) ? caseJson.attachments : [];

    const mergedAttachments = [...existingAttachments, newAttachment];

    // 5. Send PUT to update the case's attachments (plus any other required fields)
    const putResp = await fetch(`https://blue-parking-invite.bluept.dev/api/cases/${caseId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...caseJson,
        attachments: mergedAttachments,
      }),
    });

    if (!putResp.ok) {
      alert("עדכון התיק עם הקובץ החתום נכשל");
      return;
    }

    // 6. Update local UI so attachments appear immediately:
    const updatedCaseFromServer = await putResp.json(); // expect { case: {...} }

    // merge back into casesMaster / filteredEvents like you already do in handleCaseSubmit
    const updatedCase = updatedCaseFromServer.case;

    const mergeCaseAfterSave = (oldCase, serverCase) => {
      const merged = {
        ...oldCase,
        ...serverCase,
        subRows: oldCase.subRows ?? []
      };
      return {
        ...merged,
        principal_amount: Number(merged.principal_amount),
        total_amount:
            Number(merged.principal_amount) +
            Number(merged.handling_fees) +
            Number(merged.legal_fees) +
            Number(merged.locating_fees) -
            Number(merged.payment_discount)
      };
    };

    setCasesMaster(prev =>
        prev.map(c => c.case_id === updatedCase.case_id ? mergeCaseAfterSave(c, updatedCase) : c)
    );

    setFilteredEvents(prev =>
        prev.map(c => c.case_id === updatedCase.case_id ? mergeCaseAfterSave(c, updatedCase) : c)
    );
    if (updatedCase.attachments) {
      setFilesModalItems(updatedCase.attachments);
      setActiveAttachment(updatedCase.attachments[updatedCase.attachments.length - 1]);
    }

    alert("המסמך החתום נשמר לתיק ✅");
    setShowSignDialog(false);
  }


  async function applySignature(pdfUrl, sigDataUrl) {
    // 1. download original PDF
    const existingPdfBytes = await fetch(pdfUrl).then(res => res.arrayBuffer());


    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // 2. figure out which page: 3rd page if exists, else last
    const pages = pdfDoc.getPages();
    const targetPageIndex = pages[1] ? 1 : pages.length - 1;
    const page = pages[targetPageIndex];

    // 3. embed drawn signature PNG
    const pngImage = await pdfDoc.embedPng(sigDataUrl);

    const sigWidth = 180;
    const sigHeight = 140;

    const { width, height } = page.getSize();
    const x = (width / 2) - (sigWidth / 2)-160;
    const y = 80;

    page.drawImage(pngImage, {
      x,
      y,
      width: sigWidth,
      height: sigHeight,
    });

    // 4. return Blob of the new signed PDF
    const pdfBytes = await pdfDoc.save();
    return new Blob([pdfBytes], { type: "application/pdf" });
  }

  async function handleGenerateSignedPdf() {
    if (!pdfToSign) {
      alert("אין PDF");
      return;
    }
    if (!sigPadRef.current) {
      alert("אין חתימה");
      return;
    }

    try {
      setSigning(true);

      // take the drawn signature as a PNG data URL string
      const sigDataUrl = sigPadRef.current.toDataURL("image/png");

      if (!sigDataUrl || typeof sigDataUrl !== "string") {
        alert("לא הצלחתי לקרוא את החתימה מהקנבס");
        return;
      }

      // add signature to the PDF and get new Blob
      const blob = await applySignature(pdfToSign.url, sigDataUrl);

      // create an object URL so we can <iframe src=...> preview it
      const objUrl = URL.createObjectURL(blob);

      setSignedBlob(blob);               // we'll later upload this Blob
      setSignedPreviewUrl(objUrl);       // to show in the <iframe>
    } catch (err) {
      console.error("Signing failed:", err);
      alert("שגיאה בהטמעת חתימה");
    } finally {
      setSigning(false);
    }
  }

// optional: take the signedBlob and "attach" it back to a case
  function handleAttachSignedPdfToCase() {
    if (!signedBlob) {
      alert("אין קובץ חתום עדיין");
      return;
    }
    if (!caseForm) {
      alert("כדי לצרף את המסמך החתום לתיק, תכנס למצב עריכת תיק ותנסה שוב.");
      return;
    }

    const newFileName = (pdfToSign?.fileName || "signed.pdf").replace(/\.pdf$/i, "-signed.pdf");

    setCaseForm(prev => ({
      ...prev,
      newCaseAttachments: [
        ...(prev?.newCaseAttachments || []),
        {
          file: signedBlob, // <--- this is the Blob of the signed PDF
          thumbFile: null,
          iconName: "pdf",
          name: newFileName,
          type: "application/pdf",
          previewUrl: URL.createObjectURL(signedBlob),
        },
      ],
    }));

    alert("המסמך החתום נוסף לתיק. כשתשמור את התיק זה יעלה ל-S3 ✅");
    setShowSignDialog(false);
  }
// helpers
  const toDatetimeLocal = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
    return dt.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:mm"
  };

  function ActionsCell({
                         row,
                         onEditCase,
                         exportCaseToDocx,
                         handleOpenEditModal,
                         exportRowToFolder,
                         isParentRow,
                         filteredEvents,    // Add this prop
                         casesMaster,       // Add this prop
                         setFilteredEvents  // Add this prop,
                         ,loadingReport,
                         setLoadingReport
                       }) {
    const item = row.original;
    const [splitting, setSplitting] = React.useState(false);
    const [openAttach, setOpenAttach] = React.useState(false);
    // console.log('hereee', filteredEvents, casesMaster);
    const casesList = useMemo(
        () => (casesMaster && casesMaster.length
            ? casesMaster
            : (filteredEvents || []).filter(r => r.isParent || Array.isArray(r.subRows))),
        [casesMaster, filteredEvents]
    );

    const patchAfterAttach = ({ movedEvent, targetCase, oldCase }) => {
      setFilteredEvents(prev => {
        const next = prev.map(p => ({ ...p, subRows: Array.isArray(p.subRows) ? [...p.subRows] : p.subRows }));

        // remove from old parent
        const oldIdx = next.findIndex(r => Array.isArray(r.subRows) && r.subRows.some(ev => ev.id === movedEvent.id));
        if (oldIdx !== -1) {
          next[oldIdx].subRows = next[oldIdx].subRows.filter(ev => ev.id !== movedEvent.id);
          if (oldCase) next[oldIdx] = { ...next[oldIdx], main_status: oldCase.main_status ?? next[oldIdx].main_status, updated_at: oldCase.updated_at ?? next[oldIdx].updated_at };
        }

        // add to target parent (create if not on page)
        const tgtIdx = next.findIndex(r => r.case_id === targetCase.case_id);
        if (tgtIdx === -1) next.unshift({ ...targetCase, isParent: true, subRows: [movedEvent] });
        else next[tgtIdx] = { ...next[tgtIdx], ...targetCase, subRows: [movedEvent, ...(next[tgtIdx].subRows || [])] };

        return next;
      });
    };

    const splitEventToNewCase = async (event) => {
      if (!event?.id) return;
      const ok = window.confirm(`Create a new case from event #${event.id}?`);
      if (!ok) return;

      try {
        setSplitting(true);
        const res = await fetch("https://blue-parking-invite.bluept.dev/api/cases/split-event", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ eventId: event.id, userEmail }),
        });
        if (!res.ok) {
          const t = await res.text();
          throw new Error(t || `HTTP ${res.status}`);
        }
        const data = await res.json();
        patchAfterSplit(setFilteredEvents, data);
        alert(`Event moved to new case #${data.newCaseId}`);
      } catch (err) {
        console.error(err);
        alert(`Failed to split: ${err.message}`);
      } finally {
        setSplitting(false);
      }
    };

    // parent (case) row actions
    if (isParentRow(row)) {
      return (
          <>
            <Box sx={{ display: "flex", gap: 1,  '& > :last-child': { marginInlineEnd: 8 } }}>
              <Tooltip title="עריכת תיק">
                <EditIcon fontSize="medium" sx={{cursor: "pointer"}} onClick={() => onEditCase(item)}/>
              </Tooltip>

                <Tooltip title="צא לצוד">
                    <IconButton    onClick={() => {
                        setHuntTarget(row.original);
                        setOpenHuntDialog(true);
                    }} size="small">
                        {/* turns black icons to white */}
                        <img
                            src={goHunt}
                            alt="Go Hunt"
                            width={24}
                            height={24}
                            style={{ filter: "brightness(0) invert(1)" }}
                        />
                    </IconButton>
                </Tooltip>
              <Tooltip title="צור דוח">

                {loadingReport[row?.original?.case_id]  ?
                    <CircularProgress size={24} sx={{ mr: 1 }} /> :
                    <PictureAsPdfIcon  fontSize="medium" sx={{cursor: "pointer"}}   onClick={async ()=>generateReport(row.original.case_id)}/>
                }
              </Tooltip>

              <Tooltip title="שלח בקשת תשלום">

                <PaymentIcon  fontSize="medium" sx={{cursor: "pointer"}} onClick={() => {
                  const amt = row.original.total_amount;
                  setPayForm(prev => ({
                    ...prev,
                    amount: amt ?? '',          // prefill from row; empty if not found
                    clientEmail: row.original.email || '', // prefill from row
                    clientId: row.original.national_id || '', // prefill from row
                    clientPhone: row.original.phone || '', // prefill from row
                    clientName: row.original.user_name || '', // prefill from row
                    carId: row.original.car_id,
                      caseId: row.original.case_id
                  }));
                  (async () => {

                    const events = await loadCaseEvents(row.original.case_id);
                    const allAtts = [];
// 1) case-level attachments (if your case row has them)
                    if (Array.isArray(row.original.attachments)) {
                      for (const a of row.original.attachments) {
                        if (a?.url) allAtts.push({ url: a.url, fileName: a.fileName || a.name || 'file', type: a.type || '' });
                      }
                    }
// 2) all event-level attachments
                    if (Array.isArray(events)) {
                      for (const ev of events) {
                        const atts = Array.isArray(ev.attachments) ? ev.attachments : [];
                        for (const a of atts) {
                          if (a?.url) {
                            allAtts.push({
                              url: a.url,
                              fileName: a.fileName || a.name || `event-${ev.id}`,
                              type: a.type || ''
                            });
                          }
                        }
                      }
                    }

// De-dup by URL just in case
                    const byUrl = new Map();
                    for (const a of allAtts) if (!byUrl.has(a.url)) byUrl.set(a.url, a);
                    setPayAttachmentOptions([...byUrl.values()]);
                  })();
                  // inside parent row actions where you do setPayOpen(true)

                  setPaySelectedAttachment(null); // default: no file
                    setAttachFile(false);           // NEW: התיבה מתחילה כבויה (ללא קובץ)
                  setPayOpen(true);
                }} />
              </Tooltip>

              <Tooltip title="יצוא לתיקייה">

                <FolderOpenIcon  fontSize="medium" sx={{cursor: "pointer"}} onClick={() => exportCaseToDocx(item)}/>
              </Tooltip>

                <Tooltip
                    title={
                        row.original?.is_frozen
                            ? 'ביטול הקפאה'
                            : 'הקפאה'
                    }
                >
                    <RemoveCircleOutlineOutlinedIcon
                        color={row.original?.is_frozen ? 'warning' : 'inherit'}
                        fontSize="medium"
                        sx={{ cursor: 'pointer' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setFreezePrompt({
                                open: true,
                                target: 'case',
                                id: row.original.case_id,
                                freeze: !row.original?.is_frozen,
                                row: row.original,
                            });
                        }}
                    />
                </Tooltip>
            </Box>
          </>
      );
    }

    // child (event) row actions
    return (
        <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              flexWrap: 'nowrap',        // <-- keep in one horizontal row
            }}
        >
          <Tooltip title="עריכת אירוע">
    <span>
      <IconButton
          size="small"
          color="primary"
          aria-label="Edit"
          onClick={(e) => {
            e.stopPropagation();
            handleOpenEditModal(item);
          }}
      >
        <EditIcon fontSize="small"/>
      </IconButton>
    </span>
          </Tooltip>

          <Tooltip title="יצוא לתיקייה">
    <span>
      <IconButton
          size="small"
          aria-label="Export to folder"
          onClick={(e) => {
            e.stopPropagation();
            exportRowToFolder(item);
          }}
      >
        <FolderOpenIcon fontSize="small"/>
      </IconButton>
    </span>
          </Tooltip>

          <Tooltip title="העברה לתיק חדש">
    <span>
      <IconButton
          size="small"
          color="warning"
          aria-label="Move to new case"
          disabled={splitting}
          onClick={(e) => {
            e.stopPropagation();
            splitEventToNewCase(item);
          }}
      >
        {splitting ? <CircularProgress size={16}/> : <CallSplitIcon fontSize="small"/>}
      </IconButton>
    </span>
          </Tooltip>

          <Tooltip title="העברה לתיק קיים">
    <span>
      <IconButton
          size="small"
          color="success"
          aria-label="Move to existing case"
          onClick={(e) => {
            e.stopPropagation();
            setOpenAttach(true);
          }}
      >
        <CallMergeIcon fontSize="small"/>
      </IconButton>
    </span>
          </Tooltip>
            <Tooltip title={`${!!item?.is_frozen ? 'ביטול הקפאה' : 'הקפאה'}`}>

                <RemoveCircleOutlineOutlinedIcon
                    color={item?.is_frozen ? 'warning' : 'inherit'}
                    fontSize="medium"
                    sx={{ cursor: 'pointer' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setFreezePrompt({
                            open: true,
                            target: 'event',
                            id: item.id,
                            freeze: !item.is_frozen,
                            row: item,
                        });
                    }}
                />
            </Tooltip>
          <div style={{display: "flex"}}>
            <MoveToExistingCaseDialog
                key={openAttach ? `attach-${item.id}-${casesList.length}` : 'closed'}
                open={openAttach}
                onClose={() => setOpenAttach(false)}
                eventRow={item}
                allCases={casesList}
                onPatched={patchAfterAttach}
                currentCaseId={item.case_id}
                filteredEvents={filteredEvents}    // Pass the prop
                casesMaster={casesMaster}          // Pass the prop
            />
          </div>
            <Tooltip title="מחיקת אירוע זה">
      <span>
        <IconButton
            size="small"
            onClick={(e) => {
                e.stopPropagation();
                setConfirmDelete({ open: true, event: item });
            }}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </span>
            </Tooltip>
        </Box>
    );
  }


  const normalizeCase = (c) => {
    const hasChildren = Array.isArray(c.subRows) && c.subRows.length > 0;
    const live = computeCaseTotals(c); // eventsSum, total

    return {
      case_id: c.case_id,
      car_id: c.car_id || "",
      user_name: c.user_name || "",
      phone: c.phone || "",
      national_id: c.national_id || "",
      email: c.email || "",
      legal_fees: Number(c.legal_fees || 0),
      locating_fees: Number(c.locating_fees || 0),
      handling_fees: Number(c.handling_fees || 0),
      main_status: c.main_status || "ראשוני",
      end_date: toDatetimeLocal(c.end_date || null),
      // handling_lawyer: c.handling_lawyer || "",
      internal_handler: c.internal_handler || "",
      with_discount: c.with_discount ? 1 : 0,
      payment_discount: c.payment_discount ?? null,
      paid: Number(c.paid || 0),
      number_of_payments: Number(c.number_of_payments) ?? 1,
      number_of_payments_paid: Number(c.number_of_payments_paid) ?? 0,
      attachments: Array.isArray(c.attachments) ? c.attachments : [],
      newCaseAttachments: [],   // files picked but not uploaded yet
      address: c.address || "",
        lawyer_backup: c.lawyer_backup || "",
        investigator_backup: c.investigator_backup || "",
      last_name: c.last_name || "",
      sub_status: c.sub_status,
      registered_mail_uploaded: c.registered_mail_uploaded,
      registered_mail_delivered_ok: c.registered_mail_delivered_ok,
      override_total_amount: c.override_total_amount ? c.override_total_amount : 0,
      override_total_enabled: c.override_total_enabled,
      principal_amount: hasChildren ? live.eventsSum : Number(c.principal_amount || 0),
        department: c.department || "",
        sub_department: c.sub_department || "",
        call_number: c.call_number || "",
        invoice_number: c.invoice_number || "",
      total_amount:     hasChildren ? live.total     : Number(c.total_amount ??
          ((Number(c.principal_amount||0)
              + Number(c.handling_fees||0)
              + Number(c.locating_fees||0)
              + Number(c.legal_fees||0)
              - (c.with_discount ? Number(c.payment_discount||0) : 0)))),
    };
  };


  // add files into caseForm.newCaseAttachments
  const handleCaseFileChange = async (e) => {
    e.preventDefault();
    const picked = Array.from(e.target.files);
    setLoadingFiles(true);
    const processed = await Promise.all(picked.map(processAttachment)); // you already have this
    setLoadingFiles(false);

    const trimmed = processed.map(({ original, thumbnail, icon }) => ({
      file:       original,
      thumbFile:  thumbnail ?? null,
      iconName:   icon ?? null,
      name:       original.name,
      type:       original.type,
      previewUrl: URL.createObjectURL(thumbnail ?? original),
    }));

    setCaseForm(prev => ({
      ...prev,
      newCaseAttachments: [...(prev.newCaseAttachments || []), ...trimmed]
    }));
  };

  const handleRemoveCaseAttachment = (idx, isNew) => {
    setCaseForm(prev => {
      if (isNew) {
        const next = [...(prev.newCaseAttachments || [])];
        next.splice(idx, 1);
        return { ...prev, newCaseAttachments: next };
      } else {
        const next = [...(prev.attachments || [])];
        next.splice(idx, 1);
        return { ...prev, attachments: next };
      }
    });
  };

  function handleCaseChange(e) {
    const { name, value, type, checked } = e.target;
    setCaseForm((prev) => ({
      ...prev,
      [name]:
          type === "checkbox"
              ? (checked ? 1 : 0)
              : ["legal_fees","locating_fees","handling_fees","payment_discount", "override_total_amount"].includes(name)
                  ? (value === "" ? "" : Number(value))
                  : value,
    }));
  }


    async function apiFreezeCase(caseId, freeze) {


        const resp = await fetch(`https://blue-parking-invite.bluept.dev/api/gods-blue-eye/cases/${caseId}/freeze`, {
            method: 'POST',
            headers: { 'Content-Type':'application/json' },
            body: JSON.stringify({ freeze, userEmail, userName }),
        });
        if (!resp.ok) throw new Error(await resp.text());
        return resp.json();
    }

    async function apiFreezeEvent(eventId, freeze) {

        const resp = await fetch(`https://blue-parking-invite.bluept.dev/api/gods-blue-eye/events/${eventId}/freeze`, {
            method: 'POST',
            headers: { 'Content-Type':'application/json' },
            body: JSON.stringify({ freeze, userEmail, userName }),
        });
        if (!resp.ok) throw new Error(await resp.text());
        return resp.json();
    }

// Update local state after server ack
    function applyCaseFreezeToState(setter, caseId, isFrozen, patch={}) {
        setter(prev => prev.map(c => c.case_id === caseId ? { ...c, is_frozen: isFrozen ? 1 : 0, ...patch } : c));
    }
    function applyEventFreezeToState(setter, eventId, isFrozen) {
        setter(prev => prev.map(parent => {
            if (!Array.isArray(parent.subRows)) return parent;
            return {
                ...parent,
                subRows: parent.subRows.map(ev => ev.id === eventId ? { ...ev, is_frozen: isFrozen ? 1 : 0 } : ev)
            };
        }));
    }

  async function handleCaseSubmit(e) {
    e.preventDefault();
    if (!caseForm) return;
    let uploaded = [];
    if (caseForm.newCaseAttachments?.length) {
      uploaded = await uploadFilesWithThumbs(caseForm.newCaseAttachments);
    }

    // 2) merge with existing attachments
    const mergedAttachments = [
      ...(caseForm.attachments || []),
      ...uploaded,  // { fileName, type, url, thumbUrl?, iconName? }
    ];
    const payload = {
      ...caseForm,
      // send null if discount unchecked
      payment_discount:
          caseForm.with_discount ? Number(caseForm.payment_discount || 0) : null,
      // datetime-local -> ISO (server will format for MySQL)
      end_date: caseForm.end_date ? new Date(caseForm.end_date).toISOString() : null,
      attachments: mergedAttachments,
        userEmail: userEmail,

    };
    delete payload.newCaseAttachments;

    try {
      const res = await fetch(`https://blue-parking-invite.bluept.dev/api/cases/${caseForm.case_id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const json = await res.json();
      if (!res.ok) {
        setAlertMsg(json?.error || "נכשל בשמירת התיק");
        setOpenErrorAlert(true);
        // setOpenSuccessAlert(true);
        throw new Error(json?.error || "נכשל בשמירת התיק");
      }

      // Option A: refetch cases list
      // await refetchCases();

      const mergeCaseAfterSave = (oldCase, serverCase) => {
        // keep children already loaded in UI
        const merged = { ...oldCase, ...serverCase, subRows: oldCase.subRows ?? [] };

        return {...merged, principal_amount: Number(merged.principal_amount), total_amount: Number(merged.principal_amount)+Number(merged.handling_fees)+Number(merged.legal_fees)+Number(merged.locating_fees)-Number(merged.payment_discount) };
      }

// use it in both lists:
      setCasesMaster(prev =>
          prev.map(c => c.case_id === json.case.case_id ? mergeCaseAfterSave(c, json.case) : c)
      );

      setFilteredEvents(prev =>
          prev.map(c => c.case_id === json.case.case_id ? mergeCaseAfterSave(c, json.case) : c)
      );
      setShowEditCaseModal(false);
      setCaseForm(null);
      setAlertMsg("התיק נשמר בהצלחה");
      setOpenSuccessAlert(true);
    } catch (err) {
      console.error(err);
      // show toast/snackbar if you use one
    }
  }
  //



  const handleOpenMedia = (attachment) => {
    setMediaPreview(attachment);
    setShowMediaModal(true);
  };
  const [discountError, setDiscountError] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [columnFilters, setColumnFilters] = useState([]);  // [{ id, value }, ...]
  const [globalFilter, setGlobalFilter]   = useState('');
  const [editFormData, setEditFormData] = useState(null);
  const handleCloseMediaModal = () => {
    setShowMediaModal(false);
    setMediaPreview({ url: "", type: "" });
  };

  const mapMRTFilters = (cfs) => {
    const out = {};
    for (const f of cfs) {
      switch (f.id) {
        case 'car_id':            out.carId = f.value; break;
        case 'main_status':            out.main_status = f.value; break;
        case 'department':   out.department = f.value; break;
          case 'sub_department':   out.sub_department = f.value; break;
          case 'internal_handler':  out.internal_handler = f.value; break;
        case 'user_name':         out.user_name = f.value; break; // (optional—see backend)
        case 'phone':             out.phone = f.value; break;     // (optional—see backend)
          // add more as needed, matching your column accessorKeys
      }
    }
    return out;
  };
// 2. Build a flat displayList
  // 2. Build a flat displayList
  const displayList = useMemo(() => filteredEvents, [filteredEvents]);


  const hasGroups = useMemo(
      () => displayList.some(r => r.isSummary),
      [displayList],
  );

  function toDateTimeLocalValue(date, timeZone) {
    // 1) date part as “YYYY‑MM‑DD”
    const datePart = date.toLocaleDateString("en-CA", {
      timeZone,
      year:   "numeric",
      month:  "2-digit",
      day:    "2-digit"
    });

    // 2) time part as “HH:mm”
    const timePart = date.toLocaleTimeString("en-GB", {
      timeZone,
      hour12: false,
      hour:   "2-digit",
      minute: "2-digit"
    });

    return `${datePart}T${timePart}`;
  }

  const handleOpenEditModal = (event) => {
    const tz = "Europe/Athens";
    const start = new Date(event.time_of_event);
    let   end   = event.end_date ? new Date(event.end_date) : null;

    setEditFormData({
      ...event,
      dateTime: toDateTimeLocalValue(start, tz),
      end_date: end ? toDateTimeLocalValue(end, tz) : ""
    });
    setShowEditModal(true);
    setShowEditModal(true);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }


// Function to handle changes in the edit form fields:
  const handleEditFormChange = (e) => {
    const { name, type, value, checked } = e.target;

    setEditFormData(prev => ({
      ...prev,
      [name]: type === "checkbox"
          ? (checked ? 1 : 0)   // store 1/0 for your tinyint
          : value               // everything else stays as value
    }));
  };

  const handleGoHunt = async (row) => {
      setLoading(true);
      const response = await fetch(`https://blue-parking-invite.bluept.dev/api/go-hunt/${row.original.car_id}/${row.original.case_id}/${userEmail}`, {
          method: "GET", // You may use PUT if that fits your design better.
          headers: { "Content-Type": "application/json" }
      });
      const result = await response.json();
      if (response.ok) {
          setAlertMsg(`הצייד הושלם, נמצאו ${result.created_events} אירועים חדשים.`);

          setOpenSuccessAlert(true);
          // alert("Event updated successfully!");
          // Update local state to reflect the changes.
          //
          // setCasesMaster(prev => applyEventUpdateByCaseId(prev, result));
          // setFilteredEvents(prev => applyEventUpdateByCaseId(prev, result));
          // setShowEditModal(false);
          // setEditFormData(null);
      } else {
          setAlertMsg("צא לצוד נכשל: " + (result.error || "Unknown error"));
          setOpenErrorAlert(true);
      }
      // res.json({
      //     car_id: carId,
      //     case_id: caseId,
      //     created_events: eventsPayload.length,
      //     rows: eventsPayload, // return the created events
      // });

                  const events = await loadCaseEvents(row.original.case_id);

      setFilteredEvents(prev => {
        let updated = prev;
        for (const ev of events) {
          updated = applyEventUpdateByCaseId(updated, ev);
        }
        return updated;
      })
      setLoading(false);

// optionally auto-expand the case row so the new events are visible
//       setExpanded(prev => {
//           const rowIdx = filteredEvents.findIndex(c => c.case_id === row.original.case_id);
//           return rowIdx === -1 ? prev : { ...prev, [rowIdx]: true };
//       });
  }
  const handleCloseLogsModal = () => {
    setShowLogsModal(false);
  };

  const handleRemoveAttachment = (index, isNew = false) => {
    setEditFormData((prev) => {
      // Decide whether to remove from existing attachments or new attachments
      if (isNew) {
        const updatedNew = prev.newAttachments ? [...prev.newAttachments] : [];
        updatedNew.splice(index, 1);
        return { ...prev, newAttachments: updatedNew };
      } else {
        const updatedExisting = prev.attachments ? [...prev.attachments] : [];
        updatedExisting.splice(index, 1);
        return { ...prev, attachments: updatedExisting };
      }
    });
  };

// helper: apply an updated event to our cases array
  function applyEventUpdateByCaseId(prevCases, updatedEvent) {
    // normalize attachments if your API sometimes returns a string
    const ev = {
      ...updatedEvent,
      attachments:
          typeof updatedEvent.attachments === 'string'
              ? (() => { try { return JSON.parse(updatedEvent.attachments) } catch { return [] } })()
              : (updatedEvent.attachments || [])
    };

    // 1) remove this event from whichever case currently holds it
    const stripped = prevCases.map(c => {
      const sub = (c.subRows || []).filter(e => e.id !== ev.id);
      return sub.length !== (c.subRows || []).length
          ? { ...c, subRows: sub, events_count: sub.length }
          : c;
    });

    // 2) place it into its target case by case_id (if we have that case in state)
    const idx = stripped.findIndex(c => c.case_id === ev.case_id);
    if (idx === -1) {
      // target case not in current state (e.g., filtered out) → do nothing, or trigger a refetch if you prefer
      return stripped;
    }

    const target = stripped[idx];
    const sub = [ev, ...(target.subRows || [])];

    // optional: keep children sorted newest-first by event time
    sub.sort((a, b) =>
        new Date(b.time_of_event || b.created_at || 0) -
        new Date(a.time_of_event || a.created_at || 0)
    );

    const updatedCase = { ...target, subRows: sub, events_count: sub.length };
    const next = [...stripped];
    next[idx] = updatedCase;
    return next;
  }

  const handleEditEventSubmit = async (e) => {
    e.preventDefault();

    // Prepare the updated event payload.
    // For example, convert the date/time from the datetime-local field to your expected format.
    const updatedEvent = {
      ...editFormData,
      // Convert "YYYY-MM-DDTHH:mm[:ss]" back to "YYYY-MM-DD HH:mm[:ss]" if needed.
      time_of_event: editFormData.dateTime.replace("T", " "),
      end_date: editFormData.end_date.replace("T", " "),
        userEmail
    };

    let uploadedFiles = [];

    // If there are new attachments to process:
    if (editFormData.newAttachments && editFormData.newAttachments.length > 0) {
      // Create an array of file requests for the presigned URL API.
      const fileRequests = editFormData.newAttachments.map((fileObj) => ({
        fileName: fileObj.name,
        fileType: fileObj.type,
      }));

      let presignedData = null;
      try {
        setLoading(true);
        const resp = await fetch("https://blue-parking-invite.bluept.dev/api/get-presigned-urls", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ files: fileRequests }),
        });
        presignedData = await resp.json();
        setLoading(false);
      } catch (err) {
        setLoading(false);

        console.error("Error requesting presigned URLs:", err);
      }

      // If presigned URLs were returned, loop through each new file and upload it.
      if (presignedData && presignedData.presignedUrls) {
        for (let i = 0; i < editFormData.newAttachments.length; i++) {
          const fileObj = editFormData.newAttachments[i];
          const { url, key, fields } = presignedData.presignedUrls[i];

          // Prepare the form data for the upload.
          const formDataPayload = new FormData();
          Object.entries(fields).forEach(([field, value]) => {
            formDataPayload.append(field, value);
          });
          formDataPayload.append("file", fileObj.file);

          // Upload the file.
          const response = await fetch(url, {
            method: "POST",
            body: formDataPayload,
          });

          if (!response.ok) {
            console.error(`Upload failed for ${fileObj.name}`);
          } else {
            console.log(`Uploaded ${fileObj.name} successfully.`);
          }

          // Push the file data so it can be stored along with the event.
          uploadedFiles.push({
            fileName: fileObj.name,
            type: fileObj.type,
            // Construct the file URL based on your presigned data. Adjust if necessary.
            url: `${presignedData.presignedUrls[i].url}${fields.key}`,
          });
        }
      }
    }

    // Merge any uploaded files with the event's existing attachments.
    updatedEvent.attachments = [
      ...(updatedEvent.attachments || []),
      ...uploadedFiles,
    ];

    // Remove the newAttachments property before sending the payload (if desired)
    delete updatedEvent.newAttachments;

    try {
      // Call your API endpoint to save the updated event.
      // setLoading(true);
      const response = await fetch("https://blue-parking-invite.bluept.dev/api/save-event", {
        method: "PUT", // You may use PUT if that fits your design better.
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedEvent),
      });
      const result = await response.json();
      // console.log(result);
      // setLoading(false);
      if (response.ok) {
        setAlertMsg("אירוע עודכןן בהצלחה");
        setOpenSuccessAlert(true);
        // alert("Event updated successfully!");
        // Update local state to reflect the changes.

        setCasesMaster(prev => applyEventUpdateByCaseId(prev, result));
        setFilteredEvents(prev => applyEventUpdateByCaseId(prev, result));
        setShowEditModal(false);
        setEditFormData(null);
      } else {
        setAlertMsg("שגיאה בעדכון האירוע");
        setOpenErrorAlert(true);
      }
    } catch (err) {
      console.error("Error updating event:", err);
      setAlertMsg("שגיאה בעדכון האירוע");
      setOpenErrorAlert(true);
    }
  };
  const handleLogsPageChange = (event, newPage) => {
    setLogsPage(newPage);
  };
  // MODAL STATES
  const [showAddModal, setShowAddModal] = useState(false);


  useEffect(() => {
    setExpanded({});            // collapse everything on page change/resize
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    (async () => {
      const data = await getCurrentUser();
      setUserEmail(data.signInDetails.loginId);
      setUserName(data?.profile?.name || '');
    })();
  }, []);

  useEffect(() => {
    if (!caseForm) return;
    const fees =
        Number(caseForm.handling_fees || 0) +
        Number(caseForm.locating_fees || 0) +
        Number(caseForm.legal_fees || 0);
    const principal = Number(caseForm.principal_amount || 0);
    const base = principal + fees;                 // pre-discount total
    const maxDiscount = base * 0.35;
    const minDiscount = 1;
    const d = caseForm.with_discount ? Number(caseForm.payment_discount || 0) : 0;
    if(d > maxDiscount)
      setDiscountError( `הנחה יכולה להיות מקסימום 35% - ${formatCurrency(maxDiscount)})`);
    else if(d<minDiscount)
      setDiscountError( `הנחה חייבת להיות לפחות ${formatCurrency(minDiscount)}`);
    else
      setDiscountError('');
  }, [
    caseForm?.payment_discount,
    caseForm?.with_discount,
    caseForm?.handling_fees,
    caseForm?.locating_fees,
    caseForm?.legal_fees,
    caseForm?.principal_amount,
  ]);

// // If you change filters/sorts that fetch new data, collapse too:
//   useEffect(() => {
//     setExpanded({});
//   }, [filteredEvents]); // or after you set the new page result

    const loadCases = useCallback(async () => {
        const params = new URLSearchParams(window.location.search);
        const openId = params.get('openCase');
        if (openId) return;

        setLoading(true);
        const extra = mapMRTFilters(columnFilters);

        const res = await fetch("https://blue-parking-invite.bluept.dev/api/gods-blue-eye/search", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                filters: {
                    from: dateRange.from || "",
                    to:   dateRange.to   || "",
                    carId: carIdFilter || "",
                    place: placeFilter || "",
                    sub_status: filters.sub_status || [],
                    eventType:  filters.eventType  || [],
                    main_status: filters.main_status || [],
                    department:   filters.department   || [],
                    sub_department: filters.sub_department || [],
                    includeUnassigned: "0",
                    internal_handler: internalHandlerFilter || "",
                    ...extra,
                    q: globalFilter || "",
                },
                page: pagination.pageIndex + 1,
                pageSize: pagination.pageSize,
                sort: { by: "c.created_at", dir: "desc" },
            }),
        });

        const data = await res.json();

        setFeeRows(data.feeRows || []);
        setCasesMaster(data.cases || []);
        setFilteredEvents(data.cases || []);
        setTotalCases(Number(data.totalCases || 0));
        setSummary(
            data.summary || {
                byEventType: {},
                byStatus: {},
                bySubStatus: {},
                totalEvents: 0,
                grandTotal: 0,
            }
        );
        setLoading(false);
    }, [
        pagination.pageIndex, pagination.pageSize, globalFilter, columnFilters
    ]);


    useEffect(() => {
        loadCases();
    }, [loadCases]);


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const openId = params.get('openCase');
    if (!openId) return;

    (async () => {
      try {
        const r = await fetch(`https://blue-parking-invite.bluept.dev/api/cases/${encodeURIComponent(openId)}`);
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const caseData = await r.json();
        // your existing state
        setCasesMaster([caseData] || []);       // current page only (parents)
        setFilteredEvents([caseData] || []);    // what we render
        setCaseForm(caseData);
        setTotalCases(1);       // NEW
        setShowEditCaseModal(true);     // open modal
      } catch (e) {
        console.error('failed to pre-open case', e);
      }
    })();
  }, []);

  // FORM STATE for Add Event
  const [formData, setFormData] = useState({
    carId: "",
    place: "",
    place_id: "",
    address: "",
    dateTime: "",
    end_date: "",
    userName: "",
    phone: "",
    nationalId: "",
    email: "",
    eventDescription: "",
    damageDescription: "",
    attachments: [],
    event_type: "",
    // handling_lawyer: "",
    main_status: "",
    payment_amount: "",
      call_number: "",
      invoice_number: "",
  });

  // SELECTED EVENT for "View Details"
  // const [selectedEvent, setSelectedEvent] = useState(null);

  // STYLE OVERRIDES FOR DARK/LIGHT
  const pageBackground = darkMode ? "#1A2035" : "#F5F5F5";
  const textColor = darkMode ? "#ffffff" : "#000000";
  const paperBg = darkMode ? "#27293d" : "#ffffff";
  const inputBorderColor = darkMode ? "#666" : "#ccc";

  // useEffect(() => {
  //     console.log(selectedEvent?.attachments);
  // }, [selectedEvent]);



  // HANDLERS

  const handleSearch = async () => {
    // setFilters({
    //   from: dateRange.from || '',
    //   to:   dateRange.to   || '',
    //   carId: (carIdFilter || '').trim(),
    //   place: (placeFilter || '').trim(),
    //   eventType: eventTypeFilter || '',
    //   main_status: statusFilter || '',
    //     department: departmentFilter || '',
    //     sub_department: subDepartmentFilter || '',
    //   includeUnassigned: '0',
    //     sub_status: subStatusFilter || '',
    //   internal_handler: internalHandlerFilter || '',
    // });

    setLoading(true);
      resetSelection();
      const res = await fetch("https://blue-parking-invite.bluept.dev/api/gods-blue-eye/search", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        filters: {
          from: dateRange.from || "",
          to:   dateRange.to   || "",
          carId: carIdFilter || "",
          place: placeFilter || "",
            sub_status: filters.sub_status || [],
          eventType: filters.eventType || [],
          main_status: filters.main_status || [],
            department: filters.department || [],
            sub_department: filters.sub_department || [],
          includeUnassigned: "0",
          internal_handler: internalHandlerFilter || '',
        },
        page: pagination.pageIndex + 1, // server is 1-based
        pageSize: pagination.pageSize,
        sort: { by: "c.created_at", dir: "desc" },
      }),
    });
    const data = await res.json();

    setFeeRows(data.feeRows || []);
    setCasesMaster(data.cases || []);       // current page only (parents)
    setFilteredEvents(data.cases || []);    // what we render
    setTotalCases(Number(data.totalCases || 0));       // NEW
    setSummary(data.summary || { byEventType:{}, byStatus:{},bySubStatus:{}, totalEvents:0, grandTotal:0 }); // NEW
    setLoading(false);

    // collapse old expansions when filters change
    setExpanded({});
    // go back to first page
    setPagination((p) => ({ ...p, pageIndex: 0 }));
  };

  const clearFilters = async () => {
      resetSelection(); // 👈 חדש
    setCarIdFilter('');
    setPlaceFilter('');
    setSubStatusFilter('');
    setDateRange({ from: '', to: '' });
    setEventTypeFilter('');
    setDepartmentFilter('');
    setSubDepartmentFilter('');
    setStatusFilter('');
    setInternalHandlerFilter('');
    setFilters({ from:'', to:'', carId:'', place:'', eventType:'', main_status:'', lawyer:'', includeUnassigned:'0' });
    setExpanded({});
    setPagination((p) => ({ ...p, pageIndex: 0 }));
    setColumnFilters([]);
    setGlobalFilter('');
    setLoading(true);
    const res = await fetch("https://blue-parking-invite.bluept.dev/api/gods-blue-eye/search", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        filters: {
          from:  "",
          to:    "",
          carId:  "",
          place:  "",
          eventType:  [],
          main_status:  [],
          lawyer:  "",
          includeUnassigned: "0",
        },
        page: pagination.pageIndex + 1, // server is 1-based
        pageSize: pagination.pageSize,
        sort: { by: "c.created_at", dir: "desc" },
      }),
    });
    const data = await res.json();

    setFeeRows(data.feeRows || []);
    setCasesMaster(data.cases || []);       // current page only (parents)
    setFilteredEvents(data.cases || []);    // what we render
    setTotalCases(Number(data.totalCases || 0));       // NEW
    setSummary(data.summary || { byEventType:{}, byStatus:{},bySubStatus:{}, totalEvents:0, grandTotal:0 }); // NEW
    setLoading(false);

  };
  // const handleChangePage = (event, newPage) => {
  //   setPageIndex(newPage);
  // };
  const handleOpenAddModal = () =>{
      setFormData({
          carId: "",
          place: "",
          place_id: "",
          address: "",
          dateTime: "",
          end_date: "",
          userName: "",
          phone: "",
          nationalId: "",
          email: "",
          eventDescription: "",
          damageDescription: "",
          attachments: [],
          event_type: "",
          main_status: "",
          payment_amount: "",
          call_number: "",
          invoice_number: "",
      });
      setShowAddModal(true);}
  const handleCloseAddModal = () => setShowAddModal(false);

  const handleAddEventChange = (e) => {
    const { name, value } = e.target;
    // console.log('name: ', name, "value: ", value);
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddEventChangePlace = (pname, pid) => {
    // const { name, value } = e.target;
    // console.log('name: ', name, "value: ", value);
    setFormData((prev) => ({
      ...prev,
      ['place']: pname,
      ['place_id']: pid,
    }));
  };

  const handleFileChange = async (e, isEdit = false) => {
    e.preventDefault();
    const picked = Array.from(e.target.files);
    setLoadingFiles(true);

    const processed = await Promise.all(picked.map(processAttachment));

    setLoadingFiles(false);
    const trimmed = processed.map(({ original, thumbnail, icon }) => ({
      file:         original,
      thumbFile:    thumbnail ?? null,
      iconName:     icon      ?? null,
      name:         original.name,
      type:         original.type,
      previewUrl:   URL.createObjectURL(thumbnail ?? original),
    }));

    if (isEdit) {
      // push into `newAttachments` so you keep existing attachments untouched
      setEditFormData(prev => ({
        ...prev,
        newAttachments: [...(prev.newAttachments || []), ...trimmed]
      }));
    } else {
      setFormData(prev => ({ ...prev, attachments: trimmed }));
    }
  };



  function upsertCaseAndEvent(prevCases, caseRow, eventRow) {
    const idx = prevCases.findIndex(c => c.case_id === caseRow.case_id);
    if (idx === -1) {
      return [{ ...caseRow, subRows: [eventRow], events_count: 1 }, ...prevCases];
    }

    const existing = prevCases[idx];
    // avoid duplicate by id (fallback to time_of_event if needed)
    const alreadyThere = (existing.subRows || []).some(
        ev => ev.id === eventRow.id
            || (!!ev.time_of_event && !!eventRow.time_of_event && ev.time_of_event === eventRow.time_of_event)
    );

    const subRows = alreadyThere
        ? existing.subRows
        : [eventRow, ...(existing.subRows || [])];

    const updated = {
      ...existing,
      ...caseRow,               // copy any updated case fields
      subRows,
      events_count: subRows.length,
    };

    const copy = [...prevCases];
    copy[idx] = updated;
    return copy;
  }

  const handleAddEventSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const uploadedFiles = await uploadFilesWithThumbs(formData.attachments);

      const newEvent = {
        time_of_event: convertToMySQLDatetime(formData.dateTime),
        end_date:       convertToMySQLDatetime(formData.end_date),
        car_id:        formData.carId.trim(),
        place:         formData.place,
        place_id:      formData.place_id,
        // address:       formData.address,
        // user_name:     formData.userName,
        // phone:         formData.phone,
        // national_id:   formData.nationalId,
        // email:         formData.email,
        event_description:   formData.eventDescription,
        damage_description:  formData.damageDescription,
        attachments:   uploadedFiles,
        event_type: formData.event_type,
        payment_amount:      parseFloat(formData.payment_amount),
          call_number:   formData.call_number || null,
          invoice_number:formData.invoice_number || null,
          userEmail
        // main_status:              formData.main_status,
        // handling_lawyer:    formData.handling_lawyer,
        // internal_handler: formData.internal_handler
      };

      const addResp = await fetch("https://blue-parking-invite.bluept.dev/api/add-event", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newEvent)
      });
      const { event, case: caseRow, caseEvents } = await addResp.json();
      const idx = filteredEvents.findIndex(c => c.case_id === caseRow.case_id);

      if (idx === -1) {
        // new case
        caseRow.subRows = [event];
        setFilteredEvents(prev => [caseRow, ...prev]);
      }

      else {
        // existing case: update fields and push child
        const updated = { ...filteredEvents[idx], ...caseRow };
        updated.subRows = caseEvents; // newest first
        updated.events_count = caseEvents.length;

        const copy = [...filteredEvents];
        copy[idx] = updated;
        setFilteredEvents(copy);
      }
      setCasesMaster((prev) => upsertCaseAndEvent(prev, caseRow, event));
      setFilteredEvents((prev) => upsertCaseAndEvent(prev, caseRow, event));
      // existing case: update fields and push child
      // const updated = { ...prevCases[idx], ...caseRow };
      // updated.subRows = [eventRow, ...(updated.subRows || [])]; // newest first
      // updated.events_count = (updated.subRows || []).length;
      //
      // const copy = [...prevCases];
      // copy[idx] = updated;
      // setEvents(prev => [...prev, savedEvent]);
      // setFilteredEvents(prev => [...prev, savedEvent]);
      setShowAddModal(false);
      setAlertMsg("אירוע התווסף בהצלחה");
      setOpenSuccessAlert(true);
    } catch(err) {
      console.error(err);
      setAlertMsg("שגיאה בהוספת האירוע");
      setOpenErrorAlert(true);
    } finally {
      setLoading(false);
    }
  };
  const renderAttachmentPreview = (att, idx) => {
    // ---------- images ----------
    if (att.type.startsWith("image/")) {
      return (
          <img
              src={getImageSrc(att)}
              alt={att.fileName}
              width={50}
              height={50}
              style={{ objectFit: "cover", cursor: "pointer", marginRight: 4 }}
              onClick={() =>
                  handleOpenMedia({ url: att.url, type: att.type, name: att.fileName })
              }
          />
      );
    }


    // ---------- videos ----------
    if (att.type.startsWith("video/")) {
      if(att.thumbUrl){
        return (
            <img
                src={att?.thumbUrl}
                alt={att.fileName}
                width={80}
                height={80}
                loading="lazy"
                style={{ objectFit: "cover", cursor: "pointer", marginRight: 4 }}
                onClick={() =>
                    handleOpenMedia({ url: att.url, type: att.type, name: att.fileName })
                }
            />
        )
      }
      else {
        return (<Grid item key={idx}>
              <video
                  src={att.url}
                  muted
                  preload="metadata"  // this helps load just video metadata (not full file)
                  style={{
                    width: 80,
                    height: 80,
                    cursor: "pointer",
                    objectFit: "cover"
                  }}
                  onClick={() =>
                      handleOpenMedia({
                        url: att.url,
                        type: att.type,
                        name: att.fileName,
                      })
                  }
              />
            </Grid>
        )
      }

    }
    return (
        <Button
            variant="text"
            color="info"
            onClick={() => window.open(att.url, "_blank")}
        >
          {att.fileName}
        </Button>
    );
  };
  // const formatDate = useMemo(()=>{          // computed once
  //   const formatDatein = (isoString) => {
  //     if(!isoString) return "";
  //     const date = new Date(isoString);
  //     const options = {
  //       year: "numeric",
  //       month: "long",
  //       day: "numeric",
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       second: "2-digit",
  //       timeZone: "Asia/Jerusalem", // GMT+2, adjust as needed
  //     };
  //     return date.toLocaleString("en-US", options);
  //   }
  //   return formatDatein;
  // },[]);


    async function handleDeleteEvent(event) {
        if (!event?.id) return;

        try {
            const response = await fetch(
                `https://blue-parking-invite.bluept.dev/api/delete-event`,
                { method: "DELETE" ,
                    headers: {
                        "Content-Type": "application/json",
                    },
                body: JSON.stringify({ id: event.id, userEmail, caseId: event.case_id })}
            );

            if (!response.ok) throw new Error("Network response was not ok");

            const result = await response.json();

            if (result.message === "Event deleted successfully") {
                setAlertMsg("אירוע נמחק בהצלחה");
                setOpenSuccessAlert(true);

                const removeEventFromState = (setter) => {
                    setter((prev) =>
                        prev.map((parent) => {
                            if (!Array.isArray(parent.subRows)) return parent;
                            const nextSubRows = parent.subRows.filter((ev) => ev.id !== event.id);
                            return {
                                ...parent,
                                subRows: nextSubRows,
                                events_count: nextSubRows.length,
                            };
                        })
                    );
                };

                removeEventFromState(setFilteredEvents);
                removeEventFromState(setCasesMaster);
            } else {
                setAlertMsg("אירעה שגיאה במחיקת האירוע");
            }
        } catch (error) {
            console.error("Error deleting event:", error);
            setErrorMessage("אירעה שגיאה במחיקת האירוע");
            setOpenErrorAlert(true);
        }
    }



    // helper to iterate the current visible data
  // const pairsFromCases = (cases) =>
  //     cases.flatMap((c) => (c.subRows || []).map((ev) => [c, ev]));

  const num = (v) => (v == null || v === '' || isNaN(v)) ? 0 : Number(v);


  function computeCaseTotals(caseRow) {
    const events = caseRow.subRows?.filter(ev=>!ev.is_frozen) || [];
    const eventsSum = events.reduce((s, ev) => s + num(ev.payment_amount), 0);
    const fees      = num(caseRow.handling_fees) + num(caseRow.locating_fees) + num(caseRow.legal_fees);
    const discount  = caseRow.with_discount ? num(caseRow.payment_discount) : 0;
    const total     = eventsSum + fees - discount;
    return { eventsSum, fees, discount, total };
  }

  function SubStatusBreakdownTooltip({ title, data }) {
    // data = { 'שליחת מכתב בדואר רשום': { cases: 5, total: 12450 }, ... }
    const entries = Object.entries(data || {});
    if (!entries.length) return <Typography variant="body2">אין נתונים</Typography>;

    return (
        <Box sx={{ p: 1 }}>
          <Typography variant="subtitle2" sx={{ mb: 0.5 }}>{title}</Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'auto auto auto', gap: 0.75, minWidth: 240 }}>
            <Typography variant="caption" sx={{ fontWeight: 600 }}>תת-סטטוס</Typography>
            <Typography variant="caption" sx={{ fontWeight: 600, textAlign: 'center' }}>#תיקים</Typography>
            <Typography variant="caption" sx={{ fontWeight: 600, textAlign: 'end' }}>סה״כ</Typography>

            {entries.map(([sub, agg]) => (
                <React.Fragment key={sub}>
                  <Typography variant="caption">{sub}</Typography>
                  <Typography variant="caption" sx={{ textAlign: 'center' }}>{agg.cases ?? 0}</Typography>
                  <Typography variant="caption" sx={{ textAlign: 'end' }}>
                    {formatCurrency(agg.total ?? 0)}
                  </Typography>
                </React.Fragment>
            ))}
          </Box>
        </Box>
    );
  }

// NEW: build one row in logs table (with image)
  async function buildLogRow(evId, log) {
    const proxyUrl = `https://blue-parking-invite.bluept.dev/api/proxy-image?url=${encodeURIComponent(log.imageUrl)}`;
    let uint8 = null, extension = "jpeg";
    try {
      const resp = await fetch(proxyUrl);
      const arrayBuffer = await resp.arrayBuffer();
      uint8 = new Uint8Array(arrayBuffer);
      const ct = resp.headers.get("content-type") || "image/jpeg";
      extension = (ct.split("/")[1] || "jpeg").replace(/[^a-z0-9]/gi,"");
    } catch {
      // leave uint8 null → no image cell
    }
    return new DocxTableRow({
      children: [
        new DocxTableCell({ children: [new Paragraph(String(evId))] }),
        new DocxTableCell({ children: [new Paragraph(String(log.userId ?? "-"))] }),
        new DocxTableCell({ children: [new Paragraph(String(log.carId ?? "-"))] }),
        new DocxTableCell({ children: [new Paragraph(fmtDT(log.ts))] }),
        new DocxTableCell({ children: [new Paragraph(String(log.direction ?? "-"))] }),
        new DocxTableCell({ children: [new Paragraph(String(log.laneName ?? "-"))] }),
        new DocxTableCell({ children: [new Paragraph(String((log.stayTime ?? 0).toString()))] }),
        new DocxTableCell({
          children: [
            uint8
                ? new Paragraph({
                  children: [ new ImageRun({
                    data: uint8,
                    transformation: { width: 100, height: 100 },
                    extension,
                  }) ],
                })
                : new Paragraph("-")
          ]
        }),
        new DocxTableCell({ children: [new Paragraph(String(log.reason ?? "-"))] }),
        new DocxTableCell({ children: [new Paragraph(log.price != null ? `₪${(log.price).toLocaleString('he-IL')}` : "-")] }),
      ],
    });
  }

  async function exportCaseToDocx(caseRow, dirHandle) {
    // 0) pick/save location once
    const defaultName = `case_${caseRow.id ?? caseRow.case_id ?? "unknown"}.docx`;
    let dir = dirHandle;
    if (!dir) {
      if (!window.showDirectoryPicker) {
        // fallback to single-file download only (attachments won’t be saved without a directory)
        dir = null;
      } else {
        dir = await window.showDirectoryPicker();
      }
    }

    // 1) Events table
    const tableHeader = new DocxTableRow({
      children: [
        new DocxTableCell({ children: [new Paragraph({ text: "סוג אירוע", bold: true })] }),
        new DocxTableCell({ children: [new Paragraph({ text: "סכום", bold: true })] }) ,
        new DocxTableCell({ children: [new Paragraph({ text: "מקום", bold: true })] }),
        new DocxTableCell({ children: [new Paragraph({ text: "כתובת", bold: true })] }),
        new DocxTableCell({ children: [new Paragraph({ text: "זמן אירוע", bold: true })] }),
        new DocxTableCell({ children: [new Paragraph({ text: "תיאור האירוע", bold: true })] }),
        new DocxTableCell({ children: [new Paragraph({ text: "תיאור הנזק", bold: true })] }),
      ],
    });
    const eventRows = (caseRow.subRows || []).filter(ev=>!ev.is_frozen).map((ev) =>
        new DocxTableRow({
          children: [
            new DocxTableCell({ children: [new Paragraph(String(ev.event_type ?? "-"))] }),
            new DocxTableCell({ children: [new Paragraph(ils(ev.payment_amount))] }),
            new DocxTableCell({ children: [new Paragraph(String(ev.place ?? "-"))] }),
            new DocxTableCell({ children: [new Paragraph(String(ev.address ?? "-"))] }),
            new DocxTableCell({ children: [new Paragraph(fmtDT(ev.time_of_event))] }),
            new DocxTableCell({ children: [new Paragraph(String(ev.event_description ?? "-"))] }),
            new DocxTableCell({ children: [new Paragraph(String(ev.damage_description ?? "-"))] }),
          ],
        })
    );
    const eventsTable = new DocxTable({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: [tableHeader, ...eventRows],
    });

    // 2) Logs table (combined)
    const logsHeader = new DocxTableRow({
      tableHeader: true,
      children: [
        "Event ID","User ID","Plate","Time","Direction","Lane","Stay Time","Car Image","Reason","Price"
      ].map((h) => new DocxTableCell({ children: [new Paragraph(h)] })),
    });
    const logRows = [];
    for (const ev of (caseRow.subRows?.filter(ev=>!ev.is_frozen) || [])) {
      for (const log of (ev.logs || [])) {
        logRows.push(await buildLogRow(ev.id, log));
      }
    }
    const logsTable = new DocxTable({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: [logsHeader, ...logRows],
    });

    // 3) Totals + document
    const { eventsSum, fees, discount, total } = computeCaseTotals(caseRow);
    const doc = new Document({
      sections: [{
        properties: { page: { margin: { top: 720, right: 720, bottom: 720, left: 720 } } },
        children: [
          new Paragraph({ text: `תיק #${caseRow.id ?? caseRow.case_id ?? ""}`, heading: HeadingLevel.TITLE, alignment: AlignmentType.CENTER }),
          new Paragraph({ text: "פרטי תיק", heading: HeadingLevel.HEADING_2 }),
          new Paragraph(`מספר רכב: ${caseRow.car_id ?? "-"}`),
          new Paragraph(`שם לקוח: ${caseRow.user_name ?? "-"}`),
          new Paragraph(`טלפון: ${caseRow.phone ?? "-"}`),
          new Paragraph(`ת.ז.: ${caseRow.national_id ?? "-"}`),
          new Paragraph(`אימייל: ${caseRow.email ?? "-"}`),
          new Paragraph(`סטטוס תיק: ${caseRow.main_status ?? "-"}`),
          new Paragraph(`מחלקה מטפלת: ${caseRow.department ?? "-"}`),
            new Paragraph(`אישיות מטפלת: ${caseRow.sub_department ?? "-"}`),

          new Paragraph({ text: "עמלות / חיובים לתיק", heading: HeadingLevel.HEADING_2 }),
          new Paragraph(`טיפול: ${ils(caseRow.handling_fees)}`),
          new Paragraph(`איתור: ${ils(caseRow.locating_fees)}`),
          new Paragraph(`משפטי: ${ils(caseRow.legal_fees)}`),
          new Paragraph(`הנחה: ${caseRow.with_discount ? ils(caseRow.payment_discount) : "₪0"}`),

          new Paragraph({ text: "אירועים בתיק", heading: HeadingLevel.HEADING_2 }),
          eventsTable,

          new Paragraph({ text: "לוגים מאוחדים", heading: HeadingLevel.HEADING_2 }),
          logRows.length ? logsTable : new Paragraph("אין לוגים"),

          new Paragraph({ text: "סיכומים", heading: HeadingLevel.HEADING_2 }),
          new Paragraph(`סך כל האירועים: ${ils(eventsSum)}`),
          new Paragraph(`סך עמלות: ${ils(fees)}`),
          new Paragraph(`סך הנחה: ${ils(discount)}`),
          new Paragraph(`סה"כ לתיק: ${ils(total)}`),
        ],
      }],
    });

    const blob = await Packer.toBlob(doc);

    // 4) Write DOCX (directory or fallback)
    if (dir && dir.getFileHandle) {
      const fh = await dir.getFileHandle(defaultName, { create: true });
      const w  = await fh.createWritable();
      await w.write(blob);
      await w.close();
    } else {
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = defaultName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(a.href);
    }

    // 5) Save attachments for all events (directory only)
    if (dir && dir.getDirectoryHandle) {
      const attsRoot = await dir.getDirectoryHandle("attachments", { create: true });
      for (const ev of (caseRow.subRows || [])) {
        const evDir = await attsRoot.getDirectoryHandle(`event-${ev.id}`, { create: true });
        for (const att of (ev.attachments || [])) {
          try {
            const res = await fetch(att.url);
            if (!res.ok) throw new Error(`Fetch ${res.status}`);
            const fileBlob = await res.blob();
            const fh = await evDir.getFileHandle(att.fileName || `att-${Date.now()}`, { create: true });
            const w  = await fh.createWritable();
            await w.write(fileBlob);
            await w.close();
          } catch (e) {
            console.warn("Attachment save failed:", att?.fileName, e);
          }
        }
      }
    }

    alert("✔️ נשמר קובץ התיק כולל לוגים וקבצים מצורפים.");
  }

  async function exportRowToFolder(eventRow, dirHandle) {
    setLoading(true);
    // 1️⃣ pick a folder
    if (!window.showDirectoryPicker) {
      return alert("This browser doesn’t support folder-picking. Try Chrome/Edge on HTTPS.");
    }
    const dir = dirHandle ?? await window.showDirectoryPicker();

    // helper: format a timestamp like “23/03/2025 18:57:37”
    const fmt = (iso) => {
      if (!iso) return "";
      const d = new Date(iso);
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      const hh = String(d.getHours()).padStart(2, "0");
      const mi = String(d.getMinutes()).padStart(2, "0");
      const ss = String(d.getSeconds()).padStart(2, "0");
      return `${dd}/${mm}/${yyyy} ${hh}:${mi}:${ss}`;
    };

    // 2️⃣ Build the .docx
    const doc = new Document({
      sections: [{
        children: [
          new Paragraph({ text: `Event #${eventRow.id}`, heading: HeadingLevel.TITLE }),

          // — Details —
          new Paragraph({ text: "Details", heading: HeadingLevel.HEADING_2 }),
          new Paragraph(`מספר רכב: ${eventRow.car_id}`),
          new Paragraph(`חניון: ${eventRow.place}`),
          new Paragraph(`כתובת: ${eventRow.address || "-"}`),
          new Paragraph(`זמן האירוע: ${fmt(eventRow.time_of_event)}`),
          new Paragraph(`שם משתמש: ${eventRow.user_name || "-"}`),
          new Paragraph(`טלפון: ${eventRow.phone || "-"}`),
          new Paragraph(`ת"ז: ${eventRow.national_id || "-"}`),
          new Paragraph(`אימייל: ${eventRow.email || "-"}`),
          new Paragraph(`סוג האירוע: ${eventRow.event_type || "-"}`),
          new Paragraph(`סכום לתשלום: ₪${formatCurrency(eventRow?.with_discount ? eventRow?.payment_amount-eventRow?.payment_discount : eventRow.payment_amount ?? 0)}`),

          new Paragraph(`סטטוס: ${eventRow.main_status || "-"}`),
            // new Paragraph(`מחלקה מטפלת: ${caseRow.department ?? "-"}`),
            // new Paragraph(`אישיות מטפלת: ${caseRow.sub_department ?? "-"}`),
          // — Descriptions —
          new Paragraph({ text: "תיאור האירוע", heading: HeadingLevel.HEADING_2 }),
          new Paragraph(eventRow.event_description || "-"),
          new Paragraph({ text: "תיאור הנזק", heading: HeadingLevel.HEADING_2 }),
          new Paragraph(eventRow.damage_description || "-"),

        ]

      }]
    });

    // ── Build a Logs table ──
    const logRows = await Promise.all(
        (eventRow.logs || []).map(async (log) => {
          const proxyUrl = `https://blue-parking-invite.bluept.dev/api/proxy-image?url=${encodeURIComponent(log.imageUrl)}`;
          const resp = await fetch(proxyUrl);
          const arrayBuffer = await resp.arrayBuffer();
          const uint8 = new Uint8Array(arrayBuffer);
          const contentType =  "image/jpeg";
          // e.g. "image/png" → "png"
          const extension = contentType.split("/")[1];
          // const linkPara = new Paragraph({
          //     children: [
          //         new ExternalHyperlink({
          //             link: log.imageUrl,                               // URL target
          //             children: [
          //                 new TextRun({ text: "View Image", style: "Hyperlink" })
          //             ]
          //         })
          //     ]
          // });
          // 2️⃣ build the row, converting everything to strings
          return new DocxTableRow({
            children: [
              new DocxTableCell({ children: [new Paragraph(log.userId.toString())] }),
              new DocxTableCell({ children: [new Paragraph(log.carId)] }),
              new DocxTableCell({ children: [new Paragraph(fmt(log.ts))] }),
              new DocxTableCell({ children: [new Paragraph(log.direction || "-")] }),
              new DocxTableCell({ children: [new Paragraph(log.laneName || "-")] }),
              new DocxTableCell({
                children: [
                  new Paragraph(
                      // HERE: we pass a plain string, not a TextRun object
                      formatDuration(log.stayTime ?? 0)
                  ),
                ],
              }),
              new DocxTableCell({
                children: [
                  new Paragraph({
                    children: [
                      new ImageRun({
                        data: uint8,
                        transformation: { width: 100, height: 100 },
                        extension,           // ← **this** is the key**
                      }),
                    ],
                  }),
                ],
              }),
              new DocxTableCell({ children: [new Paragraph(log.reason || "-")] }),
              new DocxTableCell({
                children: [new Paragraph(   log.price != null
                    ? `₪${formatCurrency(log.price)}`
                    : "-")],
              }),
            ],
          });
        })
    );

    // 3️⃣ build the header + all data rows
    const logsTable = new DocxTable({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: [
        new DocxTableRow({
          tableHeader: true,
          children: [
            "User ID",
            "Plate",
            "Time",
            "Direction",
            "Lane",
            "Stay Time",
            "Car Image",
            "Reason",
            "Price",
          ].map((h) => new DocxTableCell({ children: [new Paragraph(h)] })),
        }),
        ...logRows,
      ],
    });

    // 4️⃣ stick that into your document’s section
    doc.addSection({
      properties: {
        type: SectionType.CONTINUOUS,  // <-- continuous break, not “next page”
      },
      children: [
        new Paragraph({ text: "Logs", heading: HeadingLevel.HEADING_2}),
        logsTable,
      ],
    });

    // 3️⃣ serialize to a Blob
    const blob = await Packer.toBlob(doc);

    // 4️⃣ write the .docx file
    const docFH = await dir.getFileHandle(`event-${eventRow.id}.docx`, { create: true });
    const docW = await docFH.createWritable();
    await docW.write(blob);
    await docW.close();

    // 5️⃣ still save attachments into “attachments/…”
    const attsDir = await dir.getDirectoryHandle("attachments", { create: true });
    for (let att of eventRow.attachments || []) {
      try {
        const res = await fetch(att.url);
        if (!res.ok) throw new Error("404");
        const blob = await res.blob();
        const f = await attsDir.getFileHandle(att.fileName, { create: true });
        const w = await f.createWritable();
        await w.write(blob);
        await w.close();
      } catch (err) {
        console.warn("Failed to save", att.fileName, err);
      }
    }
    setLoading(false);
    if(!dirHandle)
      alert("✔️ Saved .docx + attachments into your chosen folder!");
  }

  // parent = case row; child = event row
  // const isParentRow = (row) => row.depth === 0;

// pick the newest event by time_of_event (fallback created_at)
  const pickLatestEvent = (row) => {
    const evs = row?.original?.subRows || [];
    if (!evs.length) return null;
    return [...evs].sort((a, b) =>
        new Date(b.time_of_event || b.created_at || 0) -
        new Date(a.time_of_event || a.created_at || 0)
    )[0];
  };

  const sumPayments = (row) =>
      (row?.original?.subRows || []).reduce(
          (s, ev) => s + (Number(ev.payment_amount) || 0),
          0
      );


  const isParentRow = (row) => row.depth === 0;
  const fromCase = (row, key) =>{

    // console.log(row);
    return isParentRow(row)
        ? row.original?.[key]
        : row.getParentRow()?.original?.[key] ?? row.original?.[key]; // fallback to event if no parent
  }

  const allLogsForRow = (row) =>
      isParentRow(row)
          ? (row.original.subRows || []).flatMap((ev) => ev.logs || [])
          : (row.original.logs || []);

// best-effort thumbnail: prefer a log image, else first attachment.url
  const pickPreviewUrl = (row) => {
    const src = isParentRow(row) ? pickLatestEvent(row) : row.original;
    if (!src) return null;
    // const fromLogs = (src.logs || []).find((l) => !!l.imageUrl)?.imageUrl;
    // if (fromLogs) return fromLogs;
    const fromAttach = (src.attachments || []).find((a) => a.url)?.url;
    return fromAttach || null;
  };


  const parseAttList = (val) => {
    if (!val) return [];
    try { return Array.isArray(val) ? val : JSON.parse(val); }
    catch { return []; }
  };

  const normalizeAtt = (a) => ({
    url: a?.url || a?.link || "",
    thumbUrl: a?.thumbUrl || a?.thumbnail || null,
    type: a?.type || a?.mime || "application/octet-stream",
    fileName: a?.fileName || a?.name || a?.url?.split("/").pop() || "file",
    iconName: a?.iconName || null
  });
  function RemainingAttachmentsButton({ attachments, render }) {
    const [open, setOpen] = React.useState(false);
    const btnRef = React.useRef(null);

    const handleOpen = (e) => {
      e.stopPropagation(); // don’t trigger row click/expand
      setOpen(true);
    };
    const handleClose = (e) => {
      e?.stopPropagation?.();
      setOpen(false);
    };

    const rest = attachments?.slice(1) ?? [];

    return (
        <>
          <Box
              ref={btnRef}
              role="button"
              onClick={handleOpen}
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleOpen(e)}
              sx={{
                px: 1,
                py: 0.25,
                borderRadius: 1,
                border: '1px dashed',
                fontSize: 12,
                whiteSpace: 'nowrap',
                cursor: 'pointer',
                userSelect: 'none',
              }}
          >
            +{rest.length}
          </Box>

          <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, backgroundColor: paperBg, }}>
              Remaining attachments ({rest.length})
              <Box sx={{ flex: 1 }} />
              <IconButton onClick={handleClose} aria-label="Close">
                <CloseIcon sx={{ color: textColor}} />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ backgroundColor: paperBg}}>
              <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
                    gap: 1,
                  }}
              >
                {rest.map((att, i) => (
                    <Box key={(att?.id ?? att?.url ?? i) + '-rest'}>
                      {render(att, i + 1)} {/* reuse your existing preview renderer */}
                    </Box>
                ))}
              </Box>
            </DialogContent>
            <DialogActions sx={{ backgroundColor: paperBg}}>
              <Button onClick={handleClose} variant="contained">סגור</Button>
            </DialogActions>
          </Dialog>


        </>
    );
  }
  const fmtILDate = (v) => {
    const d = typeof v === 'number' ? new Date(v) : new Date(String(v));
    if (isNaN(d)) return '—';
    return new Intl.DateTimeFormat('he-IL', {
      timeZone: 'Asia/Jerusalem',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(d);
  };

  const collectParentAttachments = (row) => {
    const caseAtts  = parseAttList(row?.original?.attachments).map(normalizeAtt);
    const childAtts = (row?.original?.subRows || [])
        .flatMap(ev => parseAttList(ev.attachments).map(normalizeAtt));

    // de-dupe by URL (fallback to fileName)
    const seen = new Set();
    const all = [];
    for (const att of [...caseAtts, ...childAtts]) {
      const key = att.url || att.fileName;
      if (key && !seen.has(key)) { seen.add(key); all.push(att); }
    }
    return all;
  };
  // ──────────────── columns ──────────────────────────
  const columns = useMemo(() => [
    {
      id: 'kind',
      header: '',
      size: 32,
      enableSorting: false,
      enableColumnActions: false,
      enableResizing: false,
      Cell: ({ row }) => (
          <Tooltip title={row.depth === 0 ? 'תיק' : 'אירוע'}>
            {row.depth === 0 ? (
                <FolderOpenIcon sx={{backgroundColor: row.original.is_frozen ? "#ff0000" : "primary"}} fontSize="small" />
            ) : (
                <ReceiptLongIcon sx={{backgroundColor: row.original.is_frozen ? "#ff0000" : "primary", marginLeft: "20px"}} fontSize="small"/>
            )}
          </Tooltip>
      ),
    },
    {
      header: "אירועים",
      id: "eventsCount",
      size: 60,
      accessorFn: (row) => row.events_count ?? (row.subRows?.length || 0), // <-- add this
      enableSorting: true,
      Cell: ({ row }) => row.original.events_count ?? (row.original.subRows?.length || ''),
    },
    {
      header: "מספר רכב",
      accessorKey: "car_id",
      accessorFn: (row) => row.car_id,
      size: 60,
      enableSorting: true,
      Cell: ({ row }) => fromCase(row, "car_id") ?? "—",
    },
    {
      header: "זמן יצירה",
      id: "created_at",
      size: 180,
      enableSorting: true,
      // return a sortable primitive (timestamp); render separately
      accessorFn: (row) => Date.parse(row.created_at) || null,
      Cell: ({ row }) => {
        const val = row.original.created_at;
        return val ? fmtILDate(val) : "—";
      },
    },
    // {
    //   header: "Event date",
    //   id: "eventDate",
    //   size: 200,
    //   Cell: ({ row }) => {
    //     const val = isParentRow(row)
    //         ? ""
    //         : row.original.time_of_event;
    //     return val ? new Date(val).toLocaleString() : "";
    //   },
    // },
    // {
    //   header: "End date",
    //   id: "end_date",
    //   size: 180,
    //   Cell: ({ row }) => {
    //     const val = isParentRow(row)
    //         ? row.original.end_date
    //         : row.original.end_date;
    //     return val ? new Date(val).toLocaleString() : "—";
    //   },
    // },

      {
          header: "בטיפול של",
          id: "internal_handler",
          size: 140,
          accessorKey: "internal_handler", // <-- change from id: to accessorKey:
          enableSorting: true,
          Cell: ({ row }) =>
              row.original.internal_handler || "—",
      },
    // {
    //   header: "Place",
    //   id: "place",
    //   size: 200,
    //   // cases don't have place; show it only on event rows (or from latest event on parent)
    //   Cell: ({ row }) => {
    //     if (!isParentRow(row)) return row.original.place || "—";
    //     // const ev = pickLatestEvent(row);
    //     return "";
    //   },
    // },
    // {
    //   header: "Type",
    //   id: "type",
    //   size: 120,
    //   Cell: ({ row }) => {
    //     const val = isParentRow(row) ? "" : row.original.event_type;
    //     return val?.length>0 ?<span style={{backgroundColor: getEventTypeColor(val, darkMode, "#27293d")}}>{val}</span>  : "";
    //   },
    // },
    // {
    //   header: "Principal amount",
    //   id: "principal",
    //   Cell: ({ row }) => {
    //        if (isParentRow(row)) {
    //            // prefer server value; if subRows were loaded/changed, recompute live
    //                const serverPrincipal = row.original.principal_amount;
    //            const livePrincipal   = computeCaseTotals(row.original).eventsSum;
    //            const val = Number.isFinite(livePrincipal) && (row.original.subRows?.length ? livePrincipal : serverPrincipal ?? livePrincipal);
    //            return formatCurrency(val);
    //          }
    //     return formatCurrency(row.original.payment_amount);
    //   },
    // },
    {
      header: "סכום כולל",
      id: "amount",
      accessorFn: (r) => {
        // child rows: payment_amount; parents: computed/overridden totals
        if (r?.payment_amount != null) return Number(r.payment_amount) || 0;
        if (r?.override_total_enabled) return Number(r.override_total_amount) || 0;
        const serverTotal = r.total_amount;
        const liveTotal   = computeCaseTotals(r).total;
        return Number(r.subRows?.length ? liveTotal : (serverTotal ?? liveTotal)) || 0;
      },
      // numeric compare (numbers first, then NaN/undefined)
      sortingFn: (a, b, colId) => {
        const av = Number(a.getValue(colId));
        const bv = Number(b.getValue(colId));
        const aOk = Number.isFinite(av);
        const bOk = Number.isFinite(bv);
        if (aOk && bOk) return av - bv;
        if (aOk && !bOk) return -1;
        if (!aOk && bOk) return 1;
        return 0;
      },
      enableSorting: true,
      Cell: ({ row }) => {
        if (row.depth === 0) {
          const o = row.original;
          if (o.override_total_enabled) return formatCurrency(o.override_total_amount);
          const serverTotal = o.total_amount;
          const liveTotal   = computeCaseTotals(o).total;
          const val = o.subRows?.length ? liveTotal : (serverTotal ?? liveTotal);
          return formatCurrency(val);
        }
        return formatCurrency(row.original.payment_amount);
      },
    },
    {
      accessorKey: "main_status",
      header: "סטטוס",
      size: 180,
      enableSorting: true,
      Cell: ({ row }) => {
        if (!isParentRow(row)) return null;
        const main_status = fromCase(row, "main_status");
        return (
            <Tooltip
                arrow
                placement="top"
                slotProps={{ tooltip: { sx: { whiteSpace: 'normal', p: 1.25 } } }}
                title={<StatusTracker
                    currentStatus={row.original.main_status}
                    currentSubStatus={row.original.sub_status}
                    textColor={textColor}
                />}
            >
              <Typography
                  variant="body2"
                  sx={{ whiteSpace: "nowrap", fontWeight: 600, cursor: "help" }}
              >
                {main_status || "—"}
              </Typography>
            </Tooltip>
        );
      },
    },
    {
      header: "לוגים",
      id: "logs",
      enableSorting: true,
      size: 70,
      Cell: ({ row }) => {
        const count = isParentRow(row)
            ? allLogsForRow(row).length
            : (row.original.logs?.length || 0);
        return (
            <Tooltip title="לצפייה בלוגים">
              <IconButton
                  color="primary"
                  size="small"
                  onClick={() => {
                    if(row.depth === 0) {
                      loadCaseEvents(row.original.case_id).then((events) => {
                        const logs = (events || []).flatMap(ev => ev.logs || []);
                        setSelectedLogs(logs);
                        setShowLogsModal(true);
                      });
                    }
                    else
                    {
                      const logs = allLogsForRow(row);
                      setSelectedLogs(logs);
                      setShowLogsModal(true);
                    }
                  }}
              >
                <ListAltIcon />
              </IconButton>
            </Tooltip>
        );
      },
    },
    {
      accessorKey: 'attachments',
      header: 'קבצים',
      size: 20,
      enableSorting: true,
      Cell: ({ row, cell }) => {
        const preview = row.original.attachments_preview || [];
        const atts = isParentRow(row)
            ? (preview.length ? preview : collectParentAttachments(row))
            : ([]);

        if (!atts?.length) return null;

        return (
            <Tooltip title="לצפייה בקבצים">
              <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    openFilesModal(atts, row.original.case_id); // <-- defined below
                  }}
              >
                <AttachFileIcon fontSize="small" />
              </IconButton>
            </Tooltip>
        );
      },
    },
    {
      header: "פעולות",
      id: "actions",
      size: 220,
      Cell: ({ row }) => (
          <ActionsCell
              row={row}
              isParentRow={isParentRow}
              onEditCase={onEditCase}
              exportCaseToDocx={exportCaseToDocx}
              handleOpenEditModal={handleOpenEditModal}
              exportRowToFolder={exportRowToFolder}
              filteredEvents={filteredEvents}
              casesMaster={casesMaster}
              setFilteredEvents={setFilteredEvents}
              loadingReport={loadingReport}
              setLoadingReport={setLoadingReport}
              // refetch={refetch} // <-- pass your data reload function if you have one
          />
      ),
    },
  ], [filteredEvents, loadingReport]);

  const handlingFee = editFormData?.handling_fees_added
      ? feeRows.find(f => f.fee_name === "דמי טיפול")?.fee_value
      : 0;
  const locatingFee = editFormData?.locating_fees_added
      ? feeRows.find(f => f.fee_name === "איתור")?.fee_value
      : 0;
  const legalFee = editFormData?.legal_fees_added
      ? feeRows.find(f => f.fee_name === "הוצאות משפטיות")?.fee_value
      : 0;

// אחוז המע״מ
  const vatPercent = feeRows.find(f => f.fee_name === "מעמ")?.fee_value || 0;

// סה״כ שמשלמים (כולל כל דמי השירות + מע״מ)
  const gross = Math.round(Number(editFormData?.payment_amount) || 0);

// ראשית מחשבים את המע״מ על דמי השירות
  const feeSum   = handlingFee + locatingFee + legalFee;
  const feeVat   = Math.round(feeSum * vatPercent / 100);

// ואז מחסירים את דמי השירות + המע״מ שלהם מה־gross כדי לקבל את
// החלק של הקרן הכולל מע״מ:
  const principalInclVat    = gross - (feeSum + feeVat);

// מכאן מוציאים את המע״מ מתוך הקרן
  const principalExclVat    = Math.round(principalInclVat / (1 + vatPercent/100));
  const principalVat        = Math.round(principalInclVat - principalExclVat);

// סכום המע״מ הכולל (שירותים + קרן)
  const totalVat            = feeVat + principalVat;

// הנחה (אם יש)
  const discount = editFormData?.with_discount === 1
      ? Math.round(Number(editFormData?.payment_discount) || 0)
      : 0;

  async function loadCaseEvents(caseId) {
    const res = await fetch(`https://blue-parking-invite.bluept.dev/api/gods-blue-eye/cases/${caseId}/events`);
    if (!res.ok) throw new Error('Failed to load events');
    return await res.json(); // -> array of events
  }
// סה״כ לתשלום לאחר הנחה
  const totalAfterDiscount  = gross - discount;
  const isDiscountInvalid = discount > gross;
  const TYPE_ORDER = ['ברחן', 'נזק', 'תאונה', '—'];
  const byTypeItems =
      summary?.byEventTypeOrdered ??
      TYPE_ORDER.map(k => ({ key: k, sumEvents: Number(summary?.byEventType?.[k] || 0) }));
  //
  // const STATUS_ORDER = [
  //   'ראשוני','איסוף נתונים','טיפול תפעול',
  //  ,'ממתין לטיפול משפטי','נגבה',
  //  'הנה"ח'
  // ];

  const greenStatuses = [ 'הנה"ח', 'נגבה' ];

  const STATUS_ORDER = ['ראשוני','איסוף נתונים','טיפול תפעול','ממתין לטיפול משפטי','נגבה','הנה"ח'];
  const zero = { cases:0, events:0, sumEvents:0, sumCases:0 };
    const handlePaginationChange = useCallback((updater) => {
        resetSelection();

        setPagination((prev) =>
            typeof updater === 'function' ? updater(prev) : updater
        );
    }, [resetSelection]);
  const statusItems = React.useMemo(() => {
    const byStatus = summary?.byStatus || {};
    return STATUS_ORDER.map(k => ({ key: k, ...(byStatus[k] || zero) }));
  }, [summary?.byStatus]);
  return (
      <DashboardLayout>
        <DashboardNavbar />
        <Snackbar
            open={openErrorAlert}
            autoHideDuration={6000}
            onClose={()=>setOpenErrorAlert(false)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={()=>setOpenErrorAlert(false)} severity="error" variant="filled">
            {alertMsg}
          </Alert>
        </Snackbar>
        <Snackbar
            open={openSuccessAlert}
            autoHideDuration={6000}
            onClose={()=>setOpenSuccessAlert(false)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={()=>setOpenSuccessAlert(false)} severity="success" variant="filled">
            {alertMsg}
          </Alert>
        </Snackbar>
        {/* Container Box for the page */}
        {loading ?
            <Box
                sx={{
                  position: "fixed",  // or "absolute" if you prefer relative to a specific parent
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",  // truly centers it
                }}
            >
              <CircularProgress
                  variant="indeterminate"
                  disableShrink
                  sx={(theme) => ({
                    color: '#1a90ff',
                    animationDuration: '550ms',
                    // display: "flex",
                    // justifyContent: "center",
                    // alignItems: "center",
                    // left: 0,
                    [`& .${circularProgressClasses.circle}`]: {
                      strokeLinecap: 'round',
                    },
                    ...theme.applyStyles('dark', {
                      color: '#308fe8',
                    }),
                  })}
                  size={40}
                  thickness={4}
              />
            </Box>
            :
            <Box
                sx={{
                  backgroundColor: pageBackground,
                  color: textColor,
                  minHeight: "100vh",
                  p: 3,
                }}
            >
              {/* PAGE TITLE + ADD BUTTON */}
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h4" fontWeight="bold">
                  Gods Blue Eye
                </Typography>
                <Button variant="contained" color="primary" onClick={handleOpenAddModal}>
                  + הוסף אירוע
                </Button>
              </Box>

              <Box sx={{     backgroundColor: pageBackground,
                color: textColor,}} display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                {byTypeItems.map(({ key: typeLabel, sumEvents }) => (
                    <Paper  sx={{ p: 1.5 ,    backgroundColor: pageBackground,
                      color: textColor,}} key={typeLabel} >
                      <Typography variant="subtitle2">{typeLabel}</Typography>
                      <Typography variant="h6">₪{sumEvents.toLocaleString('he-IL')}</Typography>
                    </Paper>
                ))}
              </Box>

              {/*</Box>*/}
              <Box sx={{ mt:2, display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px,1fr))', gap:1 }}>
                {statusItems.map(({ key: statusLabel, cases, events, sumCases }) => {
                  const subData = summary?.bySubStatus?.[statusLabel] || {};
                  const hasSubData = Object.keys(subData).length > 0;

                  const Card = (
                      <Paper
                          key={statusLabel}
                          sx={{ backgroundColor: pageBackground, color: textColor, p: 1.25 }}
                      >
                        <Typography variant="subtitle2">{statusLabel}</Typography>
                        <Typography variant="body2">אירועים: {events.toLocaleString('he-IL')}</Typography>
                        <Typography variant="body2">תיקים: {cases.toLocaleString('he-IL')}</Typography>
                        <Typography
                            variant="body2"
                            fontWeight={700}
                            color={greenStatuses.includes(statusLabel) ? "green" : textColor}
                        >
                          ₪{Number(sumCases).toLocaleString('he-IL')}
                        </Typography>
                      </Paper>
                  );

                    return hasSubData ? (
                        <Box key={statusLabel} sx={{ position: 'relative', display: 'inline-block' }}>
                            {Card}

                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openDrill(e, statusLabel, subData);
                                }}
                                sx={{
                                    position: 'absolute',
                                    top: 80,
                                    insetInlineEnd: 6,        // RTL/LTR aware right padding
                                    // zIndex: (t) => t.zIndex.modal + 1,
                                    color: 'common.white',
                                }}
                            >
                                <KeyboardArrowDownIcon
                                    sx={{
                                        transition: '.2s',
                                        transform:
                                            drill.open && drill.label === statusLabel ? 'rotate(180deg)' : 'none',
                                    }}
                                />
                            </IconButton>
                        </Box>
                    ) : (
                        Card
                    );

                })}
                  <ClickAwayListener onClickAway={closeDrill}>
                      <Popper
                          open={drill.open}
                          anchorEl={drill.anchorEl}
                          strategy="fixed"
                          placement="bottom-end"
                          modifiers={[
                              { name: 'offset', options: { offset: [0, 8] } },
                              // reduce reflow on scroll-heavy tables:
                              { name: 'eventListeners', options: { scroll: false, resize: true } },
                          ]}
                          keepMounted               // avoids mount cost on each toggle
                          // strategy="fixed" can further reduce reflows if your layout allows it
                          // slotProps={{ popper: { strategy: 'fixed' } }} // depending on MUI version
                          sx={{ zIndex: (t) => t.zIndex.modal }}
                      >
                          <Paper elevation={8} sx={{ p: 1.5, minWidth: 300 }}>
                              {drill.data && (
                                  <SubStatusBreakdownTooltip title={`פירוט — ${drill.label}`} data={drill.data} />
                              )}
                          </Paper>
                      </Popper>
                  </ClickAwayListener>
                <Box sx={{ p:2, borderRadius:1 }}>
                  <Typography variant="subtitle2">סה"כ אירועים</Typography>
                  <Typography variant="h6">{summary.totalEvents.toLocaleString('he-IL')}</Typography>

                  <Typography variant="subtitle2">סה"כ תיקים</Typography>
                  <Typography variant="h6">{totalCases.toLocaleString('he-IL')}</Typography>

                  <Typography variant="subtitle2">סה"כ סכום תיקים</Typography>
                  <Typography variant="h6">₪{summary.grandTotal.toLocaleString('he-IL')}</Typography>
                </Box>
              </Box>



              <Box  onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSearch();
                }
              }}>
                {/* FILTERS */}
                <Box
                    display="flex"
                    flexWrap="wrap"
                    gap={2}
                    mb={3}
                    sx={{ "& .MuiTextField-root": { minWidth: 150 } }}
                >
                  {/* Date Range */}

                  <Box display="flex" alignItems="center" gap={1}>


                    <Typography>טווח תאריכים:</Typography>
                    <TextField
                        type="date"
                        value={dateRange.from}
                        onChange={(e) => setDateRange({ ...dateRange, from: e.target.value })}
                        InputProps={{
                          sx: {
                            color: textColor,
                            "& .MuiInputBase-input": { borderColor: inputBorderColor },
                          },
                        }}
                    />
                    <Typography> - </Typography>
                    <TextField
                        type="date"
                        value={dateRange.to}
                        onChange={(e) => setDateRange({ ...dateRange, to: e.target.value })}
                        InputProps={{
                          sx: {
                            color: textColor,
                            "& .MuiInputBase-input": { borderColor: inputBorderColor },
                          },
                        }}
                    />
                  </Box>

                  {/* Car ID */}
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography>פרטים מזהים:</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        value={carIdFilter}
                        onChange={(e) => setCarIdFilter(e.target.value)}
                        sx={{ maxWidth: 120 }}
                        InputProps={{
                          sx: {
                            color: textColor,
                            "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                          },
                        }}
                    />
                  </Box>

                  {/* Place (changed from Select to TextField) */}
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography>חניון:</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        value={placeFilter}
                        onChange={(e) => setPlaceFilter(e.target.value)}
                        sx={{ maxWidth: 120 }}
                        InputProps={{
                          sx: {
                            color: textColor,
                            "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                          },
                        }}
                    />
                  </Box>
                  <Box display="flex" alignItems="center" gap={1}>
                      <Typography>סוג האירוע:</Typography>
                      <FormControl size="small">
                          <InputLabel sx={{ color: textColor }}>סוג האירוע</InputLabel>
                          <Select
                              multiple
                              size="small"
                              sx={{width: 150, height:38}}
                              value={filters.eventType || []}
                              onChange={(e) =>
                                  setFilters((prev) => ({
                                      ...prev,
                                      eventType: e.target.value, // this will be an array
                                  }))
                              }
                              renderValue={(selected) => (selected || []).join(", ")}
                          >
                              {eventTypeOptions.map((opt) => (
                                  <MenuItem key={opt} value={opt}>
                                      <Checkbox
                                          checked={(filters.eventType || []).indexOf(opt) > -1}
                                      />
                                      <ListItemText primary={opt} />
                                  </MenuItem>
                              ))}
                          </Select>
                      </FormControl>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography>סטטוס:</Typography>
                    <FormControl size="small">
                      <InputLabel sx={{ color: textColor }}>סטטוס</InputLabel>
                        <Select
                            multiple
                            size="small"
                            sx={{width: 150, height:38}}
                            value={filters.main_status || []}
                            onChange={(e) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    main_status: e.target.value, // this will be an array
                                }))
                            }
                            renderValue={(selected) => (selected || []).join(", ")}
                        >
                            {STATUS_OPTIONS.map((opt) => (
                                <MenuItem key={opt.value} value={opt.value}>
                                    <Checkbox
                                        checked={(filters.main_status || []).indexOf(opt.value) > -1}
                                    />
                                    <ListItemText primary={opt.label} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                  </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography>תת-סטטוס:</Typography>
                        <FormControl size="small">
                            <InputLabel sx={{ color: textColor }}>תת-סטטוס</InputLabel>
                            <Select
                                multiple
                                size="small"
                                sx={{width: 150, height:38}}
                                value={filters.sub_status || []}
                                onChange={(e) =>
                                    setFilters((prev) => ({
                                        ...prev,
                                        sub_status: e.target.value, // this will be an array
                                    }))
                                }
                                renderValue={(selected) => (selected || []).join(", ")}
                            >
                                {ALL_SUB_STATUSES.map((opt) => (
                                    <MenuItem key={opt} value={opt}>
                                        <Checkbox
                                            checked={(filters.sub_status || []).indexOf(opt) > -1}
                                        />
                                        <ListItemText primary={opt} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                  <Box display="flex" alignItems="center" gap={1}>
                      <Typography>מחלקה:</Typography>
                      <FormControl size="small">
                          <InputLabel sx={{ color: textColor }}>מחלקה</InputLabel>
                          <Select
                              multiple
                              size="small"
                              sx={{width: 150, height:38}}
                              value={filters.department || []}
                              onChange={(e) =>
                                  setFilters((prev) => ({
                                      ...prev,
                                      department: e.target.value, // this will be an array
                                  }))
                              }
                              renderValue={(selected) => (selected || []).join(", ")}
                          >
                              {DEPARTMENTS.map((opt) => (
                                  <MenuItem key={opt} value={opt}>
                                      <Checkbox
                                          checked={(filters.department || []).indexOf(opt) > -1}
                                      />
                                      <ListItemText primary={opt} />
                                  </MenuItem>
                              ))}
                          </Select>
                      </FormControl>
                  </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography>גורם מטפל:</Typography>
                        <FormControl size="small">
                            <InputLabel sx={{ color: textColor }}>גורם מטפל</InputLabel>
                            <Select
                                multiple
                                size="small"
                                sx={{width: 150, height:38}}
                                value={filters.sub_department || []}
                                onChange={(e) =>
                                    setFilters((prev) => ({
                                        ...prev,
                                        sub_department: e.target.value, // this will be an array
                                    }))
                                }
                                renderValue={(selected) => (selected || []).join(", ")}
                            >
                                {ALL_SUB_DEPTS.map((opt) => (
                                    <MenuItem key={opt} value={opt}>
                                        <Checkbox
                                            checked={(filters.sub_department || []).indexOf(opt) > -1}
                                        />
                                        <ListItemText primary={opt} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography>בטיפול של:</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        value={internalHandlerFilter}
                        onChange={(e) => setInternalHandlerFilter(e.target.value)}
                        sx={{ maxWidth: 120 }}
                        InputProps={{
                          sx: {
                            color: textColor,
                            "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                          },
                        }}
                    />
                  </Box>
                  <Button sx={{backgroundColor: "blue", color: textColor}} variant="outlined" onClick={handleSearch}>
                    חפש
                  </Button>
                  <Button variant="outlined" sx={{backgroundColor: "red", color: textColor}} onClick={clearFilters}>
                    נקה
                  </Button>
                </Box>

              </Box>
              {/* EVENTS TABLE */}
              <MaterialReactTable
                  columns={columns}
                  data={Array.isArray(filteredEvents) ? filteredEvents : []}
                  autoResetPageIndex={false}
                  enableExpanding
                  // ✅ selection
                  enableRowSelection
                  enableSubRowSelection={false}
                  enableMultiRowSelection
                  onRowSelectionChange={setRowSelection}
                  // ✅ custom toolbar button for bulk edit
                  renderTopToolbarCustomActions={({ table }) => {
                      const toggleSelectAllCases = () => {
                      const topLevelRows = table.getRowModel().rows.filter(r => r.depth === 0);

                      if (!allCasesSelected) {
                      // לבחור את כל התיקים (שורות עומק 0)
                      const next = {};
                      topLevelRows.forEach(r => {
                      next[r.id] = true;
                  });
                      setRowSelection(next);
                      setAllCasesSelected(true);
                  } else {
                      // לנקות בחירה
                      setRowSelection({});
                      setAllCasesSelected(false);
                  }
                  };
                      return (
                          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                              <Button
                                  variant="outlined"
                                  onClick={toggleSelectAllCases}
                              >
                                  {allCasesSelected ? 'נקה בחירת תיקים' : 'בחר את כל התיקים'}
                              </Button>

                              <Button
                                  variant="outlined"
                                  disabled={table.getSelectedRowModel().flatRows.length === 0}
                                  onClick={() => handleOpenBulk(table)}
                              >
                                  {table.getSelectedRowModel().flatRows.length > 0 && <EditIcon />}
                              </Button>
                          </Box>
                      );
                  }}
                  enableSorting
                  localization={{
                      actions: 'פעולות',
                      select: 'בחר',
                      cancel: 'ביטול',
                      rowActions: 'פעולות שורה',
                      // selectedCountOfRowCountRowsSelected: 'תיקים נבחרו',
                      clearFilter: 'נקה מסננים',
                      edit: 'עריכה',
                      delete: 'מחיקה',
                      filter: 'סינון',
                      rowNumber: 'מס׳',
                  }}
                  enableSelectAll={false}   // ✅ לא להראות צ'קבוקס select-all בכותרת
                  enableSortingRemoval={false} // optional: keeps both up/down arrows always visible
                  muiTablePaginationProps={{
                      labelRowsPerPage: 'שורות בעמוד',
                      labelDisplayedRows: ({ from, to, count }) =>
                          `${from}–${to} מתוך ${count === -1 ? `יותר מ־${to}` : count.toLocaleString('he-IL')}`,
                    rowsPerPageOptions: [10, 25, 50, 100, 200], // ✅ adds 100 & 1000 options
                  }}
                  getRowCanExpand={(row) =>
                      row.depth === 0 && (Number(row.original?.events_count) || 0) > 0
                  }
                  getSubRows={row => row.subRows}
                  onColumnFiltersChange={setColumnFilters}
                  manualPagination
                  positionExpandColumn="first"
                  manualFiltering
                  onGlobalFilterChange={setGlobalFilter}
                  rowCount={totalCases}
                  // state={{ pagination: { pageIndex, pageSize } }}
                  state={{ expanded, pagination,globalFilter , columnFilters, rowSelection }}
                  onPaginationChange={handlePaginationChange}
                  displayColumnDefOptions={{
                      'mrt-row-expand': {
                          header: 'פתח',
                          muiTableBodyCellProps: ({ row }) => ({
                              sx: (theme) => ({
                                  backgroundColor:
                                      row.depth === 0 ? '#1e293b' : 'inherit', // same tint as the row
                                  boxShadow: 'none',
                                  color: `${theme.palette.common.white} !important`,
                                  '& .MuiIconButton-root, & .MuiSvgIcon-root': {
                                      color: row.depth === 0 ? `${theme.palette.common.white} !important` : 'none',
                                  },
                                  // '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                                  //     color: 'rgba(255,255,255,0.35) !important',
                                  // },
                              }),
                          }),
                      }
                  }}
                  initialState={{
                    columnSizing: 40 ,
                    expanded: false,// gives “status” a 80px minimum
                    columnVisibility: {
                      // when hasGroups===false, this makes rowCount:hidden
                      rowCount: hasGroups,
                    },
                    sorting: [{ id: 'created_at', desc: true }],
                  }}
                  muiTableBodyRowProps={({ row }) => ({
                      sx: (theme) => {
                          const frozen = !!row.original?.is_frozen;
                          const frozenBg = alpha(theme.palette.action.disabledBackground, 0.3);
                          const normalBg = row.depth !== 0 ? rowBg(theme, row) : undefined;

                          return {
                              // paint every cell background
                              '& td': {
                                  backgroundColor: frozen ? `${frozenBg} !important` : normalBg,
                              },

                              // dim text/icons when frozen
                              // ...(frozen && {
                              //     '& *': { color: `${theme.palette.text.disabled} !important` },
                              // }),
                              // subtle left stripe (works RTL/LTR)
                              '& td:first-of-type': { position: 'relative' },
                              '& td:first-of-type::before': {
                                  content: '""',
                                  position: 'absolute',
                                  insetInlineStart: 4,
                                  top: 6,
                                  bottom: 6,
                                  width: 3,
                                  borderRadius: 2,
                                  backgroundColor: frozen
                                      ? theme.palette.error.main // make stripe red when frozen
                                      : (row.depth !== 0 ? theme.palette.info.main : 'transparent'),
                              },
                          };
                      },
                  })}
                  enableExpandAll={false}
                  onExpandedChange={async (updater) => {
                    const next = typeof updater === 'function' ? updater(expanded) : updater;
                    // 1) Optimistically expand immediately so the first click works
                    setExpanded(next);

                    // 2) Fire-and-forget: load children for rows that *just* expanded
                    const newlyExpandedCaseIds = Object.keys(next)
                        .filter((rowId) => next[rowId] && !expanded[rowId])
                        .map((rowId) => filteredEvents[Number(rowId)]?.case_id)
                        .filter(Boolean);

                    if (!newlyExpandedCaseIds.length) return;

                    (async () => {
                      const loaded = await Promise.all(
                          newlyExpandedCaseIds.map(async (caseId) => {
                            const events = await loadCaseEvents(caseId);
                            return { caseId, events };
                          })
                      );
                      setFilteredEvents((prev) =>
                          prev.map((c) => {
                            const hit = loaded.find((x) => x.caseId === c.case_id);
                            if (!hit) return c;
                            return {
                              ...c,
                              subRows: (c.subRows && c.subRows.length) ? c.subRows : hit.events,
                              events_count: hit.events.length,
                            };
                          })
                      );
                    })();
                  }}
                  // onPaginationChange={({ pageIndex, pageSize }) => {
                  //   if (page !== pageIndex) setPage(pageIndex);
                  //   if (rowsPerPage !== pageSize) {
                  //     // if you want page size selector:
                  //     // setRowsPerPage(pageSize)
                  //   }
                  // }}
                  muiPaginationProps={{
                    // optional: show 10/25/50 page size options
                    rowsPerPageOptions: [10, 25, 50, 100, 200],
                  }}
                  // state={{
                  //   isLoading: loading,
                  //   pagination: { pageIndex: page, pageSize: rowsPerPage },
                  //   expanded,
                  // }}
                  // initialState={{ pagination: { page, rowsPerPage } }}
                  // manualPagination={false}
                  // onPaginationChange={({ pageIndex, pageSize }) => {
                  //     setPageIndex(pageIndex);
                  //     setPageSize(pageSize);
                  // }}
                  muiBottomToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: darkMode ? '#fff' : '#1e293b',
                      ".MuiFormLabel-root": {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                      ".MuiSelect-icon": {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                      ".MuiSelect-select": {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                      ".MuiBox-root.MuiButtonBase-root" : {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                      ".MuiSvgIcon-root" : {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        // pick a dimmer color for disabled icons
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                    }
                  }}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: '#fff',
                      ".MuiSvgIcon-root" : {

                        color: darkMode ? '#fff' : '#1e293b',

                      },
                      // ".Mui-TableHeadCell": {
                      //     color: darkMode ? '#fff' : '#1e293b',
                      // },
                      ".MuiTableSortLabel-iconDirectionAsc": {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                      '& .MuiInputBase-input': {
                        color: darkMode ? '#fff' : '#1e293b',
                      }
                    },

                  }}
                  // ✔ כאן הצורה הנכונה
                  muiTableBodyCellProps={({ row, cell }) => {
                      // if (cell.column.id === 'mrt-row-select' && row.depth !== 0) {
                      //     return { style: { display: 'none' } };
                      // }
                      return {
                          sx: {
                              backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                              color: darkMode ? '#ffffff' : '#000',
                              '.MuiSvgIcon-root': {
                                  color: darkMode ? '#ffffff' : '#000',
                              },
                              maxWidth: '80px',
                          },
                      };
                  }}

                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                      color: "white",
                      fontWeight: "bold",
                      ".MuiSvgIcon-root" : {
                        color: darkMode ? "#ffffff" : "#000",
                      },
                      ".Mui-TableHeadCell-Content-Wrapper": {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                        '& .MuiSvgIcon-root': {
                            color: `${theme.palette.common.white} !important`,
                        },
                      // then specifically target the sort label icon:
                      '& .MuiTableSortLabel-icon': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      // likewise for iconDirectionAsc / iconDirectionDesc if needed
                      '& .MuiTableSortLabel-iconDirectionAsc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiTableSortLabel-iconDirectionDesc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        // pick a dimmer color for disabled icons
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                      '& .MuiInputBase-input': {
                        color: darkMode ? '#fff' : '#1e293b',
                      }
                    },
                  }}
                  muiTableHeadProps={{
                    sx: {
                      display: "table-header-group",
                      backgroundColor: "rgb(0,0,0)",
                      color: "white",
                      "&.Mui-TableHeadCell-Content-Wrapper": { color: "white" },
                    },
                  }}
                  muiTableContainerProps={{
                    sx: {
                      width: "100%",
                      // overflowX: "auto",
                      backgroundColor: "#15aff4",
                      color: "white",
                    },
                  }}
              />
                <BulkEditCasesDialog
                    open={bulkOpen}
                    onClose={() => setBulkOpen(false)}
                    selectedCases={bulkTargets}
                    onSave={handleBulkSave}
                    darkMode={darkMode}
                    STATUS_OPTIONS={STATUS_OPTIONS.map(o => o.value)} // array of strings
                    SUB_STATUS_BY_MAIN={SUB_STATUS}                  // map main → [subs]
                    DEPARTMENTS={DEPARTMENTS}
                    SUB_DEPARTMENTS={SUB_DEPTS_BY_DEPT}
                    userEmail={userEmail}
                />
              <Modal
                  open={showEditCaseModal}
                  onClose={() => {   setShowEditCaseModal(false);
                    setCaseForm(null);
                    setSuggest([]);          // close @-suggest popper
                    setAnchorEl(null);
                    setNoteBody('');
                  setNotes([]);
                  }}

                  // keepMounted
              >
                <Box
                    sx={{
                      position: 'fixed',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: { xs: '95vw', md: '85vw', lg: '75vw' },
                      maxHeight: '90vh',
                      bgcolor: paperBg,
                      color: textColor,
                      borderRadius: 2,
                      boxShadow: 24,
                      display: 'grid',
                      gridTemplateRows: 'auto 1fr auto',
                      overflow: 'hidden',
                    }}
                >
                  {/* HEADER */}
                  <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
                    <Typography variant="h5">עריכת תיק</Typography>
                  </Box>

                  {/* CONTENT */}
                  <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' }, // form | notes
                        gap: 2,
                        p: 2,
                        minHeight: 0,
                        // 👇 On phones: this is the ONLY scroller
                        // one scroller on phones, no inner overlap
                        overflowY: { xs: 'auto', md: 'hidden' },
                        WebkitOverflowScrolling: { xs: 'touch', md: 'auto' },
                        // 👇 Make each row size itself to its content so siblings don't stack on top of each other
                        gridAutoRows: 'minmax(min-content, auto)',
                        alignContent: 'start',
                      }}
                  >
                    {/* LEFT: FORM — scroller */}
                    <Box sx={{ overflowY: { xs: 'visible', md: 'auto' }, minHeight: 0 }}>
                      {caseForm && (
                          <Box component="form" id="edit-case-form" onSubmit={handleCaseSubmit}>
                            <Grid container sx={{mt:2}} spacing={2}>
                              {/* Left column */}
                              <Grid item xs={12} sm={4} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <TextField
                                    label="מספר רכב"
                                    name="car_id"
                                    required
                                    value={caseForm.car_id}
                                    onChange={handleCaseChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                />
                                <TextField
                                    label="שם פרטי"
                                    name="user_name"
                                    value={caseForm.user_name}
                                    onChange={handleCaseChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                />
                                <TextField
                                    label="שם משפחה"
                                    name="last_name"
                                    value={caseForm.last_name}
                                    onChange={handleCaseChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                />
                                <TextField
                                    label="כתובת"
                                    name="address"
                                    value={caseForm.address}
                                    onChange={handleCaseChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                />
                                <TextField
                                    label="טלפון"
                                    name="phone"
                                    value={caseForm.phone}
                                    onChange={handleCaseChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                />

                                <TextField
                                    label="תעודת זהות"
                                    name="national_id"
                                    value={caseForm.national_id}
                                    onChange={handleCaseChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                />
                                <TextField
                                    label="אימייל"
                                    name="email"
                                    type="email"
                                    value={caseForm.email}
                                    onChange={handleCaseChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                />
                                  <TextField
                                      label="מספר קריאה"
                                      name="call_number"
                                      value={caseForm.call_number || ""}
                                      onChange={handleCaseChange}
                                      fullWidth
                                      InputLabelProps={{ style: { color: textColor } }}
                                      InputProps={{
                                          sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } },
                                      }}
                                      sx={{ mt: 1 }}
                                  />

                                  <TextField
                                      label="מספר חשבונית"
                                      name="invoice_number"
                                      value={caseForm.invoice_number || ""}
                                      onChange={handleCaseChange}
                                      fullWidth
                                      InputLabelProps={{ style: { color: textColor } }}
                                      InputProps={{
                                          sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } },
                                      }}
                                      sx={{ mt: 1 }}
                                  />
                              </Grid>

                              {/* Middle column */}
                              <Grid item xs={12} sm={4} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <TextField
                                    label="דמי משפטי"
                                    name="legal_fees"
                                    type="number"
                                    value={caseForm.legal_fees}
                                    onChange={handleCaseChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                />
                                <TextField
                                    label="דמי איתור"
                                    name="locating_fees"
                                    type="number"
                                    value={caseForm.locating_fees}
                                    onChange={handleCaseChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                />
                                <TextField
                                    label="דמי טיפול"
                                    name="handling_fees"
                                    type="number"
                                    value={caseForm.handling_fees}
                                    onChange={handleCaseChange}
                                    fullWidth
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                />
                                <TextField
                                    label="מחיר הקרן"
                                    // name="handling_fees"
                                    type="number"
                                    value={caseForm.principal_amount}
                                    // onChange={handleCaseChange}
                                    fullWidth
                                    readOnly
                                    InputLabelProps={{ style: { color: textColor } }}
                                    InputProps={{   readOnly: true,sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                />
                                <TextField
                                    label="סכום כולל"
                                    name="override_total_amount"
                                    type="number"
                                    value={caseForm.override_total_enabled ? caseForm.override_total_amount : caseForm.total_amount}
                                    onChange={handleCaseChange}
                                    fullWidth
                                    disabled={!caseForm.override_total_enabled}
                                    // readOnly={!caseForm.override_total_enabled}
                                    InputLabelProps={{
                                      sx: {
                                        color: textColor,                     // normal
                                        '&.Mui-disabled': {
                                          color: '#fff',                      // your disabled color
                                          opacity: 1,                         // <-- remove the disabled fade
                                        },
                                      },
                                    }}
                                    InputProps={{  sx: {   color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
                                        '&.Mui-disabled': { opacity: 1 },

                                        // 🔥 the important part — target the actual input element with higher specificity
                                        '& input.MuiInputBase-input.Mui-disabled': {
                                          WebkitTextFillColor: '#fff !important',
                                          color: '#fff !important',
                                          opacity: 1,
                                        },

                                      } }}
                                />
                                <FormControlLabel
                                    control={
                                      <Checkbox
                                          checked={!!caseForm.override_total_enabled}
                                          onChange={(e) =>
                                              setCaseForm(prev => ({ ...prev, override_total_enabled: e.target.checked ? 1 : 0 }))
                                          }
                                      />
                                    }
                                    label="שינוי מחיר כולל"
                                />

                                <FormControl fullWidth>
                                  <InputLabel sx={{ color: textColor }}>סטטוס</InputLabel>
                                  <Select
                                      label="סטטוס"
                                      name="main_status"
                                      value={caseForm.main_status}
                                      onChange={handleCaseChange}
                                      sx={{ height: 44, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } }}
                                  >
                                    {ALL_STATUS_STEPS.map((s) => (
                                        <MenuItem key={s} value={s}>{s}</MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>

                                {<FormControl fullWidth>
                                  <InputLabel sx={{ color: textColor }}>תת סטטוס:</InputLabel>
                                  <Select
                                      label="תת סטטוס"
                                      name="sub_status"
                                      value={caseForm.sub_status}

                                      onChange={handleCaseChange}
                                      sx={{ height: 44, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } }}
                                  >
                                    {SUB_STATUS[caseForm.main_status].map((s) => (
                                        <MenuItem key={s} value={s}>{s}</MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>}

                          {/*      {*/}
                          {/*          <>*/}
                          {/*          <FormControlLabel*/}
                          {/*          control={*/}
                          {/*            <Checkbox*/}
                          {/*                name="registered_mail_uploaded"*/}
                          {/*                checked={Boolean(caseForm.registered_mail_uploaded)}*/}
                          {/*                onChange={handleCaseChange}*/}
                          {/*                sx={{ color: textColor }}*/}
                          {/*            />*/}
                          {/*          }*/}
                          {/*          label="הועלה העתק המכתב לתיק"*/}
                          {/*      />*/}
                          {/*        <FormControlLabel*/}
                          {/*        control={*/}
                          {/*        <Checkbox*/}
                          {/*        name="registered_mail_delivered_ok"*/}
                          {/*        checked={Boolean(caseForm.registered_mail_delivered_ok)}*/}
                          {/*      onChange={handleCaseChange}*/}
                          {/*      sx={{ color: textColor }}*/}
                          {/*    />*/}
                          {/*    }*/}
                          {/*    label="המכתב נמסר"*/}
                          {/*  />*/}

                          {/*</>*/}
                          {/*      }*/}

                                <TextField
                                    label="תאריך סגירה"
                                    name="end_date"
                                    type="datetime-local"
                                    value={caseForm.end_date || ""}
                                    onChange={handleCaseChange}
                                    InputLabelProps={{ shrink: true, style: { color: textColor } }}
                                    InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                    fullWidth
                                />
                              </Grid>

                              {/* Right column */}
                              <Grid item xs={12} sm={4} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                  <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                                      <InputLabel>מחלקה</InputLabel>
                                      <Select
                                          label="מחלקה"
                                          value={caseForm.department || ''}
                                          sx={{height:44}}
                                          onChange={(e) => setCaseForm(f => ({
                                              ...f,
                                              department: e.target.value,
                                              // clear sub + handler if dept changed away from 'תפעול'
                                              sub_department: '',
                                              internal_handler: e.target.value === 'תפעול' ? (f.internal_handler || '') : ''
                                          }))}
                                      >
                                          {DEPARTMENTS.map(d => <MenuItem key={d} value={d}>{d}</MenuItem>)}
                                      </Select>
                                  </FormControl>
                                  {caseForm.department !=='משפטי' && caseForm.lawyer_backup && <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                                      <TextField
                                          label="עורך דין"
                                          name="lawyer_backup"
                                          type="text"
                                          value={caseForm.lawyer_backup || ""}
                                          readOnly
                                          InputLabelProps={{ style: { color: textColor } }}
                                          InputProps={{   readOnly: true,sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                                  fullWidth
                                      />
                                  </FormControl>}
                                  {caseForm.department !=='חוקר' && caseForm.investigator_backup && <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                                      <TextField
                                          label="חוקר"
                                          name="investigator_backup"
                                          type="text"
                                          value={caseForm.investigator_backup || ""}
                                          readOnly
                                          InputLabelProps={{ style: { color: textColor } }}
                                          InputProps={{   readOnly: true,sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                          fullWidth
                                      />
                                  </FormControl>}
                                  <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                                      <InputLabel>גורם מטפל</InputLabel>
                                      <Select
                                          label="גורם מטפל"
                                          value={caseForm.sub_department || ''}
                                          sx={{height:44}}
                                          onChange={(e) => setCaseForm(f => ({ ...f, sub_department: e.target.value }))}
                                          disabled={!caseForm.department}
                                      >
                                          {(SUB_DEPTS_BY_DEPT[caseForm.department] || []).map(sd => (
                                              <MenuItem key={sd} value={sd}>{sd}</MenuItem>
                                          ))}
                                      </Select>
                                  </FormControl>

                                  {/* For חוקר: show free-text boxes when 'אחר 1' / 'אחר 2' chosen */}
                                  {caseForm.department === 'חוקר' && (caseForm.sub_department!=="עמית לוגסי") && (
                                      <TextField
                                          fullWidth
                                          size="small"
                                          sx={{ mt: 1 }}
                                          label="גורם מטפל"
                                          value={caseForm.sub_department || ''}
                                          onChange={(e) => setCaseForm(f => ({
                                              ...f,
                                              // decide: either keep in a separate field, or override sub_department with free text:
                                              sub_department: e.target.value,
                                          }))}
                                      />
                                  )}
                                <InternalHandlerField caseForm={caseForm} setCaseForm={setCaseForm} />
                                <FormControlLabel
                                    control={
                                      <Checkbox
                                          name="with_discount"
                                          checked={Boolean(caseForm.with_discount)}
                                          onChange={handleCaseChange}
                                          sx={{ color: textColor }}
                                      />
                                    }
                                    label="הנחה"
                                />

                                {Boolean(caseForm.with_discount) && (
                                    <TextField
                                        label="סכום הנחה"
                                        name="payment_discount"
                                        type="number"
                                        value={caseForm.payment_discount ?? ""}
                                        onChange={handleCaseChange}
                                        fullWidth
                                        error={Boolean(discountError)}
                                        helperText={discountError}
                                        InputLabelProps={{ style: { color: textColor } }}
                                        InputProps={{ sx: { color: textColor, "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } } }}
                                    />
                                )}
                                <TextField
                                    label="שולם"
                                    type="number"
                                    value={caseForm.paid ?? 0}
                                    onChange={onPaidChange}
                                    inputProps={{ min: 0, step: 1 }}
                                    helperText="סך הכל ששולם עד כה"
                                    FormHelperTextProps={{
                                      sx: { color: textColor }   // any css color / theme token
                                    }}
                                />

                                <TextField
                                    label="כמות תשלומים"
                                    type="number"
                                    value={caseForm.number_of_payments ?? 1}
                                    onChange={onNopChange}
                                    inputProps={{ min: 1, max: 18, step: 1 }}
                                    helperText="1–18"
                                    FormHelperTextProps={{
                                      sx: { color: textColor }   // any css color / theme token
                                    }}                            />

                              </Grid>
                              <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ mt: 1, mb: 1 }}>
                                  קבצי תיק
                                </Typography>

                                <input
                                    type="file"
                                    multiple
                                    onChange={handleCaseFileChange}
                                    disabled={loadingFiles}
                                    style={{ opacity: loadingFiles ? 0.6 : 1 }}
                                />

                                <Box sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 2,
                                  maxHeight: 220,
                                  overflowY: "auto",
                                  p: 1,
                                  mt: 1,
                                  border: `1px solid ${darkMode ? "#444" : "#ccc"}`,
                                  borderRadius: 1
                                }}>
                                  {/* existing case attachments */}
                                  {caseForm.attachments?.map((att, idx) => (
                                      <Box key={`case-existing-${idx}`} sx={{ position: "relative" }}>
                                        {att.url && att.type?.includes("image") ? (
                                            <img src={att.thumbUrl || att.url} alt={att.fileName} style={{ width: 100, height: 100, objectFit: "cover" }} />
                                        ) : att.url && att.type?.includes("video") ? (
                                            <video src={att.url} style={{ width: 100, height: 100 }} controls />
                                        ) : (
                                            <Button variant="text" onClick={() => window.open(att.url, "_blank")}>
                                              {att.fileName}
                                            </Button>
                                        )}
                                        <IconButton
                                            size="small"
                                            onClick={() => handleRemoveCaseAttachment(idx, false)}
                                            sx={{
                                              position: "absolute", top: -8, right: -8,
                                              backgroundColor: "rgba(255,255,255,0.8)",
                                              "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                                            }}
                                        >
                                          <CloseIcon fontSize="small" />
                                        </IconButton>
                                      </Box>
                                  ))}

                                  {/* newly added (not yet uploaded) */}
                                  {caseForm.newCaseAttachments?.map((att, idx) => (
                                      <Box key={`case-new-${idx}`} sx={{ position: "relative" }}>
                                        {att.previewUrl && att.type?.includes("image") ? (
                                            <img src={att.previewUrl} alt={att.name} style={{ width: 100, height: 100, objectFit: "cover" }} />
                                        ) : att.previewUrl && att.type?.includes("video") ? (
                                            <video src={att.previewUrl} style={{ width: 100, height: 100 }} controls />
                                        ) : (
                                            <Button variant="text">{att.name}</Button>
                                        )}
                                        <IconButton
                                            size="small"
                                            onClick={() => handleRemoveCaseAttachment(idx, true)}
                                            sx={{
                                              position: "absolute", top: -8, right: -8,
                                              backgroundColor: "rgba(255,255,255,0.8)",
                                              "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                                            }}
                                        >
                                          <CloseIcon fontSize="small" />
                                        </IconButton>
                                      </Box>
                                  ))}
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                      )}
                    </Box>

                    {/* RIGHT: NOTES — capped + scrollable */}
                    <Card
                        elevation={2}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          minHeight: 0,
                          // 👇 Only let it fill the column on desktop; on phones it should just flow
                          maxHeight: { xs: 'none', md: '100%' },
                          // Make sure it participates in normal document flow on xs
                          flex: { xs: '0 0 auto', md: '1 1 auto' },
                          position: 'relative',
                          zIndex: 0,
                          backgroundColor: paperBg,
                        }}
                    >
                      <Box sx={{ p: 1.5, pb: 1 }}>
                        <Typography variant="h6">הערות תיק</Typography>
                      </Box>
                      <Divider />

                      {/* LIST (scrolls, capped height on mobile too) */}
                      <Box
                          sx={{
                            p: 1.5,
                            // 👇 On phones: no inner scroll, just flows after fields
                            flex:        { xs: '0 0 auto', md: 1 },
                            minHeight:   { xs: 'auto',     md: 0 },
                            overflowY:   { xs: 'visible',  md: 'auto' },
                            // optional desktop cap:
                            maxHeight:   { xs: 'none',     md: '28vh' },

                          }}
                      >
                        {notesLoading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                                  <CircularProgress />
                                </Box>
                            )
                            :

                            notes.length === 0 ? (
                                <Typography variant="body2" sx={{ opacity: 0.7, color: textColor }}>-</Typography>
                            ) : (
                                <Stack spacing={1.25}>
                                  {notes.map((n) => (
                                      <Paper key={n.id} variant="outlined" sx={{ p: 1, borderRadius: 1.5 }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5, flexWrap: 'wrap' }}>
                                          <Typography variant="caption" sx={{ fontWeight: 600 }}>
                                            {n.author_name || n.author_email}
                                          </Typography>
                                          <Typography variant="caption" sx={{ opacity: 0.7 }}>
                                            · {fmtIL(n.created_at_ms)}
                                          </Typography>
                                        </Stack>
                                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', direction: "rtl" }}>{n.body}</Typography>
                                      </Paper>
                                  ))}
                                </Stack>
                            )}
                      </Box>

                      <Divider />

                      {/* EDITOR (does NOT grow) */}
                      <Box sx={{ p: 1.5, flexShrink: 0 }}>
                        <TextField
                            label="כתוב הערה, ניתן לתייג מישהו בעזרת @"
                            value={noteBody}
                            onChange={onNoteChange}
                            fullWidth
                            multiline
                            minRows={4}
                            sx={{ '& .MuiInputBase-root': { alignItems: 'flex-start' } }}
                            inputProps={{
                              dir: 'rtl',               // force RTL typing
                              style: { direction: 'rtl', textAlign: 'right' },
                            }}
                        />
                        <Popper
                            open={Boolean(suggest.length && anchorEl)}
                            anchorEl={anchorEl}
                            placement="top-start"
                            disablePortal={false}                         // ← render into a portal
                            container={document.body}                     // ← ensure it’s outside overflow areas
                            modifiers={[
                              { name: 'offset', options: { offset: [0, 8] } },
                              { name: 'preventOverflow', options: { boundary: 'viewport' } },
                            ]}
                            sx={(theme) => ({
                              zIndex: theme.zIndex.modal + 2,            // ← above the modal content
                              width: anchorEl ? anchorEl.clientWidth : undefined,
                            })}
                        >
                          <Paper elevation={3}>
                            <List dense sx={{ maxHeight: 240, overflowY: 'auto' }}>
                              {suggest.map(u => (
                                  <ListItem
                                      key={u.email || u.username}
                                      onMouseDown={(e) => e.preventDefault()} // keep focus in textarea
                                      onClick={() => applyMention(u)}
                                      sx={{ px: 1.5, py: 0.75, cursor: 'pointer' }}
                                  >
                                    <ListItemText
                                        primary={u.email || u.username}
                                        secondary={[u.given_name, u.family_name].filter(Boolean).join(' ')}
                                    />
                                  </ListItem>
                              ))}
                            </List>
                          </Paper>
                        </Popper>
                        <Box sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end' }}>
                          <Button variant="contained" onClick={saveNote}>הוסף הערה</Button>
                        </Box>
                      </Box>
                    </Card>
                  </Box>

                  {/* FOOTER (always visible) */}
                  <Box
                      sx={{
                        p: 2,
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: 1,
                        bgcolor: paperBg,
                      }}
                  >
                    <Button variant="outlined" onClick={() => { setShowEditCaseModal(false);
                      setCaseForm(null);
                      setSuggest([]);          // close @-suggest popper
                      setAnchorEl(null);
                        setNotes([]); // optional fallback
                      setNoteBody('');  }}>
                      בטל
                    </Button>
                    <Button disabled={(Boolean(discountError) && caseForm?.with_discount)} variant="contained" type="submit" form="edit-case-form">
                      שמור
                    </Button>
                  </Box>
                </Box>
              </Modal>

              <Modal open={showLogsModal} onClose={handleCloseLogsModal}>
                <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",

                      bgcolor: paperBg,
                      color: textColor,
                      p: 2,

                      // responsive width:
                      width: isXs ? "90%" : 1000,
                      // cap height & enable scrolling:
                      maxHeight: isXs ? "90vh" : "auto",
                      overflowY: isXs ? "auto" : "visible",

                      borderRadius: 2,
                    }}
                >
                  <Typography variant="h5" mb={2}>
                    לוגים
                  </Typography>

                  <TableContainer component={Paper} sx={{ backgroundColor: darkMode ? "#1F2739" : "#ffffff" }}>
                    <Table>
                      <TableHead sx={{ display: "table-header-group" }}>
                        <TableRow>
                          <TableCell
                              sx={{
                                color: darkMode ? "#ffffff" : "#000000",
                                fontWeight: "bold",
                                fontSize: "0.95rem",
                                padding: "12px 16px",
                              }}
                          >
                           מזהה משתמש
                          </TableCell>
                          <TableCell
                              sx={{
                                color: darkMode ? "#ffffff" : "#000000",
                                fontWeight: "bold",
                                fontSize: "0.95rem",
                                padding: "12px 16px",
                              }}
                          >
                            מספר רכב
                          </TableCell>
                          <TableCell
                              sx={{
                                color: darkMode ? "#ffffff" : "#000000",
                                fontWeight: "bold",
                                fontSize: "0.95rem",
                                padding: "12px 16px",
                              }}
                          >
                            זמן
                          </TableCell>
                          <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                            כיוון
                          </TableCell>
                          <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                            שם הנתיב
                          </TableCell>
                          <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                            זמן שהות
                          </TableCell>
                          <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                            תמונת רכב
                          </TableCell>
                          <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                            סיבה
                          </TableCell>
                          <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                            מחיר
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedLogs
                            .slice(logsPage * logsPerPage, logsPage * logsPerPage + logsPerPage)
                            .map((log, idx) => (
                                <TableRow key={idx}>
                                  {/* Show user id instead of Num */}
                                  <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                                    {log.userId}
                                  </TableCell>
                                  {/* Show plate number */}
                                  <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                                    {log.carId}
                                  </TableCell>
                                  {/* Format and show the timestamp */}
                                  <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                                    {formatTimestamp(log.ts)}
                                  </TableCell>
                                  <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                                    {log.direction || (log.inLog?.direction ?? "")}
                                  </TableCell>
                                  <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                                    {log.laneName || (log.inLog?.laneName ?? "")}
                                  </TableCell>
                                  {/* Convert duration (seconds) into hh:mm:ss format */}
                                  <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                                    {log.stayTime ? formatDuration(log.stayTime) : "-"}
                                  </TableCell>
                                  {/* Render the car image using an img tag */}
                                  <TableCell>
                                    {log.imageUrl ? (
                                        <img src={log.imageUrl} alt="Car" style={{ width: 80, height: "auto" }}    onClick={() =>
                                            handleOpenMedia({ url: log.imageUrl, type: "image", name: "Car Image" })
                                        } />
                                    ) : (
                                        "-"
                                    )}
                                  </TableCell>
                                  <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                                    {log.reason ? log.reason : "-"}
                                  </TableCell>
                                  <TableCell sx={{ color: darkMode ? "#ffffff" : "#000000" }}>
                                    {log.price != null ? `₪${formatCurrency(log.price)}` : "-"}
                                  </TableCell>
                                </TableRow>
                            ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[6]}
                        component="div"
                        count={selectedLogs.length}
                        rowsPerPage={logsPerPage}
                        page={logsPage}
                        onPageChange={handleLogsPageChange}
                        sx={{ color: darkMode ? "#ffffff" : "#000000" }}
                    />
                  </TableContainer>

                  <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button variant="contained" onClick={handleCloseLogsModal}>
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
                <Modal
                    open={confirmDelete.open}
                    onClose={() => setConfirmDelete({ open: false, event: null })}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            bgcolor: paperBg,
                            boxShadow: 24,
                            borderRadius: 2,
                            p: 3,
                            minWidth: 380,
                        }}
                    >
                        <DialogTitle sx={{ fontWeight: 700, textAlign: "center" }}>
                            מחיקת אירוע
                        </DialogTitle>

                        <DialogContent sx={{ mt: 1 }}>
                            {confirmDelete.event && (
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mb: 2,
                                    direction: "rtl",
                                    textAlign: "right",
                                }}>
                                    <Typography variant="body2">
                                        <strong>חניון:</strong> {confirmDelete.event.place || "-"}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>זמן האירוע:</strong>{" "}
                                        {confirmDelete.event.time_of_event
                                            ? fmtDT(confirmDelete.event.time_of_event)
                                            : "-"}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>סוג האירוע:</strong> {confirmDelete.event.event_type || "-"}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>סכום לתשלום:</strong>{" "}
                                        {formatCurrency(
                                            confirmDelete.event.with_discount
                                                ? (confirmDelete.event.payment_amount || 0) -
                                                (confirmDelete.event.payment_discount || 0)
                                                : confirmDelete.event.payment_amount || 0
                                        )}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>תיאור האירוע:</strong>{" "}
                                        {confirmDelete.event.event_description || "-"}
                                    </Typography>
                                </Box>
                            )}

                            <DialogContentText>
                                האם אתה בטוח שברצונך למחוק אירוע זה? פעולה זו אינה ניתנת לביטול.
                            </DialogContentText>
                        </DialogContent>

                        <DialogActions sx={{ justifyContent: "space-between", mt: 2 }}>
                            <Button
                                onClick={() => setConfirmDelete({ open: false, event: null })}
                                variant="outlined"
                            >
                                ביטול
                            </Button>
                            <Button
                                onClick={async () => {
                                    if (!confirmDelete.event) return;
                                    await handleDeleteEvent(confirmDelete.event);
                                    setConfirmDelete({ open: false, event: null });
                                }}
                                variant="outlined"
                                color="error"
                            >
                                מחק אירוע
                            </Button>
                        </DialogActions>
                    </Box>
                </Modal>
              {/* ADD EVENT MODAL */}
              <Modal open={showAddModal} onClose={handleCloseAddModal}>
                <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",

                      bgcolor: paperBg,
                      color: textColor,
                      p: 2,

                      // responsive width:
                      width: isXs ? "90%" : 600,
                      // cap height & enable scrolling:
                      maxHeight: isXs ? "90vh" : "auto",
                      overflowY: isXs ? "auto" : "visible",

                      borderRadius: 2,
                    }}
                >
                  <Typography variant="h5" mb={2}>
                    הוסף אירוע חדש
                  </Typography>
                  <Box component="form" onSubmit={handleAddEventSubmit}>
                    <Grid container spacing={2}>
                      {/* Left Column: Basic Details */}
                      <Grid item xs={6}     sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2, // each child gets 16px (2 * theme.spacing(1)) of vertical spacing
                      }}>
                        <TextField
                            label="מספר רכב"
                            name="carId"
                            variant="outlined"
                            required
                            value={formData.carId}
                            onChange={handleAddEventChange}
                            fullWidth
                            InputLabelProps={{ style: { color: textColor } }}
                            InputProps={{
                              sx: {
                                "& input:-webkit-autofill": {
                                  boxShadow: "0 0 0 100px #1A2035 inset",
                                  WebkitTextFillColor: "#fff",
                                },
                                color: textColor,
                                gap: 2,
                                "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                              },
                            }}
                        />
                        <AsyncSearch
                            value={formData.place}
                            onValueChange={(pname, pid) => handleAddEventChangePlace(pname, pid)}
                        />
                        {/*<TextField*/}
                        {/*    label="Address"*/}
                        {/*    name="address"*/}
                        {/*    variant="outlined"*/}
                        {/*    value={formData.address}*/}
                        {/*    onChange={handleAddEventChange}*/}
                        {/*    fullWidth*/}
                        {/*    InputLabelProps={{ style: { color: textColor } }}*/}
                        {/*    InputProps={{*/}
                        {/*      sx: {*/}
                        {/*        "& input:-webkit-autofill": {*/}
                        {/*          boxShadow: "0 0 0 100px #1A2035 inset",*/}
                        {/*          WebkitTextFillColor: "#fff",*/}
                        {/*        },*/}
                        {/*        gap: 2,*/}
                        {/*        color: textColor,*/}
                        {/*        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },*/}
                        {/*      },*/}
                        {/*    }}*/}
                        {/*/>*/}
                        <TextField
                            label="זמן האירוע"
                            name="dateTime"
                            type="datetime-local"
                            required
                            value={formData.dateTime}
                            onChange={handleAddEventChange}
                            InputLabelProps={{ shrink: true, style: { color: textColor } }}
                            InputProps={{
                              sx: {
                                "& input:-webkit-autofill": {
                                  boxShadow: "0 0 0 100px #1A2035 inset",
                                  WebkitTextFillColor: "#fff",
                                },
                                gap: 2,
                                color: textColor,
                                "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                              },
                            }}
                            fullWidth
                        />

                        {/*<TextField*/}
                        {/*    label="User Name"*/}
                        {/*    name="userName"*/}
                        {/*    variant="outlined"*/}
                        {/*    value={formData.userName}*/}
                        {/*    onChange={handleAddEventChange}*/}
                        {/*    fullWidth*/}
                        {/*    InputLabelProps={{ style: { color: textColor } }}*/}
                        {/*    InputProps={{*/}
                        {/*      sx: {*/}
                        {/*        "& input:-webkit-autofill": {*/}
                        {/*          boxShadow: "0 0 0 100px #1A2035 inset",*/}
                        {/*          WebkitTextFillColor: "#fff",*/}
                        {/*        },*/}
                        {/*        gap: 2,*/}
                        {/*        color: textColor,*/}
                        {/*        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },*/}
                        {/*      },*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {/*<TextField*/}
                        {/*    label="Phone"*/}
                        {/*    name="phone"*/}
                        {/*    type="tel"*/}
                        {/*    variant="outlined"*/}
                        {/*    value={formData.phone}*/}
                        {/*    onChange={handleAddEventChange}*/}
                        {/*    fullWidth*/}
                        {/*    InputLabelProps={{ style: { color: textColor } }}*/}
                        {/*    InputProps={{*/}
                        {/*      sx: {*/}
                        {/*        "& input:-webkit-autofill": {*/}
                        {/*          boxShadow: "0 0 0 100px #1A2035 inset",*/}
                        {/*          WebkitTextFillColor: "#fff",*/}
                        {/*        },*/}
                        {/*        gap: 2,*/}
                        {/*        color: textColor,*/}
                        {/*        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },*/}
                        {/*      },*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {/*<TextField*/}
                        {/*    label="ID (National ID)"*/}
                        {/*    name="nationalId"*/}
                        {/*    variant="outlined"*/}
                        {/*    value={formData.nationalId}*/}
                        {/*    onChange={handleAddEventChange}*/}
                        {/*    fullWidth*/}
                        {/*    InputLabelProps={{ style: { color: textColor } }}*/}
                        {/*    InputProps={{*/}
                        {/*      sx: {*/}
                        {/*        "& input:-webkit-autofill": {*/}
                        {/*          boxShadow: "0 0 0 100px #1A2035 inset",*/}
                        {/*          WebkitTextFillColor: "#fff",*/}
                        {/*        },*/}
                        {/*        gap: 2,*/}
                        {/*        color: textColor,*/}
                        {/*        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },*/}
                        {/*      },*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {/*<TextField*/}
                        {/*    label="Email"*/}
                        {/*    name="email"*/}
                        {/*    type="email"*/}
                        {/*    variant="outlined"*/}
                        {/*    value={formData.email}*/}
                        {/*    onChange={handleAddEventChange}*/}
                        {/*    fullWidth*/}
                        {/*    InputLabelProps={{ style: { color: textColor } }}*/}
                        {/*    InputProps={{*/}
                        {/*      sx: {*/}
                        {/*        "& input:-webkit-autofill": {*/}
                        {/*          boxShadow: "0 0 0 100px #1A2035 inset",*/}
                        {/*          WebkitTextFillColor: "#fff",*/}
                        {/*        },*/}
                        {/*        gap: 2,*/}
                        {/*        color: textColor,*/}
                        {/*        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },*/}
                        {/*      },*/}
                        {/*    }}*/}
                        {/*/>*/}
                        <FormControl variant="outlined">
                          <InputLabel
                              fullWidth
                              sx={{
                                color: textColor,                     // default color
                              }}
                              id="event-type-label"
                          >
                            סוג אירוע
                          </InputLabel>
                          <Select
                              value={formData?.event_type || ""}
                              onChange={handleAddEventChange}
                              // displayEmptyF
                              label="סוג אירוע"
                              name="event_type"
                              style={{ textAlign: "left" }}
                              sx={{height:44}}
                              id="event-type-select"
                              renderValue={(val) =>
                                  val
                                  && <span style={{ backgroundColor: getEventTypeColor(val, darkMode, "#27293d") }}>{val}</span>

                              }
                          >
                            {eventTypeOptions.map((event) => (
                                <MenuItem
                                    key={event}
                                    value={event} // Storing the entire object
                                    sx={{
                                      backgroundColor: getEventTypeColor(event, darkMode, "#27293d")
                                    }}
                                >
                                  {event}
                                </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                          {["תאונה", "נזק"].includes(formData.event_type) && (
                              <>
                                  <TextField
                                      fullWidth
                                      margin="dense"
                                      label="מספר קריאה"
                                      name="call_number"
                                      value={formData.call_number}
                                      onChange={handleAddEventChange}
                                      size="small"
                                  />
                                  <TextField
                                      fullWidth
                                      margin="dense"
                                      label="מספר חשבונית"
                                      name="invoice_number"
                                      value={formData.invoice_number}
                                      onChange={handleAddEventChange}
                                      size="small"
                                  />
                              </>
                          )}
                        {/*<FormControl variant="outlined">*/}
                        {/*  <InputLabel*/}
                        {/*      fullWidth*/}
                        {/*      sx={{*/}
                        {/*        color: textColor,                     // default color*/}
                        {/*      }}*/}
                        {/*      id="event-type-label"*/}
                        {/*  >*/}
                        {/*    handling lawyer*/}
                        {/*  </InputLabel>*/}
                        {/*  <Select*/}
                        {/*      value={formData?.handling_lawyer || ""}*/}
                        {/*      onChange={handleAddEventChange}*/}
                        {/*      // displayEmpty*/}
                        {/*      label="handling lawyer"*/}
                        {/*      name="handling_lawyer"*/}
                        {/*      style={{ textAlign: "left" }}*/}
                        {/*      sx={{height:44}}*/}
                        {/*      id="handling_lawyer-select"*/}

                        {/*  >*/}
                        {/*    {HANDLING_LAWYERS.map((lawyer) => (*/}
                        {/*        <MenuItem*/}
                        {/*            key={lawyer}*/}
                        {/*            value={lawyer} // Storing the entire object*/}
                        {/*            sx={{*/}
                        {/*              backgroundColor: getEventTypeColor(event, darkMode, "#27293d")*/}
                        {/*            }}*/}
                        {/*        >*/}
                        {/*          {lawyer}*/}
                        {/*        </MenuItem>*/}
                        {/*    ))}*/}
                        {/*  </Select>*/}
                        {/*</FormControl>*/}
                      </Grid>

                      {/* Right Column: Descriptions & Attachments */}
                      <Grid item xs={6} >
                        <TextField
                            label="סכום לתשלום"
                            name="payment_amount"
                            type="number"
                            value={formData.payment_amount || 0}
                            onChange={handleAddEventChange}
                            fullWidth
                            InputLabelProps={{ style: { color: textColor } }}
                            InputProps={{
                              sx: {
                                color: textColor,
                                "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                              },
                            }}
                        />

                        {/*<FormControl sx={{mt: 2}} fullWidth>*/}
                        {/*  <InputLabel sx={{ color: textColor }}>Status</InputLabel>*/}
                        {/*  <Select*/}
                        {/*      label="Status"*/}
                        {/*      name="main_status"*/}
                        {/*      value={formData.main_status || 'ראשוני'}*/}
                        {/*      onChange={handleAddEventChange}*/}
                        {/*      sx={{ height: "45px", "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor } }}*/}
                        {/*  >*/}
                        {/*    {ALL_STATUS_STEPS.map((s) => (*/}
                        {/*        <MenuItem key={s} value={s}>{s}</MenuItem>*/}
                        {/*    ))}*/}
                        {/*  </Select>*/}
                        {/*</FormControl>*/}
                        <TextField
                            label="תיאור האירוע"
                            name="eventDescription"
                            multiline
                            rows={6} // Increased rows for longer text
                            required
                            value={formData.eventDescription}
                            onChange={handleAddEventChange}
                            fullWidth
                            InputLabelProps={{ style: { color: textColor } }}
                            InputProps={{
                              sx: {
                                mt: 2,
                                "& input:-webkit-autofill": {
                                  boxShadow: "0 0 0 100px #1A2035 inset",
                                  WebkitTextFillColor: "#fff",
                                },
                                color: textColor,
                                "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                              },
                            }}
                        />
                        <TextField
                            label="תיאור הנזק"
                            name="damageDescription"
                            multiline
                            rows={6} // Increased rows for longer text
                            value={formData.damageDescription}
                            onChange={handleAddEventChange}
                            fullWidth
                            InputLabelProps={{ style: { color: textColor } }}
                            InputProps={{
                              sx: {
                                "& input:-webkit-autofill": {
                                  boxShadow: "0 0 0 100px #1A2035 inset",
                                  WebkitTextFillColor: "#fff",
                                },
                                color: textColor,
                                "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                              },
                            }}
                            sx={{ mt: 2 }}
                        />
                        {/*<Box mt={2}>*/}
                        {/*  <Typography mb={1}>Attachments</Typography>*/}
                        {/*  <input*/}
                        {/*      type="file"*/}
                        {/*      multiple*/}
                        {/*      onChange={handleFileChange}*/}
                        {/*      disabled={loadingFiles}*/}
                        {/*      style={{ opacity: loading ? 0.5 : 1 }}*/}
                        {/*  />*/}

                        {/*  {loadingFiles && (*/}
                        {/*      <CircularProgress*/}
                        {/*          variant="indeterminate"*/}
                        {/*          disableShrink*/}
                        {/*          sx={(theme) => ({*/}
                        {/*            color: '#1a90ff',*/}
                        {/*            animationDuration: '550ms',*/}
                        {/*            // display: "flex",*/}
                        {/*            // justifyContent: "center",*/}
                        {/*            // alignItems: "center",*/}
                        {/*            // left: 0,*/}
                        {/*            [`& .${circularProgressClasses.circle}`]: {*/}
                        {/*              strokeLinecap: 'round',*/}
                        {/*            },*/}
                        {/*            ...theme.applyStyles('dark', {*/}
                        {/*              color: '#308fe8',*/}
                        {/*            }),*/}
                        {/*          })}*/}
                        {/*          size={40}*/}
                        {/*          thickness={4}*/}
                        {/*      />*/}
                        {/*  )}                                    </Box>*/}
                      </Grid>
                    </Grid>
                    <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>

                      <Button variant="outlined" onClick={handleCloseAddModal}>
                        בטל
                      </Button>
                      <Button disabled={loadingFiles} type="submit" variant="contained" color="primary">
                        שמור
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Modal>

              {/* VIEW DETAILS MODAL */}

              <Modal open={showEditModal} onClose={() => { setShowEditModal(false); setEditFormData(null); }}>
                <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",

                      bgcolor: paperBg,
                      color: textColor,
                      p: 2,

                      // responsive width:
                      width: isXs ? "90%" : 600,
                      // cap height & enable scrolling:
                      maxHeight: isXs ? "90vh" : "auto",
                      overflowY: isXs ? "auto" : "visible",

                      borderRadius: 2,
                    }}
                >
                  <Typography variant="h5" mb={2}>
                    עריכת אירוע
                  </Typography>
                  {editFormData && (
                      <Box component="form" onSubmit={handleEditEventSubmit}>
                        <Grid container spacing={2}>
                          {/* Left Column: Basic Details */}
                          <Grid item xs={12} sm={4} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <TextField
                                label="חניון"
                                name="place"
                                variant="outlined"
                                required
                                value={editFormData.place || ""}
                                onChange={handleEditFormChange}
                                fullWidth
                                InputLabelProps={{ style: { color: textColor } }}
                                InputProps={{
                                  sx: { "& input:-webkit-autofill": {
                                      boxShadow: "0 0 0 100px #1A2035 inset",
                                      WebkitTextFillColor: "#fff",
                                    },
                                    color: textColor,
                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                  },
                                }}
                            />
                            {/*<TextField*/}
                            {/*    label="Address"*/}
                            {/*    name="address"*/}
                            {/*    variant="outlined"*/}
                            {/*    value={editFormData.address || ""}*/}
                            {/*    onChange={handleEditFormChange}*/}
                            {/*    fullWidth*/}
                            {/*    InputLabelProps={{ style: { color: textColor } }}*/}
                            {/*    InputProps={{*/}
                            {/*      sx: {*/}
                            {/*        "& input:-webkit-autofill": {*/}
                            {/*          boxShadow: "0 0 0 100px #1A2035 inset",*/}
                            {/*          WebkitTextFillColor: "#fff",*/}
                            {/*        },*/}
                            {/*        color: textColor,*/}
                            {/*        "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },*/}
                            {/*      },*/}
                            {/*    }}*/}
                            {/*/>*/}
                            <TextField
                                label="זמן האירוע"
                                name="dateTime"
                                type="datetime-local"
                                required
                                value={editFormData.dateTime || ""}
                                onChange={handleEditFormChange}
                                InputLabelProps={{ shrink: true, style: { color: textColor } }}
                                fullWidth
                                InputProps={{
                                  sx: {
                                    "& input:-webkit-autofill": {
                                      boxShadow: "0 0 0 100px #1A2035 inset",
                                      WebkitTextFillColor: "#fff",
                                    },
                                    color: textColor,
                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                  },
                                }}
                            />

                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TextField
                                label="תיאור האירוע"
                                name="event_description"
                                multiline
                                rows={6}
                                required
                                value={editFormData.event_description || ""}
                                onChange={handleEditFormChange}
                                fullWidth
                                sx={{ mt: 2 }}
                                InputLabelProps={{ style: { color: textColor } }}
                                InputProps={{
                                  sx: {
                                    "& input:-webkit-autofill": {
                                      boxShadow: "0 0 0 100px #1A2035 inset",
                                      WebkitTextFillColor: "#fff",
                                    },
                                    color: textColor,
                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                  },
                                }}
                            />
                            <TextField
                                label="תיאור הנזק"
                                name="damage_description"
                                multiline
                                rows={6}
                                value={editFormData.damage_description || ""}
                                onChange={handleEditFormChange}
                                fullWidth
                                InputLabelProps={{ style: { color: textColor } }}
                                InputProps={{
                                  sx: {
                                    "& input:-webkit-autofill": {
                                      boxShadow: "0 0 0 100px #1A2035 inset",
                                      WebkitTextFillColor: "#fff",
                                    },
                                    color: textColor,
                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: inputBorderColor },
                                  },
                                }}
                                sx={{ mt: 2 }}
                            />

                          </Grid>
                          {/* Right Column: Descriptions */}
                          <Grid item xs={12} sm={4}>
                            <TextField
                                label="סכום לתשלום"
                                name="payment_amount"
                                type="number"
                                value={editFormData.payment_amount}
                                onChange={handleEditFormChange}
                                fullWidth

                            />

                            <FormControl   fullWidth
                                           sx={{ mt: 2 }} variant="outlined">

                              <InputLabel
                                  fullWidth
                                  sx={{
                                    color: textColor,                     // default color
                                  }}
                                  id="event-type-label"
                              >
                                סוג אירוע
                              </InputLabel>
                              <Select
                                  value={editFormData?.event_type || ""}
                                  onChange={handleEditFormChange}
                                  displayEmpty
                                  label="סוג אירוע"
                                  name="event_type"
                                  style={{ textAlign: "left" }}
                                  sx={{height:44}}
                                  id="event-type-select"
                                  renderValue={(val) =>
                                      val
                                      && <span style={{ backgroundColor: getEventTypeColor(val, darkMode, "#27293d") }}>{val}</span>

                                  }
                              >
                                {eventTypeOptions.map((event) => (
                                    <MenuItem
                                        key={event}
                                        value={event} // Storing the entire object
                                        sx={{
                                          backgroundColor: getEventTypeColor(event, darkMode, "#27293d")
                                        }}
                                    >
                                      {event}
                                    </MenuItem>
                                ))}
                              </Select>
                            </FormControl>

                          </Grid>


                        </Grid>

                        <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                          <Button variant="outlined" onClick={() => { setShowEditModal(false); setEditFormData(null); }}>
                            בטל
                          </Button>
                          <Button   disabled={isDiscountInvalid} type="submit" variant="contained" color="primary">
                            שמור
                          </Button>
                        </Box>
                      </Box>
                  )}
                </Box>
              </Modal>
                <Dialog
                    open={freezePrompt.open}
                    onClose={() => setFreezePrompt(s => ({ ...s, open: false }))}
                    fullWidth
                    maxWidth="xs"
                >
                    <DialogTitle sx={{ backgroundColor: paperBg}}>
                        {freezePrompt.freeze
                            ? (freezePrompt.target === 'case' ? 'להקפיא תיק?' : 'להקפיא אירוע?')
                            : (freezePrompt.target === 'case' ? 'לבטל הקפאת תיק?' : 'לבטל הקפאת אירוע?')}
                    </DialogTitle>

                    <DialogContent sx={{ backgroundColor: paperBg}}>
                        <Typography variant="body2">
                            {freezePrompt.freeze
                                ? 'הסטטוס יעודכן ל״ראשוני״ ותת־הסטטוס ל״מוקפא״. להמשיך?'
                                : 'לבטל את הקפאת התיק? התיק יועבר לתת סטטוס טיפול מיידי'}
                        </Typography>
                    </DialogContent>

                    <DialogActions sx={{ backgroundColor: paperBg}}>
                        <Button onClick={() => setFreezePrompt(s => ({ ...s, open: false }))}>
                            ביטול
                        </Button>
                        <Button
                            // variant="contained"
                            color={freezePrompt.freeze ? 'warning' : 'primary'}
                            onClick={async () => {
                                try {
                                    if (freezePrompt.target === 'case') {
                                        const res = await apiFreezeCase(freezePrompt.id, freezePrompt.freeze);
                                        if (res) {
                                            applyCaseFreezeToState(
                                                setCasesMaster,
                                                freezePrompt.id,
                                                freezePrompt.freeze,
                                                {
                                                    main_status: res.case?.main_status,
                                                    sub_status:  res.case?.sub_status,
                                                }
                                            );
                                            applyCaseFreezeToState(
                                                setFilteredEvents,
                                                freezePrompt.id,
                                                freezePrompt.freeze,
                                                {
                                                    main_status: res.case?.main_status,
                                                    sub_status:  res.case?.sub_status,
                                                }
                                            );
                                        }
                                    } else {
                                        const res = await apiFreezeEvent(freezePrompt.id, freezePrompt.freeze);
                                        if (res) {
                                            applyEventFreezeToState(setCasesMaster, freezePrompt.id, freezePrompt.freeze);
                                            applyEventFreezeToState(setFilteredEvents, freezePrompt.id, freezePrompt.freeze);
                                        }
                                    }
                                } catch (e) {
                                    alert('פעולת ההקפאה נכשלה');
                                    console.error(e);
                                } finally {
                                    setFreezePrompt(s => ({ ...s, open: false }));
                                }
                            }}
                            autoFocus
                        >
                            {freezePrompt.freeze ? 'כן, הקפא' : 'כן, בטל הקפאה'}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openHuntDialog}
                    onClose={() => setOpenHuntDialog(false)}
                    maxWidth="xs"
                    fullWidth
                    // sx={{ backgroundColor: paperBg}}
                >
                    <DialogTitle sx={{ fontWeight: 700, textAlign: "center", backgroundColor: paperBg }}>
                        האם אתה בטוח?
                    </DialogTitle>

                    <DialogContent sx={{ textAlign: "center", backgroundColor: paperBg }}>
                        <Typography variant="body1" sx={{ mt: 1 }}>
                צא לצייד יחפש אירועים הקשורים למספר רכב הזה ובמידה וימצא יצרף אותם לתיק
                        </Typography>

                        <Typography variant="body2" color="error" sx={{ mt: 2, fontWeight: 600 }}>
                            הפעולה הזו לא ניתנת לביטול!
                        </Typography>
                    </DialogContent>

                    <DialogActions sx={{ justifyContent: "center", pb: 2, backgroundColor: paperBg }}>
                        <Button
                            variant="outlined"
                            onClick={() => setOpenHuntDialog(false)}
                        >
                            בטל
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={async () => {
                                if (!huntTarget) return;
                                await handleGoHunt({ original: huntTarget });
                                setOpenHuntDialog(false);
                            }}
                        >
                            צא לצוד
                        </Button>
                    </DialogActions>
                </Dialog>

              <Dialog open={payOpen} onClose={closePaymentDialog} fullWidth maxWidth="sm">
                <DialogTitle sx={{ backgroundColor: paperBg}}>שלח בקשת תשלום</DialogTitle>
                <DialogContent sx={{ backgroundColor: paperBg}}>
                  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 1 }}>
                    <TextField
                        required
                        label="שם לקוח"
                        name="clientName"
                        value={payForm.clientName}
                        onChange={onPayChange}
                        fullWidth
                    />
                    <TextField
                        required
                        label="טלפון לקוח"
                        name="clientPhone"
                        type="tel"                  // keep as string; preserves leading zero
                        value={payForm.clientPhone}
                        onChange={(e) => {
                          const digits = e.target.value.replace(/\D/g, '').slice(0, 10); // allow only 0-9, max 10
                          setPayForm(prev => ({ ...prev, clientPhone: digits }));
                        }}
                        onKeyDown={(e) => {         // optional extra guard while typing
                          const allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End'];
                          if (!/^\d$/.test(e.key) && !allowed.includes(e.key)) e.preventDefault();
                        }}
                        inputProps={{
                          inputMode: 'numeric',     // numeric keypad on mobile
                          pattern: '[0-9]*',
                          maxLength: 10             // adjust if you want to allow 9/10/11 digits
                        }}
                        fullWidth
                    />
                    <TextField
                        required
                        label="מספר תשלומים"
                        name="paymentsNumber"
                        type="number"
                        value={payForm.paymentsNumber}
                        onChange={onPayChange}
                        fullWidth
                        inputProps={{ min: 1, max: 18 }}
                        defaultValue={1}
                    />

                    <TextField
                        required
                        type="number"
                        inputProps={{ min: 1, step: '0.01' }}
                        label="סכום לתשלום (₪ כולל מע״מ)"
                        name="amount"
                        value={payForm.amount}
                        onChange={onPayChange}
                        fullWidth
                    />

                    {/*<TextField*/}
                    {/*    label="אימייל לקוח"*/}
                    {/*    name="clientEmail"*/}
                    {/*    value={payForm.clientEmail}*/}
                    {/*    onChange={onPayChange}*/}
                    {/*    fullWidth*/}
                    {/*/>*/}
                    <TextField
                        label="תעודת זהות"
                        name="clientId"
                        value={payForm.clientId}
                        onChange={onPayChange}
                        fullWidth
                    />
                      <Box sx={{ gridColumn: "1 / -1" }}>
                          <FormControlLabel
                              control={
                                  <Checkbox
                                      checked={attachFile}
                                      onChange={(e) => {
                                          const checked = e.target.checked;
                                          setAttachFile(checked);
                                          if (!checked) {
                                              setPaySelectedAttachment(null);
                                          }
                                      }}
                                  />
                              }
                              label="צרף קובץ"
                          />
                      </Box>

                      {/* file select directly UNDER the checkbox */}
                      {attachFile && (
                          <Box>
                              <Autocomplete
                                  options={payAttachmentOptions}
                                  value={paySelectedAttachment}
                                  onChange={(_, v) => setPaySelectedAttachment(v)}
                                  getOptionLabel={(o) => (o ? o.fileName : "")}
                                  renderInput={(params) => (
                                      <TextField
                                          {...params}
                                          label="צרף קובץ (חובה מכתב עורך דין חתום)"
                                          placeholder="בחר קובץ מהתיק/אירועים"
                                      />
                                  )}
                              />
                              {paySelectedAttachment && (
                                  <Typography variant="caption" sx={{ mt: 0.5 }}>
                                      יישלח יחד עם ההודעה: {paySelectedAttachment.fileName}
                                  </Typography>
                              )}
                          </Box>

                      )}
                  </Box>
                </DialogContent>
                <DialogActions sx={{ backgroundColor: paperBg}}>
                  <Button onClick={closePaymentDialog} disabled={paySubmitting}>ביטול</Button>
                  <Button
                      variant="contained"
                      onClick={async () => {
                        // basic validation
                        if (!payForm.clientName?.trim() || !payForm.clientPhone?.trim() || !payForm.amount) {
                          alert('יש למלא שם לקוח, טלפון וסכום');
                          return;
                        }
                        if (!Number(payForm.paymentsNumber) || payForm.paymentsNumber < 1 || payForm.paymentsNumber > 18) {
                          alert('מספר תשלומים לא תקין - חייב להיות בין 1 ל- 18');
                          return;
                        }

                        try {
                          setPaySubmitting(true);
                          const res = await fetch('https://blue-parking-invite.bluept.dev/api/payment-requests', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                              clientName: payForm.clientName.trim(),
                              clientPhone: payForm.clientPhone.trim(),
                              paymentsNumber: Number(payForm.paymentsNumber),
                              amount: Number(payForm.amount),           // ILS gross
                              clientEmail: payForm.clientEmail?.trim() || '',
                              clientId: payForm.clientId?.trim() || '',
                              carId: payForm.carId || '',
                              attachment: paySelectedAttachment ? {
                                url: paySelectedAttachment.url,
                                fileName: paySelectedAttachment.fileName,
                                type: paySelectedAttachment.type || ''
                              } : null
                                ,
                                caseId: payForm.caseId,
                                userEmail,
                                userName,
                            })
                          });
                          const json = await res.json();
                          if (!res.ok) {
                            throw new Error(json?.error || `HTTP ${res.status}`);
                          }
                          alert('בקשת תשלום נשלחה בהצלחה');
                          closePaymentDialog();
                        } catch (e) {
                          console.error(e);
                          alert(`נכשל בשליחה: ${e.message}`);
                          setPaySubmitting(false);
                        }
                      }}
                      disabled={
                          attachFile
                              ? (paySubmitting || !hasSignedAttachment)
                              : paySubmitting
                      }

                  >
                    {paySubmitting ? 'שולח…' : 'שלח'}
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                  open={showFilesModal}
                  onClose={() => setShowFilesModal(false)}
                  fullWidth
                  maxWidth="md"
              >
                <DialogTitle sx={{ backgroundColor: paperBg}}>קבצים</DialogTitle>
                <DialogContent dividers sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '260px 1fr' }, gap: 2 ,  backgroundColor: paperBg}}>
                  {/* Left: list */}
                  <Box sx={{ minHeight: 520 }}>
                    <List dense sx={{ maxHeight: 520, overflowY: 'auto', borderRight: { md: '1px solid rgba(0,0,0,0.12)' } }}>
                      {filesModalItems.map((att, i) => (
                          <ListItemButton
                              key={`${att.url}-${i}`}
                              selected={activeAttachment?.url === att.url}
                              onClick={() => setActiveAttachment(att)}
                          >
                            <ListItemText
                                primary={att.fileName || att.name || 'file'}
                                secondary={att.type}
                                primaryTypographyProps={{ noWrap: true }}
                                secondaryTypographyProps={{ noWrap: true, color: textColor }}
                            />
                          </ListItemButton>
                      ))}
                    </List>
                  </Box>

                  {/* Right: preview */}
                  <Box sx={{ minHeight: 520 }}>
                    {activeAttachment ? (
                        <>
                          <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            {activeAttachment.fileName || activeAttachment.name}
                          </Typography>
                          <Divider sx={{ mb: 1 }} />
                          <RenderAttachmentInline att={activeAttachment} />
                        </>
                    ) : (
                        <Typography variant="body2" sx={{ opacity: 0.8 }}>No file selected.</Typography>
                    )}
                  </Box>
                </DialogContent>

                <DialogActions sx={{ backgroundColor: paperBg}}>
                  {activeAttachment && (
                      <Button onClick={() => window.open(activeAttachment.url, '_blank')}>
                        הורדה
                      </Button>
                  )}
                  <Button onClick={() => setShowFilesModal(false)}>סגירה</Button>
                </DialogActions>
              </Dialog>

              <Dialog
                  open={showSignDialog}
                  onClose={closeSignDialog}
                  fullWidth
                  maxWidth="md"
              >
                <DialogTitle sx={{ bgcolor: paperBg, color: textColor }}>
                  חתימה על מסמך PDF
                </DialogTitle>

                <DialogContent
                    sx={{
                      bgcolor: paperBg,
                      color: textColor,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                >
                  {/* left: original doc preview */}
                  <Box sx={{ display: "flex", flexDirection: "row", gap: 2, flexWrap: "wrap" }}>
                    <Box sx={{ flex: 1, minWidth: 300 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, color: textColor }}>
                        מסמך מקורי
                      </Typography>
                      {pdfToSign && (
                          <iframe
                              title="original-pdf"
                              src={pdfToSign.url}
                              style={{ width: "100%", height: 300, border: 0, backgroundColor: "#fff" }}
                          />
                      )}
                    </Box>

                    {/* right: signature pad + preview of result */}
                    <Box sx={{ flex: 1, minWidth: 300 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, color: textColor }}>
                        החתימה שלך
                      </Typography>

                      {/* Signature pad */}
                      <Box
                          sx={{
                            border: `1px solid ${inputBorderColor}`,
                            borderRadius: 1,
                            backgroundColor: "#fff",
                            width: "100%",
                            height: 150,
                          }}
                      >
                        {/* You'll need react-signature-canvas */}
                        <SignatureCanvas
                            ref={sigPadRef}
                            penColor="black"
                            backgroundColor="rgba(0,0,0,0)"
                            canvasProps={{
                              style: {
                                width: "100%",
                                height: "150px",
                              },
                            }}
                        />
                      </Box>

                      <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={() => sigPadRef.current?.clear()}
                        >
                          נקה
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            disabled={signing}
                            onClick={handleGenerateSignedPdf}
                        >
                          {signing ? "מייצר..." : "שמור חתימה על המסמך"}
                        </Button>
                      </Box>

                      {signedPreviewUrl && (
                          <>
                            <Typography variant="subtitle2" sx={{ mt: 2, color: textColor }}>
                              תצוגה אחרי חתימה
                            </Typography>
                            <iframe
                                title="signed-preview"
                                src={signedPreviewUrl}
                                style={{ width: "100%", height: 200, border: 0, backgroundColor: "#fff" }}
                            />
                          </>
                      )}
                    </Box>
                  </Box>
                </DialogContent>

                <DialogActions sx={{ bgcolor: paperBg }}>
                  <Button onClick={closeSignDialog}>ביטול</Button>
                  <Button
                      onClick={() => {
                        if (caseForm && caseForm.case_id) {
                          handleAttachSignedPdfToCase();
                        } else if (activeAttachment) {
                          // we’re in preview modal, not in edit modal.
                          // we need to know which case this attachment belongs to.
                          // activeAttachment does NOT tell us the case_id by itself,
                          // so you’ll need to pass the parent case row into openFilesModal().
                          // For now let's assume you store it in something like caseFormBeforeOpen or selectedCaseIdForPreview.
                          uploadSignedPdfDirect(preivewCaseId);
                        } else {
                          alert("לא נמצא תיק יעד");
                        }
                      }}
                      disabled={!signedBlob}
                      variant="contained"
                  >
                    להוסיף לתיק
                  </Button>
                </DialogActions>
              </Dialog>

              <Modal open={showMediaModal} onClose={handleCloseMediaModal}>
                <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      backgroundColor: paperBg,
                      color: textColor,
                      p: 2,
                      borderRadius: 2,
                      width: "80%",
                      maxWidth: 800,
                      textAlign: "center",
                    }}
                >
                  {mediaPreview.type?.includes("image") && (
                      <img
                          src={mediaPreview.url}
                          alt="Preview"
                          style={{ maxWidth: "100%", maxHeight: "80vh" }}
                      />
                  )}

                  {mediaPreview.type?.includes("video") && (
                      <video
                          src={mediaPreview.url}
                          controls
                          style={{ maxWidth: "100%", maxHeight: "80vh" }}
                      />
                  )}

                  <Box mt={2}>
                    <Button onClick={handleCloseMediaModal} variant="contained" color="secondary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </Box>}
      </DashboardLayout>
  )
};

export default GodsBlueEye;
